/*! Patched added guards to click/mouseleave, function n, May 21 2025 */
/*! For license information please see endrock.scripts.js.LICENSE.txt */
(() => {
  "use strict";
  var e = {
      60: (e, t, s) => {
        function i(e) {
          return (
            (i =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  }),
            i(e)
          );
        }
        function r() {
          r = function () {
            return t;
          };
          var e,
            t = {},
            s = Object.prototype,
            a = s.hasOwnProperty,
            n =
              Object.defineProperty ||
              function (e, t, s) {
                e[t] = s.value;
              },
            o = "function" == typeof Symbol ? Symbol : {},
            l = o.iterator || "@@iterator",
            d = o.asyncIterator || "@@asyncIterator",
            c = o.toStringTag || "@@toStringTag";
          function p(e, t, s) {
            return (
              Object.defineProperty(e, t, {
                value: s,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              }),
              e[t]
            );
          }
          try {
            p({}, "");
          } catch (e) {
            p = function (e, t, s) {
              return (e[t] = s);
            };
          }
          function u(e, t, s, i) {
            var r = t && t.prototype instanceof y ? t : y,
              a = Object.create(r.prototype),
              o = new I(i || []);
            return n(a, "_invoke", { value: P(e, s, o) }), a;
          }
          function m(e, t, s) {
            try {
              return { type: "normal", arg: e.call(t, s) };
            } catch (e) {
              return { type: "throw", arg: e };
            }
          }
          t.wrap = u;
          var f = "suspendedStart",
            h = "suspendedYield",
            v = "executing",
            g = "completed",
            w = {};
          function y() {}
          function b() {}
          function E() {}
          var x = {};
          p(x, l, function () {
            return this;
          });
          var S = Object.getPrototypeOf,
            T = S && S(S(O([])));
          T && T !== s && a.call(T, l) && (x = T);
          var M = (E.prototype = y.prototype = Object.create(x));
          function C(e) {
            ["next", "throw", "return"].forEach(function (t) {
              p(e, t, function (e) {
                return this._invoke(t, e);
              });
            });
          }
          function L(e, t) {
            function s(r, n, o, l) {
              var d = m(e[r], e, n);
              if ("throw" !== d.type) {
                var c = d.arg,
                  p = c.value;
                return p && "object" == i(p) && a.call(p, "__await")
                  ? t.resolve(p.__await).then(
                      function (e) {
                        s("next", e, o, l);
                      },
                      function (e) {
                        s("throw", e, o, l);
                      }
                    )
                  : t.resolve(p).then(
                      function (e) {
                        (c.value = e), o(c);
                      },
                      function (e) {
                        return s("throw", e, o, l);
                      }
                    );
              }
              l(d.arg);
            }
            var r;
            n(this, "_invoke", {
              value: function (e, i) {
                function a() {
                  return new t(function (t, r) {
                    s(e, i, t, r);
                  });
                }
                return (r = r ? r.then(a, a) : a());
              },
            });
          }
          function P(t, s, i) {
            var r = f;
            return function (a, n) {
              if (r === v) throw Error("Generator is already running");
              if (r === g) {
                if ("throw" === a) throw n;
                return { value: e, done: !0 };
              }
              for (i.method = a, i.arg = n; ; ) {
                var o = i.delegate;
                if (o) {
                  var l = k(o, i);
                  if (l) {
                    if (l === w) continue;
                    return l;
                  }
                }
                if ("next" === i.method) i.sent = i._sent = i.arg;
                else if ("throw" === i.method) {
                  if (r === f) throw ((r = g), i.arg);
                  i.dispatchException(i.arg);
                } else "return" === i.method && i.abrupt("return", i.arg);
                r = v;
                var d = m(t, s, i);
                if ("normal" === d.type) {
                  if (((r = i.done ? g : h), d.arg === w)) continue;
                  return { value: d.arg, done: i.done };
                }
                "throw" === d.type &&
                  ((r = g), (i.method = "throw"), (i.arg = d.arg));
              }
            };
          }
          function k(t, s) {
            var i = s.method,
              r = t.iterator[i];
            if (r === e)
              return (
                (s.delegate = null),
                ("throw" === i &&
                  t.iterator.return &&
                  ((s.method = "return"),
                  (s.arg = e),
                  k(t, s),
                  "throw" === s.method)) ||
                  ("return" !== i &&
                    ((s.method = "throw"),
                    (s.arg = new TypeError(
                      "The iterator does not provide a '" + i + "' method"
                    )))),
                w
              );
            var a = m(r, t.iterator, s.arg);
            if ("throw" === a.type)
              return (
                (s.method = "throw"), (s.arg = a.arg), (s.delegate = null), w
              );
            var n = a.arg;
            return n
              ? n.done
                ? ((s[t.resultName] = n.value),
                  (s.next = t.nextLoc),
                  "return" !== s.method && ((s.method = "next"), (s.arg = e)),
                  (s.delegate = null),
                  w)
                : n
              : ((s.method = "throw"),
                (s.arg = new TypeError("iterator result is not an object")),
                (s.delegate = null),
                w);
          }
          function A(e) {
            var t = { tryLoc: e[0] };
            1 in e && (t.catchLoc = e[1]),
              2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
              this.tryEntries.push(t);
          }
          function z(e) {
            var t = e.completion || {};
            (t.type = "normal"), delete t.arg, (e.completion = t);
          }
          function I(e) {
            (this.tryEntries = [{ tryLoc: "root" }]),
              e.forEach(A, this),
              this.reset(!0);
          }
          function O(t) {
            if (t || "" === t) {
              var s = t[l];
              if (s) return s.call(t);
              if ("function" == typeof t.next) return t;
              if (!isNaN(t.length)) {
                var r = -1,
                  n = function s() {
                    for (; ++r < t.length; )
                      if (a.call(t, r))
                        return (s.value = t[r]), (s.done = !1), s;
                    return (s.value = e), (s.done = !0), s;
                  };
                return (n.next = n);
              }
            }
            throw new TypeError(i(t) + " is not iterable");
          }
          return (
            (b.prototype = E),
            n(M, "constructor", { value: E, configurable: !0 }),
            n(E, "constructor", { value: b, configurable: !0 }),
            (b.displayName = p(E, c, "GeneratorFunction")),
            (t.isGeneratorFunction = function (e) {
              var t = "function" == typeof e && e.constructor;
              return (
                !!t &&
                (t === b || "GeneratorFunction" === (t.displayName || t.name))
              );
            }),
            (t.mark = function (e) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(e, E)
                  : ((e.__proto__ = E), p(e, c, "GeneratorFunction")),
                (e.prototype = Object.create(M)),
                e
              );
            }),
            (t.awrap = function (e) {
              return { __await: e };
            }),
            C(L.prototype),
            p(L.prototype, d, function () {
              return this;
            }),
            (t.AsyncIterator = L),
            (t.async = function (e, s, i, r, a) {
              void 0 === a && (a = Promise);
              var n = new L(u(e, s, i, r), a);
              return t.isGeneratorFunction(s)
                ? n
                : n.next().then(function (e) {
                    return e.done ? e.value : n.next();
                  });
            }),
            C(M),
            p(M, c, "Generator"),
            p(M, l, function () {
              return this;
            }),
            p(M, "toString", function () {
              return "[object Generator]";
            }),
            (t.keys = function (e) {
              var t = Object(e),
                s = [];
              for (var i in t) s.push(i);
              return (
                s.reverse(),
                function e() {
                  for (; s.length; ) {
                    var i = s.pop();
                    if (i in t) return (e.value = i), (e.done = !1), e;
                  }
                  return (e.done = !0), e;
                }
              );
            }),
            (t.values = O),
            (I.prototype = {
              constructor: I,
              reset: function (t) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = e),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = e),
                  this.tryEntries.forEach(z),
                  !t)
                )
                  for (var s in this)
                    "t" === s.charAt(0) &&
                      a.call(this, s) &&
                      !isNaN(+s.slice(1)) &&
                      (this[s] = e);
              },
              stop: function () {
                this.done = !0;
                var e = this.tryEntries[0].completion;
                if ("throw" === e.type) throw e.arg;
                return this.rval;
              },
              dispatchException: function (t) {
                if (this.done) throw t;
                var s = this;
                function i(i, r) {
                  return (
                    (o.type = "throw"),
                    (o.arg = t),
                    (s.next = i),
                    r && ((s.method = "next"), (s.arg = e)),
                    !!r
                  );
                }
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var n = this.tryEntries[r],
                    o = n.completion;
                  if ("root" === n.tryLoc) return i("end");
                  if (n.tryLoc <= this.prev) {
                    var l = a.call(n, "catchLoc"),
                      d = a.call(n, "finallyLoc");
                    if (l && d) {
                      if (this.prev < n.catchLoc) return i(n.catchLoc, !0);
                      if (this.prev < n.finallyLoc) return i(n.finallyLoc);
                    } else if (l) {
                      if (this.prev < n.catchLoc) return i(n.catchLoc, !0);
                    } else {
                      if (!d)
                        throw Error("try statement without catch or finally");
                      if (this.prev < n.finallyLoc) return i(n.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function (e, t) {
                for (var s = this.tryEntries.length - 1; s >= 0; --s) {
                  var i = this.tryEntries[s];
                  if (
                    i.tryLoc <= this.prev &&
                    a.call(i, "finallyLoc") &&
                    this.prev < i.finallyLoc
                  ) {
                    var r = i;
                    break;
                  }
                }
                r &&
                  ("break" === e || "continue" === e) &&
                  r.tryLoc <= t &&
                  t <= r.finallyLoc &&
                  (r = null);
                var n = r ? r.completion : {};
                return (
                  (n.type = e),
                  (n.arg = t),
                  r
                    ? ((this.method = "next"), (this.next = r.finallyLoc), w)
                    : this.complete(n)
                );
              },
              complete: function (e, t) {
                if ("throw" === e.type) throw e.arg;
                return (
                  "break" === e.type || "continue" === e.type
                    ? (this.next = e.arg)
                    : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                  w
                );
              },
              finish: function (e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var s = this.tryEntries[t];
                  if (s.finallyLoc === e)
                    return this.complete(s.completion, s.afterLoc), z(s), w;
                }
              },
              catch: function (e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var s = this.tryEntries[t];
                  if (s.tryLoc === e) {
                    var i = s.completion;
                    if ("throw" === i.type) {
                      var r = i.arg;
                      z(s);
                    }
                    return r;
                  }
                }
                throw Error("illegal catch attempt");
              },
              delegateYield: function (t, s, i) {
                return (
                  (this.delegate = {
                    iterator: O(t),
                    resultName: s,
                    nextLoc: i,
                  }),
                  "next" === this.method && (this.arg = e),
                  w
                );
              },
            }),
            t
          );
        }
        function a(e, t, s, i, r, a, n) {
          try {
            var o = e[a](n),
              l = o.value;
          } catch (e) {
            return void s(e);
          }
          o.done ? t(l) : Promise.resolve(l).then(i, r);
        }
        s.d(t, { _: () => n });
        var n = (function () {
            var e,
              t =
                ((e = r().mark(function e(t) {
                  var s, i, a, n;
                  return r().wrap(
                    function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            if (!(s = t.target.closest("form"))) {
                              e.next = 20;
                              break;
                            }
                            if (
                              !(i = s.querySelector("input[name='id']").value)
                            ) {
                              e.next = 20;
                              break;
                            }
                            return (
                              (a = t.currentTarget),
                              (n = { items: [{ id: i, quantity: 1 }] }),
                              a.setAttribute("disabled", "disabled"),
                              (e.prev = 7),
                              (e.next = 10),
                              fetch(
                                window.Shopify.routes.root + "cart/add.js",
                                {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                  },
                                  body: JSON.stringify(n),
                                }
                              )
                            );
                          case 10:
                            return (e.next = 12), l();
                          case 12:
                            return (
                              a.removeAttribute("disabled"), (e.next = 15), o()
                            );
                          case 15:
                            e.next = 20;
                            break;
                          case 17:
                            (e.prev = 17),
                              (e.t0 = e.catch(7)),
                              console.log("error add to cart ", e.t0);
                          case 20:
                          case "end":
                            return e.stop();
                        }
                    },
                    e,
                    null,
                    [[7, 17]]
                  );
                })),
                function () {
                  var t = this,
                    s = arguments;
                  return new Promise(function (i, r) {
                    var n = e.apply(t, s);
                    function o(e) {
                      a(n, i, r, o, l, "next", e);
                    }
                    function l(e) {
                      a(n, i, r, o, l, "throw", e);
                    }
                    o(void 0);
                  });
                });
            return function (e) {
              return t.apply(this, arguments);
            };
          })(),
          o = function () {
            return new Promise(function (e) {
              document.querySelector(".cart-link__icon").click();
            });
          },
          l = function () {
            return new Promise(function (e) {
              document.documentElement.dispatchEvent(
                new CustomEvent("on:cart:change", {
                  bubbles: !0,
                  cancelable: !1,
                })
              ),
                setTimeout(function () {
                  e();
                }, 700);
            });
          };
      },
      209: (e, t, s) => {
        s.d(t, { Z: () => a, g: () => c });
        var i = s(60);
        var r = s(37),
          a = function () {
            var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : null,
              t = ".add_to_cart_plp:not(.button--sold-out)";
            (e ? e.querySelectorAll(t) : document.querySelectorAll(t)).forEach(
              function (e) {
                e.addEventListener("click", function (t) { if(!t||!e)return;
                  t.preventDefault(), n(e);
                });
              }
            );
          },
          n = function (e) {
            var t = document.querySelector(".tabs-collections");
            if (o(e)) e.classList.add("mobile-hidden");
            else if (
              ((0, i._)(event), l(event), window.screen.width <= 992 && t)
            ) {
              for (
                var s = document.querySelector(".product-block__backdrop"),
                  r = e
                    .closest(".tabs-collections__content")
                    .querySelector("#tabs-sizes-container"),
                  a = document.getElementById(
                    window.sizeContainer.getAttribute("id")
                  );
                r.firstChild;

              )
                a.appendChild(r.firstChild);
              (s.style.display = "none"),
                document.body.classList.remove("body-no-scroll"),
                r.classList.remove("active"),
                (window.sizeContainer = null);
            }
          },
          o = function (e) {
            return (
              window.screen.width <= 992 &&
              !e.closest(".sizes-container__forms") &&
              e.classList.contains("with-sizes") &&
              !e.classList.contains("sizes") &&
              !e.classList.contains("btn-no-sizes")
            );
          },
          l = function (e) {
            var t = e.target.closest(".product-block__sizes-container");
            if (t) {
              var s = t.previousElementSibling;
              s && s.classList.contains("product-block__backdrop") && d(t, s);
            }
          },
          d = function (e, t) {
            e &&
              t &&
              (e.classList.remove("active"),
              document.body.classList.remove("body-no-scroll"),
              (t.style.display = "none"));
          },
          c = function () {
            var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : null,
              t = window.screen.width >= 768,
              s = t ? ".image-cont .sizes-container" : "product-block";
            if (t) {
              var i = e ? e.querySelectorAll(s) : document.querySelectorAll(s);
              p(i);
            } else {
              var a = document.querySelectorAll(".tabs-collections");
              if (a && a.length > 0) (0, r.ss)(a);
              else {
                var n = e || document.querySelectorAll("product-block");
                h(n);
              }
            }
          },
          p = function (e) {
            e.forEach(function (e) {
              var t = e.querySelector(".sizes-container__forms"),
                s = e.querySelector(
                  ".add_to_cart_plp:not(.sizes):not(.button--sold-out)"
                );
              u(s, t), m(e, t, s);
            });
          },
          u = function (e, t) {
            e &&
              t &&
              e.addEventListener("click", function (s) {
                s.preventDefault(),
                  (t.style.display = "flex"),
                  (t.style.flexWrap = "wrap"),
                  (t.style.justifyContent = "flex-start"),
                  t.parentElement.classList.add("bottom-move-container"),
                  (e.style.display = "none");
              });
          },
          m = function (e, t, s) {
            e.addEventListener("mouseleave", function () { if(!t||!s)return;
              t &&
                s &&
                ((t.style.display = "none"),
                t.parentElement.classList.remove("bottom-move-container"),
                (s.style.display = "flex"));
            });
          },
          f = function (e) {
            if (e) {
              var t = e.querySelector(".product-block__sizes-container"),
                s = e.querySelector(
                  ".image-cont .sizes-container .add_to_cart_plp:not(.sizes):not(.button--sold-out)"
                ),
                i = e.querySelector(".product-block__backdrop");
              !(function (e, t, s) {
                e &&
                  t &&
                  s &&
                  e.addEventListener("click", function (e) {
                    e.preventDefault(),
                      t.classList.add("active"),
                      document.body.classList.add("body-no-scroll"),
                      (s.style.display = "block");
                  });
              })(s, t, i),
                (function (e, t) {
                  e &&
                    t &&
                    e.addEventListener("click", function () {
                      d(t, e);
                    });
                })(i, t);
            }
          },
          h = function (e) {
            if (e.length)
              e.forEach(function (e) {
                f(e);
              });
            else {
              var t = document.querySelectorAll("product-block");
              t.length && f(t);
            }
          };
        window.addEventListener("DOMContentLoaded", function () {
          !(function () {
            var e = document.querySelector(
                ".collection-carousel__button--prev"
              ),
              t = document.querySelector(".collection-carousel__button--next"),
              s = document.querySelector(".collection-carousel__cards-wrapper"),
              i = document.querySelector(".collection-carousel__cards"),
              r = document.querySelector(
                ".collection-carousel .collection-carousel__container"
              ),
              a = document.querySelector(".collection-carousel");
            function n() { if(!e||!t)return;
              var r = s.offsetWidth,
                a = i.scrollWidth,
                n = s.scrollLeft;
              a > r
                ? ((e.style.display = 0 === n ? "none" : "block"),
                  (t.style.display = n + r >= a ? "none" : "block"))
                : ((t.style.display = "none"), (e.style.display = "none"));
            }
            "none" !== window.getComputedStyle(a).display &&
              r.childElementCount > 0 &&
              ((document.querySelector(
                ".page-header .container .pagetitle"
              ).style.display = "none"),
              (document.querySelector(".page-header").style.marginTop = "0"),
              (document.querySelector(
                ".main-collection-section .utility-bar"
              ).style.borderTop = "1px solid #E2E2E2"),
              (document.querySelector(
                ".main-collection-section .utility-bar"
              ).style.paddingTop = "20px")),
              n(),
              window.addEventListener("resize", n),
              s.addEventListener("scroll", n),
              e.addEventListener("click", function () {
                s.scrollBy({ left: -256, behavior: "smooth" });
              }),
              t.addEventListener("click", function () {
                s.scrollBy({ left: 256, behavior: "smooth" });
              });
          })();
        });
      },
      37: (e, t, s) => {
        s.d(t, { K5: () => i, ss: () => a });
        var i = function () {
            var e = document.querySelectorAll(".tabs-collections__tab"),
              t = document.querySelectorAll(".tabs-collections__collection");
            e.length &&
              (setTimeout(function () {
                if (
                  (t.forEach(function (e, t) {
                    0 != t && e.classList.add("visually-hidden");
                  }),
                  document.querySelector(".tabs-collections__tabs"))
                ) {
                  var e = document.querySelectorAll(".tabs-collections__tabs"),
                    s = document.querySelectorAll(".tabs-collections__content"),
                    i = document.querySelectorAll(".div-spiner-content");
                  e.forEach(function (e) {
                    e.style.display = "flex";
                  }),
                    s.forEach(function (e) {
                      e.style.display = "block";
                    }),
                    i.forEach(function (e) {
                      e.remove();
                    });
                }
              }, 500),
              e.forEach(function (s) {
                s.addEventListener("click", function () {
                  var i = s.getAttribute("data-linkid"),
                    r = document.querySelector(
                      ".tabs-collections__collection#".concat(i)
                    );
                  e.forEach(function (e) {
                    return e.classList.remove("active");
                  }),
                    t.forEach(function (e) {
                      return e.classList.add("visually-hidden");
                    }),
                    s.classList.add("active"),
                    r.classList.remove("visually-hidden");
                });
              }));
          },
          r = function (e, t) {
            e &&
              t &&
              e.forEach(function (e) {
                e.addEventListener("click", function (e) {
                  e.preventDefault();
                  var s = e.target,
                    i = document.getElementById("tabs-sizes-container"),
                    r = s
                      .closest(".block-inner-inner")
                      .querySelector(".product-block__sizes-container");
                  (window.sizeContainer = r),
                    r &&
                      i &&
                      ((function (e, t, s) {
                        if (!s.classList.contains("active"))
                          for (s.classList.add("active"); t.firstChild; )
                            s.appendChild(t.firstChild);
                        (e.style.display = "block"),
                          document.body.classList.add("body-no-scroll");
                      })(t, r, i),
                      (function (e, t) {
                        e &&
                          e.addEventListener("click", function () {
                            for (
                              var s = document.getElementById(
                                window.sizeContainer.getAttribute("id")
                              );
                              t.firstChild;

                            )
                              s.appendChild(t.firstChild);
                            (e.style.display = "none"),
                              document.body.classList.remove("body-no-scroll"),
                              t.classList.remove("active"),
                              (window.sizeContainer = null);
                          });
                      })(t, i));
                });
              });
          },
          a = function (e) {
            e.forEach(function (e) {
              e.querySelectorAll(".tabs-collections_slider").forEach(function (
                t
              ) {
                var s = t.querySelectorAll(
                    ".image-cont .sizes-container .add_to_cart_plp:not(.sizes):not(.button--sold-out)"
                  ),
                  i = e.querySelector(".product-block__backdrop");
                r(s, i);
              });
            });
          };
      },
    },
    t = {};
  function s(i) {
    var r = t[i];
    if (void 0 !== r) return r.exports;
    var a = (t[i] = { exports: {} });
    return e[i](a, a.exports, s), a.exports;
  }
  function i(e) {
    return (
      null !== e &&
      "object" == typeof e &&
      "constructor" in e &&
      e.constructor === Object
    );
  }
  function r(e, t) {
    void 0 === e && (e = {}),
      void 0 === t && (t = {}),
      Object.keys(t).forEach((s) => {
        void 0 === e[s]
          ? (e[s] = t[s])
          : i(t[s]) && i(e[s]) && Object.keys(t[s]).length > 0 && r(e[s], t[s]);
      });
  }
  (s.d = (e, t) => {
    for (var i in t)
      s.o(t, i) &&
        !s.o(e, i) &&
        Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
  }),
    (s.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t));
  const a = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: { blur() {}, nodeName: "" },
    querySelector: () => null,
    querySelectorAll: () => [],
    getElementById: () => null,
    createEvent: () => ({ initEvent() {} }),
    createElement: () => ({
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName: () => [],
    }),
    createElementNS: () => ({}),
    importNode: () => null,
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
  };
  function n() {
    const e = "undefined" != typeof document ? document : {};
    return r(e, a), e;
  }
  const o = {
    document: a,
    navigator: { userAgent: "" },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
    CustomEvent: function () {
      return this;
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle: () => ({ getPropertyValue: () => "" }),
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia: () => ({}),
    requestAnimationFrame: (e) =>
      "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
    cancelAnimationFrame(e) {
      "undefined" != typeof setTimeout && clearTimeout(e);
    },
  };
  function l() {
    const e = "undefined" != typeof window ? window : {};
    return r(e, o), e;
  }
  function d(e) {
    return (
      void 0 === e && (e = ""),
      e
        .trim()
        .split(" ")
        .filter((e) => !!e.trim())
    );
  }
  function c(e, t) {
    return void 0 === t && (t = 0), setTimeout(e, t);
  }
  function p() {
    return Date.now();
  }
  function u(e, t) {
    void 0 === t && (t = "x");
    const s = l();
    let i, r, a;
    const n = (function (e) {
      const t = l();
      let s;
      return (
        t.getComputedStyle && (s = t.getComputedStyle(e, null)),
        !s && e.currentStyle && (s = e.currentStyle),
        s || (s = e.style),
        s
      );
    })(e);
    return (
      s.WebKitCSSMatrix
        ? ((r = n.transform || n.webkitTransform),
          r.split(",").length > 6 &&
            (r = r
              .split(", ")
              .map((e) => e.replace(",", "."))
              .join(", ")),
          (a = new s.WebKitCSSMatrix("none" === r ? "" : r)))
        : ((a =
            n.MozTransform ||
            n.OTransform ||
            n.MsTransform ||
            n.msTransform ||
            n.transform ||
            n
              .getPropertyValue("transform")
              .replace("translate(", "matrix(1, 0, 0, 1,")),
          (i = a.toString().split(","))),
      "x" === t &&
        (r = s.WebKitCSSMatrix
          ? a.m41
          : 16 === i.length
          ? parseFloat(i[12])
          : parseFloat(i[4])),
      "y" === t &&
        (r = s.WebKitCSSMatrix
          ? a.m42
          : 16 === i.length
          ? parseFloat(i[13])
          : parseFloat(i[5])),
      r || 0
    );
  }
  function m(e) {
    return (
      "object" == typeof e &&
      null !== e &&
      e.constructor &&
      "Object" === Object.prototype.toString.call(e).slice(8, -1)
    );
  }
  function f() {
    const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
      t = ["__proto__", "constructor", "prototype"];
    for (let i = 1; i < arguments.length; i += 1) {
      const r = i < 0 || arguments.length <= i ? void 0 : arguments[i];
      if (
        null != r &&
        ((s = r),
        !("undefined" != typeof window && void 0 !== window.HTMLElement
          ? s instanceof HTMLElement
          : s && (1 === s.nodeType || 11 === s.nodeType)))
      ) {
        const s = Object.keys(Object(r)).filter((e) => t.indexOf(e) < 0);
        for (let t = 0, i = s.length; t < i; t += 1) {
          const i = s[t],
            a = Object.getOwnPropertyDescriptor(r, i);
          void 0 !== a &&
            a.enumerable &&
            (m(e[i]) && m(r[i])
              ? r[i].__swiper__
                ? (e[i] = r[i])
                : f(e[i], r[i])
              : !m(e[i]) && m(r[i])
              ? ((e[i] = {}), r[i].__swiper__ ? (e[i] = r[i]) : f(e[i], r[i]))
              : (e[i] = r[i]));
        }
      }
    }
    var s;
    return e;
  }
  function h(e, t, s) {
    e.style.setProperty(t, s);
  }
  function v(e) {
    let { swiper: t, targetPosition: s, side: i } = e;
    const r = l(),
      a = -t.translate;
    let n,
      o = null;
    const d = t.params.speed;
    (t.wrapperEl.style.scrollSnapType = "none"),
      r.cancelAnimationFrame(t.cssModeFrameID);
    const c = s > a ? "next" : "prev",
      p = (e, t) => ("next" === c && e >= t) || ("prev" === c && e <= t),
      u = () => {
        (n = new Date().getTime()), null === o && (o = n);
        const e = Math.max(Math.min((n - o) / d, 1), 0),
          l = 0.5 - Math.cos(e * Math.PI) / 2;
        let c = a + l * (s - a);
        if ((p(c, s) && (c = s), t.wrapperEl.scrollTo({ [i]: c }), p(c, s)))
          return (
            (t.wrapperEl.style.overflow = "hidden"),
            (t.wrapperEl.style.scrollSnapType = ""),
            setTimeout(() => {
              (t.wrapperEl.style.overflow = ""),
                t.wrapperEl.scrollTo({ [i]: c });
            }),
            void r.cancelAnimationFrame(t.cssModeFrameID)
          );
        t.cssModeFrameID = r.requestAnimationFrame(u);
      };
    u();
  }
  function g(e) {
    return (
      e.querySelector(".swiper-slide-transform") ||
      (e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform")) ||
      e
    );
  }
  function w(e, t) {
    void 0 === t && (t = "");
    const s = [...e.children];
    return (
      e instanceof HTMLSlotElement && s.push(...e.assignedElements()),
      t ? s.filter((e) => e.matches(t)) : s
    );
  }
  function y(e) {
    try {
      return void console.warn(e);
    } catch (e) {}
  }
  function b(e, t) {
    void 0 === t && (t = []);
    const s = document.createElement(e);
    return s.classList.add(...(Array.isArray(t) ? t : d(t))), s;
  }
  function E(e) {
    const t = l(),
      s = n(),
      i = e.getBoundingClientRect(),
      r = s.body,
      a = e.clientTop || r.clientTop || 0,
      o = e.clientLeft || r.clientLeft || 0,
      d = e === t ? t.scrollY : e.scrollTop,
      c = e === t ? t.scrollX : e.scrollLeft;
    return { top: i.top + d - a, left: i.left + c - o };
  }
  function x(e, t) {
    return l().getComputedStyle(e, null).getPropertyValue(t);
  }
  function S(e) {
    let t,
      s = e;
    if (s) {
      for (t = 0; null !== (s = s.previousSibling); )
        1 === s.nodeType && (t += 1);
      return t;
    }
  }
  function T(e, t) {
    const s = [];
    let i = e.parentElement;
    for (; i; )
      t ? i.matches(t) && s.push(i) : s.push(i), (i = i.parentElement);
    return s;
  }
  function M(e, t) {
    t &&
      e.addEventListener("transitionend", function s(i) {
        i.target === e &&
          (t.call(e, i), e.removeEventListener("transitionend", s));
      });
  }
  function C(e, t, s) {
    const i = l();
    return s
      ? e["width" === t ? "offsetWidth" : "offsetHeight"] +
          parseFloat(
            i
              .getComputedStyle(e, null)
              .getPropertyValue("width" === t ? "margin-right" : "margin-top")
          ) +
          parseFloat(
            i
              .getComputedStyle(e, null)
              .getPropertyValue("width" === t ? "margin-left" : "margin-bottom")
          )
      : e.offsetWidth;
  }
  function L(e) {
    return (Array.isArray(e) ? e : [e]).filter((e) => !!e);
  }
  function P(e) {
    return (t) =>
      Math.abs(t) > 0 &&
      e.browser &&
      e.browser.need3dFix &&
      Math.abs(t) % 90 == 0
        ? t + 0.001
        : t;
  }
  let k, A, z;
  function I() {
    return (
      k ||
        (k = (function () {
          const e = l(),
            t = n();
          return {
            smoothScroll:
              t.documentElement &&
              t.documentElement.style &&
              "scrollBehavior" in t.documentElement.style,
            touch: !!(
              "ontouchstart" in e ||
              (e.DocumentTouch && t instanceof e.DocumentTouch)
            ),
          };
        })()),
      k
    );
  }
  function O(e) {
    return (
      void 0 === e && (e = {}),
      A ||
        (A = (function (e) {
          let { userAgent: t } = void 0 === e ? {} : e;
          const s = I(),
            i = l(),
            r = i.navigator.platform,
            a = t || i.navigator.userAgent,
            n = { ios: !1, android: !1 },
            o = i.screen.width,
            d = i.screen.height,
            c = a.match(/(Android);?[\s\/]+([\d.]+)?/);
          let p = a.match(/(iPad).*OS\s([\d_]+)/);
          const u = a.match(/(iPod)(.*OS\s([\d_]+))?/),
            m = !p && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
            f = "Win32" === r;
          let h = "MacIntel" === r;
          return (
            !p &&
              h &&
              s.touch &&
              [
                "1024x1366",
                "1366x1024",
                "834x1194",
                "1194x834",
                "834x1112",
                "1112x834",
                "768x1024",
                "1024x768",
                "820x1180",
                "1180x820",
                "810x1080",
                "1080x810",
              ].indexOf(`${o}x${d}`) >= 0 &&
              ((p = a.match(/(Version)\/([\d.]+)/)),
              p || (p = [0, 1, "13_0_0"]),
              (h = !1)),
            c && !f && ((n.os = "android"), (n.android = !0)),
            (p || m || u) && ((n.os = "ios"), (n.ios = !0)),
            n
          );
        })(e)),
      A
    );
  }
  function $() {
    return (
      z ||
        (z = (function () {
          const e = l(),
            t = O();
          let s = !1;
          function i() {
            const t = e.navigator.userAgent.toLowerCase();
            return (
              t.indexOf("safari") >= 0 &&
              t.indexOf("chrome") < 0 &&
              t.indexOf("android") < 0
            );
          }
          if (i()) {
            const t = String(e.navigator.userAgent);
            if (t.includes("Version/")) {
              const [e, i] = t
                .split("Version/")[1]
                .split(" ")[0]
                .split(".")
                .map((e) => Number(e));
              s = e < 16 || (16 === e && i < 2);
            }
          }
          const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
              e.navigator.userAgent
            ),
            a = i();
          return {
            isSafari: s || a,
            needPerspectiveFix: s,
            need3dFix: a || (r && t.ios),
            isWebView: r,
          };
        })()),
      z
    );
  }
  var D = {
    on(e, t, s) {
      const i = this;
      if (!i.eventsListeners || i.destroyed) return i;
      if ("function" != typeof t) return i;
      const r = s ? "unshift" : "push";
      return (
        e.split(" ").forEach((e) => {
          i.eventsListeners[e] || (i.eventsListeners[e] = []),
            i.eventsListeners[e][r](t);
        }),
        i
      );
    },
    once(e, t, s) {
      const i = this;
      if (!i.eventsListeners || i.destroyed) return i;
      if ("function" != typeof t) return i;
      function r() {
        i.off(e, r), r.__emitterProxy && delete r.__emitterProxy;
        for (var s = arguments.length, a = new Array(s), n = 0; n < s; n++)
          a[n] = arguments[n];
        t.apply(i, a);
      }
      return (r.__emitterProxy = t), i.on(e, r, s);
    },
    onAny(e, t) {
      const s = this;
      if (!s.eventsListeners || s.destroyed) return s;
      if ("function" != typeof e) return s;
      const i = t ? "unshift" : "push";
      return (
        s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[i](e), s
      );
    },
    offAny(e) {
      const t = this;
      if (!t.eventsListeners || t.destroyed) return t;
      if (!t.eventsAnyListeners) return t;
      const s = t.eventsAnyListeners.indexOf(e);
      return s >= 0 && t.eventsAnyListeners.splice(s, 1), t;
    },
    off(e, t) {
      const s = this;
      return !s.eventsListeners || s.destroyed
        ? s
        : s.eventsListeners
        ? (e.split(" ").forEach((e) => {
            void 0 === t
              ? (s.eventsListeners[e] = [])
              : s.eventsListeners[e] &&
                s.eventsListeners[e].forEach((i, r) => {
                  (i === t || (i.__emitterProxy && i.__emitterProxy === t)) &&
                    s.eventsListeners[e].splice(r, 1);
                });
          }),
          s)
        : s;
    },
    emit() {
      const e = this;
      if (!e.eventsListeners || e.destroyed) return e;
      if (!e.eventsListeners) return e;
      let t, s, i;
      for (var r = arguments.length, a = new Array(r), n = 0; n < r; n++)
        a[n] = arguments[n];
      "string" == typeof a[0] || Array.isArray(a[0])
        ? ((t = a[0]), (s = a.slice(1, a.length)), (i = e))
        : ((t = a[0].events), (s = a[0].data), (i = a[0].context || e)),
        s.unshift(i);
      return (
        (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
          e.eventsAnyListeners &&
            e.eventsAnyListeners.length &&
            e.eventsAnyListeners.forEach((e) => {
              e.apply(i, [t, ...s]);
            }),
            e.eventsListeners &&
              e.eventsListeners[t] &&
              e.eventsListeners[t].forEach((e) => {
                e.apply(i, s);
              });
        }),
        e
      );
    },
  };
  const _ = (e, t, s) => {
    t && !e.classList.contains(s)
      ? e.classList.add(s)
      : !t && e.classList.contains(s) && e.classList.remove(s);
  };
  const q = (e, t, s) => {
    t && !e.classList.contains(s)
      ? e.classList.add(s)
      : !t && e.classList.contains(s) && e.classList.remove(s);
  };
  const G = (e, t) => {
      if (!e || e.destroyed || !e.params) return;
      const s = t.closest(
        e.isElement ? "swiper-slide" : `.${e.params.slideClass}`
      );
      if (s) {
        let t = s.querySelector(`.${e.params.lazyPreloaderClass}`);
        !t &&
          e.isElement &&
          (s.shadowRoot
            ? (t = s.shadowRoot.querySelector(
                `.${e.params.lazyPreloaderClass}`
              ))
            : requestAnimationFrame(() => {
                s.shadowRoot &&
                  ((t = s.shadowRoot.querySelector(
                    `.${e.params.lazyPreloaderClass}`
                  )),
                  t && t.remove());
              })),
          t && t.remove();
      }
    },
    B = (e, t) => {
      if (!e.slides[t]) return;
      const s = e.slides[t].querySelector('[loading="lazy"]');
      s && s.removeAttribute("loading");
    },
    N = (e) => {
      if (!e || e.destroyed || !e.params) return;
      let t = e.params.lazyPreloadPrevNext;
      const s = e.slides.length;
      if (!s || !t || t < 0) return;
      t = Math.min(t, s);
      const i =
          "auto" === e.params.slidesPerView
            ? e.slidesPerViewDynamic()
            : Math.ceil(e.params.slidesPerView),
        r = e.activeIndex;
      if (e.params.grid && e.params.grid.rows > 1) {
        const s = r,
          a = [s - t];
        return (
          a.push(...Array.from({ length: t }).map((e, t) => s + i + t)),
          void e.slides.forEach((t, s) => {
            a.includes(t.column) && B(e, s);
          })
        );
      }
      const a = r + i - 1;
      if (e.params.rewind || e.params.loop)
        for (let i = r - t; i <= a + t; i += 1) {
          const t = ((i % s) + s) % s;
          (t < r || t > a) && B(e, t);
        }
      else
        for (let i = Math.max(r - t, 0); i <= Math.min(a + t, s - 1); i += 1)
          i !== r && (i > a || i < r) && B(e, i);
    };
  var V = {
    updateSize: function () {
      const e = this;
      let t, s;
      const i = e.el;
      (t =
        void 0 !== e.params.width && null !== e.params.width
          ? e.params.width
          : i.clientWidth),
        (s =
          void 0 !== e.params.height && null !== e.params.height
            ? e.params.height
            : i.clientHeight),
        (0 === t && e.isHorizontal()) ||
          (0 === s && e.isVertical()) ||
          ((t =
            t -
            parseInt(x(i, "padding-left") || 0, 10) -
            parseInt(x(i, "padding-right") || 0, 10)),
          (s =
            s -
            parseInt(x(i, "padding-top") || 0, 10) -
            parseInt(x(i, "padding-bottom") || 0, 10)),
          Number.isNaN(t) && (t = 0),
          Number.isNaN(s) && (s = 0),
          Object.assign(e, {
            width: t,
            height: s,
            size: e.isHorizontal() ? t : s,
          }));
    },
    updateSlides: function () {
      const e = this;
      function t(t, s) {
        return parseFloat(t.getPropertyValue(e.getDirectionLabel(s)) || 0);
      }
      const s = e.params,
        {
          wrapperEl: i,
          slidesEl: r,
          size: a,
          rtlTranslate: n,
          wrongRTL: o,
        } = e,
        l = e.virtual && s.virtual.enabled,
        d = l ? e.virtual.slides.length : e.slides.length,
        c = w(r, `.${e.params.slideClass}, swiper-slide`),
        p = l ? e.virtual.slides.length : c.length;
      let u = [];
      const m = [],
        f = [];
      let v = s.slidesOffsetBefore;
      "function" == typeof v && (v = s.slidesOffsetBefore.call(e));
      let g = s.slidesOffsetAfter;
      "function" == typeof g && (g = s.slidesOffsetAfter.call(e));
      const y = e.snapGrid.length,
        b = e.slidesGrid.length;
      let E = s.spaceBetween,
        S = -v,
        T = 0,
        M = 0;
      if (void 0 === a) return;
      "string" == typeof E && E.indexOf("%") >= 0
        ? (E = (parseFloat(E.replace("%", "")) / 100) * a)
        : "string" == typeof E && (E = parseFloat(E)),
        (e.virtualSize = -E),
        c.forEach((e) => {
          n ? (e.style.marginLeft = "") : (e.style.marginRight = ""),
            (e.style.marginBottom = ""),
            (e.style.marginTop = "");
        }),
        s.centeredSlides &&
          s.cssMode &&
          (h(i, "--swiper-centered-offset-before", ""),
          h(i, "--swiper-centered-offset-after", ""));
      const L = s.grid && s.grid.rows > 1 && e.grid;
      let P;
      L ? e.grid.initSlides(c) : e.grid && e.grid.unsetSlides();
      const k =
        "auto" === s.slidesPerView &&
        s.breakpoints &&
        Object.keys(s.breakpoints).filter(
          (e) => void 0 !== s.breakpoints[e].slidesPerView
        ).length > 0;
      for (let i = 0; i < p; i += 1) {
        let r;
        if (
          ((P = 0),
          c[i] && (r = c[i]),
          L && e.grid.updateSlide(i, r, c),
          !c[i] || "none" !== x(r, "display"))
        ) {
          if ("auto" === s.slidesPerView) {
            k && (c[i].style[e.getDirectionLabel("width")] = "");
            const a = getComputedStyle(r),
              n = r.style.transform,
              o = r.style.webkitTransform;
            if (
              (n && (r.style.transform = "none"),
              o && (r.style.webkitTransform = "none"),
              s.roundLengths)
            )
              P = e.isHorizontal() ? C(r, "width", !0) : C(r, "height", !0);
            else {
              const e = t(a, "width"),
                s = t(a, "padding-left"),
                i = t(a, "padding-right"),
                n = t(a, "margin-left"),
                o = t(a, "margin-right"),
                l = a.getPropertyValue("box-sizing");
              if (l && "border-box" === l) P = e + n + o;
              else {
                const { clientWidth: t, offsetWidth: a } = r;
                P = e + s + i + n + o + (a - t);
              }
            }
            n && (r.style.transform = n),
              o && (r.style.webkitTransform = o),
              s.roundLengths && (P = Math.floor(P));
          } else
            (P = (a - (s.slidesPerView - 1) * E) / s.slidesPerView),
              s.roundLengths && (P = Math.floor(P)),
              c[i] && (c[i].style[e.getDirectionLabel("width")] = `${P}px`);
          c[i] && (c[i].swiperSlideSize = P),
            f.push(P),
            s.centeredSlides
              ? ((S = S + P / 2 + T / 2 + E),
                0 === T && 0 !== i && (S = S - a / 2 - E),
                0 === i && (S = S - a / 2 - E),
                Math.abs(S) < 0.001 && (S = 0),
                s.roundLengths && (S = Math.floor(S)),
                M % s.slidesPerGroup == 0 && u.push(S),
                m.push(S))
              : (s.roundLengths && (S = Math.floor(S)),
                (M - Math.min(e.params.slidesPerGroupSkip, M)) %
                  e.params.slidesPerGroup ==
                  0 && u.push(S),
                m.push(S),
                (S = S + P + E)),
            (e.virtualSize += P + E),
            (T = P),
            (M += 1);
        }
      }
      if (
        ((e.virtualSize = Math.max(e.virtualSize, a) + g),
        n &&
          o &&
          ("slide" === s.effect || "coverflow" === s.effect) &&
          (i.style.width = `${e.virtualSize + E}px`),
        s.setWrapperSize &&
          (i.style[e.getDirectionLabel("width")] = `${e.virtualSize + E}px`),
        L && e.grid.updateWrapperSize(P, u),
        !s.centeredSlides)
      ) {
        const t = [];
        for (let i = 0; i < u.length; i += 1) {
          let r = u[i];
          s.roundLengths && (r = Math.floor(r)),
            u[i] <= e.virtualSize - a && t.push(r);
        }
        (u = t),
          Math.floor(e.virtualSize - a) - Math.floor(u[u.length - 1]) > 1 &&
            u.push(e.virtualSize - a);
      }
      if (l && s.loop) {
        const t = f[0] + E;
        if (s.slidesPerGroup > 1) {
          const i = Math.ceil(
              (e.virtual.slidesBefore + e.virtual.slidesAfter) /
                s.slidesPerGroup
            ),
            r = t * s.slidesPerGroup;
          for (let e = 0; e < i; e += 1) u.push(u[u.length - 1] + r);
        }
        for (
          let i = 0;
          i < e.virtual.slidesBefore + e.virtual.slidesAfter;
          i += 1
        )
          1 === s.slidesPerGroup && u.push(u[u.length - 1] + t),
            m.push(m[m.length - 1] + t),
            (e.virtualSize += t);
      }
      if ((0 === u.length && (u = [0]), 0 !== E)) {
        const t =
          e.isHorizontal() && n
            ? "marginLeft"
            : e.getDirectionLabel("marginRight");
        c.filter(
          (e, t) => !(s.cssMode && !s.loop) || t !== c.length - 1
        ).forEach((e) => {
          e.style[t] = `${E}px`;
        });
      }
      if (s.centeredSlides && s.centeredSlidesBounds) {
        let e = 0;
        f.forEach((t) => {
          e += t + (E || 0);
        }),
          (e -= E);
        const t = e > a ? e - a : 0;
        u = u.map((e) => (e <= 0 ? -v : e > t ? t + g : e));
      }
      if (s.centerInsufficientSlides) {
        let e = 0;
        f.forEach((t) => {
          e += t + (E || 0);
        }),
          (e -= E);
        const t = (s.slidesOffsetBefore || 0) + (s.slidesOffsetAfter || 0);
        if (e + t < a) {
          const s = (a - e - t) / 2;
          u.forEach((e, t) => {
            u[t] = e - s;
          }),
            m.forEach((e, t) => {
              m[t] = e + s;
            });
        }
      }
      if (
        (Object.assign(e, {
          slides: c,
          snapGrid: u,
          slidesGrid: m,
          slidesSizesGrid: f,
        }),
        s.centeredSlides && s.cssMode && !s.centeredSlidesBounds)
      ) {
        h(i, "--swiper-centered-offset-before", -u[0] + "px"),
          h(
            i,
            "--swiper-centered-offset-after",
            e.size / 2 - f[f.length - 1] / 2 + "px"
          );
        const t = -e.snapGrid[0],
          s = -e.slidesGrid[0];
        (e.snapGrid = e.snapGrid.map((e) => e + t)),
          (e.slidesGrid = e.slidesGrid.map((e) => e + s));
      }
      if (
        (p !== d && e.emit("slidesLengthChange"),
        u.length !== y &&
          (e.params.watchOverflow && e.checkOverflow(),
          e.emit("snapGridLengthChange")),
        m.length !== b && e.emit("slidesGridLengthChange"),
        s.watchSlidesProgress && e.updateSlidesOffset(),
        e.emit("slidesUpdated"),
        !(l || s.cssMode || ("slide" !== s.effect && "fade" !== s.effect)))
      ) {
        const t = `${s.containerModifierClass}backface-hidden`,
          i = e.el.classList.contains(t);
        p <= s.maxBackfaceHiddenSlides
          ? i || e.el.classList.add(t)
          : i && e.el.classList.remove(t);
      }
    },
    updateAutoHeight: function (e) {
      const t = this,
        s = [],
        i = t.virtual && t.params.virtual.enabled;
      let r,
        a = 0;
      "number" == typeof e
        ? t.setTransition(e)
        : !0 === e && t.setTransition(t.params.speed);
      const n = (e) => (i ? t.slides[t.getSlideIndexByData(e)] : t.slides[e]);
      if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
        if (t.params.centeredSlides)
          (t.visibleSlides || []).forEach((e) => {
            s.push(e);
          });
        else
          for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
            const e = t.activeIndex + r;
            if (e > t.slides.length && !i) break;
            s.push(n(e));
          }
      else s.push(n(t.activeIndex));
      for (r = 0; r < s.length; r += 1)
        if (void 0 !== s[r]) {
          const e = s[r].offsetHeight;
          a = e > a ? e : a;
        }
      (a || 0 === a) && (t.wrapperEl.style.height = `${a}px`);
    },
    updateSlidesOffset: function () {
      const e = this,
        t = e.slides,
        s = e.isElement
          ? e.isHorizontal()
            ? e.wrapperEl.offsetLeft
            : e.wrapperEl.offsetTop
          : 0;
      for (let i = 0; i < t.length; i += 1)
        t[i].swiperSlideOffset =
          (e.isHorizontal() ? t[i].offsetLeft : t[i].offsetTop) -
          s -
          e.cssOverflowAdjustment();
    },
    updateSlidesProgress: function (e) {
      void 0 === e && (e = (this && this.translate) || 0);
      const t = this,
        s = t.params,
        { slides: i, rtlTranslate: r, snapGrid: a } = t;
      if (0 === i.length) return;
      void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
      let n = -e;
      r && (n = e), (t.visibleSlidesIndexes = []), (t.visibleSlides = []);
      let o = s.spaceBetween;
      "string" == typeof o && o.indexOf("%") >= 0
        ? (o = (parseFloat(o.replace("%", "")) / 100) * t.size)
        : "string" == typeof o && (o = parseFloat(o));
      for (let e = 0; e < i.length; e += 1) {
        const l = i[e];
        let d = l.swiperSlideOffset;
        s.cssMode && s.centeredSlides && (d -= i[0].swiperSlideOffset);
        const c =
            (n + (s.centeredSlides ? t.minTranslate() : 0) - d) /
            (l.swiperSlideSize + o),
          p =
            (n - a[0] + (s.centeredSlides ? t.minTranslate() : 0) - d) /
            (l.swiperSlideSize + o),
          u = -(n - d),
          m = u + t.slidesSizesGrid[e],
          f = u >= 0 && u <= t.size - t.slidesSizesGrid[e],
          h =
            (u >= 0 && u < t.size - 1) ||
            (m > 1 && m <= t.size) ||
            (u <= 0 && m >= t.size);
        h && (t.visibleSlides.push(l), t.visibleSlidesIndexes.push(e)),
          _(l, h, s.slideVisibleClass),
          _(l, f, s.slideFullyVisibleClass),
          (l.progress = r ? -c : c),
          (l.originalProgress = r ? -p : p);
      }
    },
    updateProgress: function (e) {
      const t = this;
      if (void 0 === e) {
        const s = t.rtlTranslate ? -1 : 1;
        e = (t && t.translate && t.translate * s) || 0;
      }
      const s = t.params,
        i = t.maxTranslate() - t.minTranslate();
      let { progress: r, isBeginning: a, isEnd: n, progressLoop: o } = t;
      const l = a,
        d = n;
      if (0 === i) (r = 0), (a = !0), (n = !0);
      else {
        r = (e - t.minTranslate()) / i;
        const s = Math.abs(e - t.minTranslate()) < 1,
          o = Math.abs(e - t.maxTranslate()) < 1;
        (a = s || r <= 0), (n = o || r >= 1), s && (r = 0), o && (r = 1);
      }
      if (s.loop) {
        const s = t.getSlideIndexByData(0),
          i = t.getSlideIndexByData(t.slides.length - 1),
          r = t.slidesGrid[s],
          a = t.slidesGrid[i],
          n = t.slidesGrid[t.slidesGrid.length - 1],
          l = Math.abs(e);
        (o = l >= r ? (l - r) / n : (l + n - a) / n), o > 1 && (o -= 1);
      }
      Object.assign(t, {
        progress: r,
        progressLoop: o,
        isBeginning: a,
        isEnd: n,
      }),
        (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) &&
          t.updateSlidesProgress(e),
        a && !l && t.emit("reachBeginning toEdge"),
        n && !d && t.emit("reachEnd toEdge"),
        ((l && !a) || (d && !n)) && t.emit("fromEdge"),
        t.emit("progress", r);
    },
    updateSlidesClasses: function () {
      const e = this,
        { slides: t, params: s, slidesEl: i, activeIndex: r } = e,
        a = e.virtual && s.virtual.enabled,
        n = e.grid && s.grid && s.grid.rows > 1,
        o = (e) => w(i, `.${s.slideClass}${e}, swiper-slide${e}`)[0];
      let l, d, c;
      if (a)
        if (s.loop) {
          let t = r - e.virtual.slidesBefore;
          t < 0 && (t = e.virtual.slides.length + t),
            t >= e.virtual.slides.length && (t -= e.virtual.slides.length),
            (l = o(`[data-swiper-slide-index="${t}"]`));
        } else l = o(`[data-swiper-slide-index="${r}"]`);
      else
        n
          ? ((l = t.filter((e) => e.column === r)[0]),
            (c = t.filter((e) => e.column === r + 1)[0]),
            (d = t.filter((e) => e.column === r - 1)[0]))
          : (l = t[r]);
      l &&
        (n ||
          ((c = (function (e, t) {
            const s = [];
            for (; e.nextElementSibling; ) {
              const i = e.nextElementSibling;
              t ? i.matches(t) && s.push(i) : s.push(i), (e = i);
            }
            return s;
          })(l, `.${s.slideClass}, swiper-slide`)[0]),
          s.loop && !c && (c = t[0]),
          (d = (function (e, t) {
            const s = [];
            for (; e.previousElementSibling; ) {
              const i = e.previousElementSibling;
              t ? i.matches(t) && s.push(i) : s.push(i), (e = i);
            }
            return s;
          })(l, `.${s.slideClass}, swiper-slide`)[0]),
          s.loop && 0 === !d && (d = t[t.length - 1]))),
        t.forEach((e) => {
          q(e, e === l, s.slideActiveClass),
            q(e, e === c, s.slideNextClass),
            q(e, e === d, s.slidePrevClass);
        }),
        e.emitSlidesClasses();
    },
    updateActiveIndex: function (e) {
      const t = this,
        s = t.rtlTranslate ? t.translate : -t.translate,
        {
          snapGrid: i,
          params: r,
          activeIndex: a,
          realIndex: n,
          snapIndex: o,
        } = t;
      let l,
        d = e;
      const c = (e) => {
        let s = e - t.virtual.slidesBefore;
        return (
          s < 0 && (s = t.virtual.slides.length + s),
          s >= t.virtual.slides.length && (s -= t.virtual.slides.length),
          s
        );
      };
      if (
        (void 0 === d &&
          (d = (function (e) {
            const { slidesGrid: t, params: s } = e,
              i = e.rtlTranslate ? e.translate : -e.translate;
            let r;
            for (let e = 0; e < t.length; e += 1)
              void 0 !== t[e + 1]
                ? i >= t[e] && i < t[e + 1] - (t[e + 1] - t[e]) / 2
                  ? (r = e)
                  : i >= t[e] && i < t[e + 1] && (r = e + 1)
                : i >= t[e] && (r = e);
            return (
              s.normalizeSlideIndex && (r < 0 || void 0 === r) && (r = 0), r
            );
          })(t)),
        i.indexOf(s) >= 0)
      )
        l = i.indexOf(s);
      else {
        const e = Math.min(r.slidesPerGroupSkip, d);
        l = e + Math.floor((d - e) / r.slidesPerGroup);
      }
      if ((l >= i.length && (l = i.length - 1), d === a && !t.params.loop))
        return void (l !== o && ((t.snapIndex = l), t.emit("snapIndexChange")));
      if (d === a && t.params.loop && t.virtual && t.params.virtual.enabled)
        return void (t.realIndex = c(d));
      const p = t.grid && r.grid && r.grid.rows > 1;
      let u;
      if (t.virtual && r.virtual.enabled && r.loop) u = c(d);
      else if (p) {
        const e = t.slides.filter((e) => e.column === d)[0];
        let s = parseInt(e.getAttribute("data-swiper-slide-index"), 10);
        Number.isNaN(s) && (s = Math.max(t.slides.indexOf(e), 0)),
          (u = Math.floor(s / r.grid.rows));
      } else if (t.slides[d]) {
        const e = t.slides[d].getAttribute("data-swiper-slide-index");
        u = e ? parseInt(e, 10) : d;
      } else u = d;
      Object.assign(t, {
        previousSnapIndex: o,
        snapIndex: l,
        previousRealIndex: n,
        realIndex: u,
        previousIndex: a,
        activeIndex: d,
      }),
        t.initialized && N(t),
        t.emit("activeIndexChange"),
        t.emit("snapIndexChange"),
        (t.initialized || t.params.runCallbacksOnInit) &&
          (n !== u && t.emit("realIndexChange"), t.emit("slideChange"));
    },
    updateClickedSlide: function (e, t) {
      const s = this,
        i = s.params;
      let r = e.closest(`.${i.slideClass}, swiper-slide`);
      !r &&
        s.isElement &&
        t &&
        t.length > 1 &&
        t.includes(e) &&
        [...t.slice(t.indexOf(e) + 1, t.length)].forEach((e) => {
          !r &&
            e.matches &&
            e.matches(`.${i.slideClass}, swiper-slide`) &&
            (r = e);
        });
      let a,
        n = !1;
      if (r)
        for (let e = 0; e < s.slides.length; e += 1)
          if (s.slides[e] === r) {
            (n = !0), (a = e);
            break;
          }
      if (!r || !n)
        return (s.clickedSlide = void 0), void (s.clickedIndex = void 0);
      (s.clickedSlide = r),
        s.virtual && s.params.virtual.enabled
          ? (s.clickedIndex = parseInt(
              r.getAttribute("data-swiper-slide-index"),
              10
            ))
          : (s.clickedIndex = a),
        i.slideToClickedSlide &&
          void 0 !== s.clickedIndex &&
          s.clickedIndex !== s.activeIndex &&
          s.slideToClickedSlide();
    },
  };
  var H = {
    getTranslate: function (e) {
      void 0 === e && (e = this.isHorizontal() ? "x" : "y");
      const { params: t, rtlTranslate: s, translate: i, wrapperEl: r } = this;
      if (t.virtualTranslate) return s ? -i : i;
      if (t.cssMode) return i;
      let a = u(r, e);
      return (a += this.cssOverflowAdjustment()), s && (a = -a), a || 0;
    },
    setTranslate: function (e, t) {
      const s = this,
        { rtlTranslate: i, params: r, wrapperEl: a, progress: n } = s;
      let o,
        l = 0,
        d = 0;
      s.isHorizontal() ? (l = i ? -e : e) : (d = e),
        r.roundLengths && ((l = Math.floor(l)), (d = Math.floor(d))),
        (s.previousTranslate = s.translate),
        (s.translate = s.isHorizontal() ? l : d),
        r.cssMode
          ? (a[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal()
              ? -l
              : -d)
          : r.virtualTranslate ||
            (s.isHorizontal()
              ? (l -= s.cssOverflowAdjustment())
              : (d -= s.cssOverflowAdjustment()),
            (a.style.transform = `translate3d(${l}px, ${d}px, 0px)`));
      const c = s.maxTranslate() - s.minTranslate();
      (o = 0 === c ? 0 : (e - s.minTranslate()) / c),
        o !== n && s.updateProgress(e),
        s.emit("setTranslate", s.translate, t);
    },
    minTranslate: function () {
      return -this.snapGrid[0];
    },
    maxTranslate: function () {
      return -this.snapGrid[this.snapGrid.length - 1];
    },
    translateTo: function (e, t, s, i, r) {
      void 0 === e && (e = 0),
        void 0 === t && (t = this.params.speed),
        void 0 === s && (s = !0),
        void 0 === i && (i = !0);
      const a = this,
        { params: n, wrapperEl: o } = a;
      if (a.animating && n.preventInteractionOnTransition) return !1;
      const l = a.minTranslate(),
        d = a.maxTranslate();
      let c;
      if (
        ((c = i && e > l ? l : i && e < d ? d : e),
        a.updateProgress(c),
        n.cssMode)
      ) {
        const e = a.isHorizontal();
        if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -c;
        else {
          if (!a.support.smoothScroll)
            return (
              v({ swiper: a, targetPosition: -c, side: e ? "left" : "top" }), !0
            );
          o.scrollTo({ [e ? "left" : "top"]: -c, behavior: "smooth" });
        }
        return !0;
      }
      return (
        0 === t
          ? (a.setTransition(0),
            a.setTranslate(c),
            s &&
              (a.emit("beforeTransitionStart", t, r), a.emit("transitionEnd")))
          : (a.setTransition(t),
            a.setTranslate(c),
            s &&
              (a.emit("beforeTransitionStart", t, r),
              a.emit("transitionStart")),
            a.animating ||
              ((a.animating = !0),
              a.onTranslateToWrapperTransitionEnd ||
                (a.onTranslateToWrapperTransitionEnd = function (e) {
                  a &&
                    !a.destroyed &&
                    e.target === this &&
                    (a.wrapperEl.removeEventListener(
                      "transitionend",
                      a.onTranslateToWrapperTransitionEnd
                    ),
                    (a.onTranslateToWrapperTransitionEnd = null),
                    delete a.onTranslateToWrapperTransitionEnd,
                    (a.animating = !1),
                    s && a.emit("transitionEnd"));
                }),
              a.wrapperEl.addEventListener(
                "transitionend",
                a.onTranslateToWrapperTransitionEnd
              ))),
        !0
      );
    },
  };
  function X(e) {
    let { swiper: t, runCallbacks: s, direction: i, step: r } = e;
    const { activeIndex: a, previousIndex: n } = t;
    let o = i;
    if (
      (o || (o = a > n ? "next" : a < n ? "prev" : "reset"),
      t.emit(`transition${r}`),
      s && a !== n)
    ) {
      if ("reset" === o) return void t.emit(`slideResetTransition${r}`);
      t.emit(`slideChangeTransition${r}`),
        "next" === o
          ? t.emit(`slideNextTransition${r}`)
          : t.emit(`slidePrevTransition${r}`);
    }
  }
  var Y = {
    slideTo: function (e, t, s, i, r) {
      void 0 === e && (e = 0),
        void 0 === s && (s = !0),
        "string" == typeof e && (e = parseInt(e, 10));
      const a = this;
      let n = e;
      n < 0 && (n = 0);
      const {
        params: o,
        snapGrid: l,
        slidesGrid: d,
        previousIndex: c,
        activeIndex: p,
        rtlTranslate: u,
        wrapperEl: m,
        enabled: f,
      } = a;
      if (
        (!f && !i && !r) ||
        a.destroyed ||
        (a.animating && o.preventInteractionOnTransition)
      )
        return !1;
      void 0 === t && (t = a.params.speed);
      const h = Math.min(a.params.slidesPerGroupSkip, n);
      let g = h + Math.floor((n - h) / a.params.slidesPerGroup);
      g >= l.length && (g = l.length - 1);
      const w = -l[g];
      if (o.normalizeSlideIndex)
        for (let e = 0; e < d.length; e += 1) {
          const t = -Math.floor(100 * w),
            s = Math.floor(100 * d[e]),
            i = Math.floor(100 * d[e + 1]);
          void 0 !== d[e + 1]
            ? t >= s && t < i - (i - s) / 2
              ? (n = e)
              : t >= s && t < i && (n = e + 1)
            : t >= s && (n = e);
        }
      if (a.initialized && n !== p) {
        if (
          !a.allowSlideNext &&
          (u
            ? w > a.translate && w > a.minTranslate()
            : w < a.translate && w < a.minTranslate())
        )
          return !1;
        if (
          !a.allowSlidePrev &&
          w > a.translate &&
          w > a.maxTranslate() &&
          (p || 0) !== n
        )
          return !1;
      }
      let y;
      n !== (c || 0) && s && a.emit("beforeSlideChangeStart"),
        a.updateProgress(w),
        (y = n > p ? "next" : n < p ? "prev" : "reset");
      const b = a.virtual && a.params.virtual.enabled;
      if (!(b && r) && ((u && -w === a.translate) || (!u && w === a.translate)))
        return (
          a.updateActiveIndex(n),
          o.autoHeight && a.updateAutoHeight(),
          a.updateSlidesClasses(),
          "slide" !== o.effect && a.setTranslate(w),
          "reset" !== y && (a.transitionStart(s, y), a.transitionEnd(s, y)),
          !1
        );
      if (o.cssMode) {
        const e = a.isHorizontal(),
          s = u ? w : -w;
        if (0 === t)
          b &&
            ((a.wrapperEl.style.scrollSnapType = "none"),
            (a._immediateVirtual = !0)),
            b && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0
              ? ((a._cssModeVirtualInitialSet = !0),
                requestAnimationFrame(() => {
                  m[e ? "scrollLeft" : "scrollTop"] = s;
                }))
              : (m[e ? "scrollLeft" : "scrollTop"] = s),
            b &&
              requestAnimationFrame(() => {
                (a.wrapperEl.style.scrollSnapType = ""),
                  (a._immediateVirtual = !1);
              });
        else {
          if (!a.support.smoothScroll)
            return (
              v({ swiper: a, targetPosition: s, side: e ? "left" : "top" }), !0
            );
          m.scrollTo({ [e ? "left" : "top"]: s, behavior: "smooth" });
        }
        return !0;
      }
      return (
        a.setTransition(t),
        a.setTranslate(w),
        a.updateActiveIndex(n),
        a.updateSlidesClasses(),
        a.emit("beforeTransitionStart", t, i),
        a.transitionStart(s, y),
        0 === t
          ? a.transitionEnd(s, y)
          : a.animating ||
            ((a.animating = !0),
            a.onSlideToWrapperTransitionEnd ||
              (a.onSlideToWrapperTransitionEnd = function (e) {
                a &&
                  !a.destroyed &&
                  e.target === this &&
                  (a.wrapperEl.removeEventListener(
                    "transitionend",
                    a.onSlideToWrapperTransitionEnd
                  ),
                  (a.onSlideToWrapperTransitionEnd = null),
                  delete a.onSlideToWrapperTransitionEnd,
                  a.transitionEnd(s, y));
              }),
            a.wrapperEl.addEventListener(
              "transitionend",
              a.onSlideToWrapperTransitionEnd
            )),
        !0
      );
    },
    slideToLoop: function (e, t, s, i) {
      if (
        (void 0 === e && (e = 0),
        void 0 === s && (s = !0),
        "string" == typeof e)
      ) {
        e = parseInt(e, 10);
      }
      const r = this;
      if (r.destroyed) return;
      void 0 === t && (t = r.params.speed);
      const a = r.grid && r.params.grid && r.params.grid.rows > 1;
      let n = e;
      if (r.params.loop)
        if (r.virtual && r.params.virtual.enabled) n += r.virtual.slidesBefore;
        else {
          let e;
          if (a) {
            const t = n * r.params.grid.rows;
            e = r.slides.filter(
              (e) => 1 * e.getAttribute("data-swiper-slide-index") === t
            )[0].column;
          } else e = r.getSlideIndexByData(n);
          const t = a
              ? Math.ceil(r.slides.length / r.params.grid.rows)
              : r.slides.length,
            { centeredSlides: s } = r.params;
          let o = r.params.slidesPerView;
          "auto" === o
            ? (o = r.slidesPerViewDynamic())
            : ((o = Math.ceil(parseFloat(r.params.slidesPerView, 10))),
              s && o % 2 == 0 && (o += 1));
          let l = t - e < o;
          if (
            (s && (l = l || e < Math.ceil(o / 2)),
            i && s && "auto" !== r.params.slidesPerView && !a && (l = !1),
            l)
          ) {
            const i = s
              ? e < r.activeIndex
                ? "prev"
                : "next"
              : e - r.activeIndex - 1 < r.params.slidesPerView
              ? "next"
              : "prev";
            r.loopFix({
              direction: i,
              slideTo: !0,
              activeSlideIndex: "next" === i ? e + 1 : e - t + 1,
              slideRealIndex: "next" === i ? r.realIndex : void 0,
            });
          }
          if (a) {
            const e = n * r.params.grid.rows;
            n = r.slides.filter(
              (t) => 1 * t.getAttribute("data-swiper-slide-index") === e
            )[0].column;
          } else n = r.getSlideIndexByData(n);
        }
      return (
        requestAnimationFrame(() => {
          r.slideTo(n, t, s, i);
        }),
        r
      );
    },
    slideNext: function (e, t, s) {
      void 0 === t && (t = !0);
      const i = this,
        { enabled: r, params: a, animating: n } = i;
      if (!r || i.destroyed) return i;
      void 0 === e && (e = i.params.speed);
      let o = a.slidesPerGroup;
      "auto" === a.slidesPerView &&
        1 === a.slidesPerGroup &&
        a.slidesPerGroupAuto &&
        (o = Math.max(i.slidesPerViewDynamic("current", !0), 1));
      const l = i.activeIndex < a.slidesPerGroupSkip ? 1 : o,
        d = i.virtual && a.virtual.enabled;
      if (a.loop) {
        if (n && !d && a.loopPreventsSliding) return !1;
        if (
          (i.loopFix({ direction: "next" }),
          (i._clientLeft = i.wrapperEl.clientLeft),
          i.activeIndex === i.slides.length - 1 && a.cssMode)
        )
          return (
            requestAnimationFrame(() => {
              i.slideTo(i.activeIndex + l, e, t, s);
            }),
            !0
          );
      }
      return a.rewind && i.isEnd
        ? i.slideTo(0, e, t, s)
        : i.slideTo(i.activeIndex + l, e, t, s);
    },
    slidePrev: function (e, t, s) {
      void 0 === t && (t = !0);
      const i = this,
        {
          params: r,
          snapGrid: a,
          slidesGrid: n,
          rtlTranslate: o,
          enabled: l,
          animating: d,
        } = i;
      if (!l || i.destroyed) return i;
      void 0 === e && (e = i.params.speed);
      const c = i.virtual && r.virtual.enabled;
      if (r.loop) {
        if (d && !c && r.loopPreventsSliding) return !1;
        i.loopFix({ direction: "prev" }),
          (i._clientLeft = i.wrapperEl.clientLeft);
      }
      function p(e) {
        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
      }
      const u = p(o ? i.translate : -i.translate),
        m = a.map((e) => p(e));
      let f = a[m.indexOf(u) - 1];
      if (void 0 === f && r.cssMode) {
        let e;
        a.forEach((t, s) => {
          u >= t && (e = s);
        }),
          void 0 !== e && (f = a[e > 0 ? e - 1 : e]);
      }
      let h = 0;
      if (
        (void 0 !== f &&
          ((h = n.indexOf(f)),
          h < 0 && (h = i.activeIndex - 1),
          "auto" === r.slidesPerView &&
            1 === r.slidesPerGroup &&
            r.slidesPerGroupAuto &&
            ((h = h - i.slidesPerViewDynamic("previous", !0) + 1),
            (h = Math.max(h, 0)))),
        r.rewind && i.isBeginning)
      ) {
        const r =
          i.params.virtual && i.params.virtual.enabled && i.virtual
            ? i.virtual.slides.length - 1
            : i.slides.length - 1;
        return i.slideTo(r, e, t, s);
      }
      return r.loop && 0 === i.activeIndex && r.cssMode
        ? (requestAnimationFrame(() => {
            i.slideTo(h, e, t, s);
          }),
          !0)
        : i.slideTo(h, e, t, s);
    },
    slideReset: function (e, t, s) {
      void 0 === t && (t = !0);
      const i = this;
      if (!i.destroyed)
        return (
          void 0 === e && (e = i.params.speed),
          i.slideTo(i.activeIndex, e, t, s)
        );
    },
    slideToClosest: function (e, t, s, i) {
      void 0 === t && (t = !0), void 0 === i && (i = 0.5);
      const r = this;
      if (r.destroyed) return;
      void 0 === e && (e = r.params.speed);
      let a = r.activeIndex;
      const n = Math.min(r.params.slidesPerGroupSkip, a),
        o = n + Math.floor((a - n) / r.params.slidesPerGroup),
        l = r.rtlTranslate ? r.translate : -r.translate;
      if (l >= r.snapGrid[o]) {
        const e = r.snapGrid[o];
        l - e > (r.snapGrid[o + 1] - e) * i && (a += r.params.slidesPerGroup);
      } else {
        const e = r.snapGrid[o - 1];
        l - e <= (r.snapGrid[o] - e) * i && (a -= r.params.slidesPerGroup);
      }
      return (
        (a = Math.max(a, 0)),
        (a = Math.min(a, r.slidesGrid.length - 1)),
        r.slideTo(a, e, t, s)
      );
    },
    slideToClickedSlide: function () {
      const e = this;
      if (e.destroyed) return;
      const { params: t, slidesEl: s } = e,
        i =
          "auto" === t.slidesPerView
            ? e.slidesPerViewDynamic()
            : t.slidesPerView;
      let r,
        a = e.clickedIndex;
      const n = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
      if (t.loop) {
        if (e.animating) return;
        (r = parseInt(
          e.clickedSlide.getAttribute("data-swiper-slide-index"),
          10
        )),
          t.centeredSlides
            ? a < e.loopedSlides - i / 2 ||
              a > e.slides.length - e.loopedSlides + i / 2
              ? (e.loopFix(),
                (a = e.getSlideIndex(
                  w(s, `${n}[data-swiper-slide-index="${r}"]`)[0]
                )),
                c(() => {
                  e.slideTo(a);
                }))
              : e.slideTo(a)
            : a > e.slides.length - i
            ? (e.loopFix(),
              (a = e.getSlideIndex(
                w(s, `${n}[data-swiper-slide-index="${r}"]`)[0]
              )),
              c(() => {
                e.slideTo(a);
              }))
            : e.slideTo(a);
      } else e.slideTo(a);
    },
  };
  var F = {
    loopCreate: function (e) {
      const t = this,
        { params: s, slidesEl: i } = t;
      if (!s.loop || (t.virtual && t.params.virtual.enabled)) return;
      const r = () => {
          w(i, `.${s.slideClass}, swiper-slide`).forEach((e, t) => {
            e.setAttribute("data-swiper-slide-index", t);
          });
        },
        a = t.grid && s.grid && s.grid.rows > 1,
        n = s.slidesPerGroup * (a ? s.grid.rows : 1),
        o = t.slides.length % n != 0,
        l = a && t.slides.length % s.grid.rows != 0,
        d = (e) => {
          for (let i = 0; i < e; i += 1) {
            const e = t.isElement
              ? b("swiper-slide", [s.slideBlankClass])
              : b("div", [s.slideClass, s.slideBlankClass]);
            t.slidesEl.append(e);
          }
        };
      if (o) {
        if (s.loopAddBlankSlides) {
          d(n - (t.slides.length % n)), t.recalcSlides(), t.updateSlides();
        } else
          y(
            "Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"
          );
        r();
      } else if (l) {
        if (s.loopAddBlankSlides) {
          d(s.grid.rows - (t.slides.length % s.grid.rows)),
            t.recalcSlides(),
            t.updateSlides();
        } else
          y(
            "Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"
          );
        r();
      } else r();
      t.loopFix({
        slideRealIndex: e,
        direction: s.centeredSlides ? void 0 : "next",
      });
    },
    loopFix: function (e) {
      let {
        slideRealIndex: t,
        slideTo: s = !0,
        direction: i,
        setTranslate: r,
        activeSlideIndex: a,
        byController: n,
        byMousewheel: o,
      } = void 0 === e ? {} : e;
      const l = this;
      if (!l.params.loop) return;
      l.emit("beforeLoopFix");
      const {
          slides: d,
          allowSlidePrev: c,
          allowSlideNext: p,
          slidesEl: u,
          params: m,
        } = l,
        { centeredSlides: f } = m;
      if (
        ((l.allowSlidePrev = !0),
        (l.allowSlideNext = !0),
        l.virtual && m.virtual.enabled)
      )
        return (
          s &&
            (m.centeredSlides || 0 !== l.snapIndex
              ? m.centeredSlides && l.snapIndex < m.slidesPerView
                ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0)
                : l.snapIndex === l.snapGrid.length - 1 &&
                  l.slideTo(l.virtual.slidesBefore, 0, !1, !0)
              : l.slideTo(l.virtual.slides.length, 0, !1, !0)),
          (l.allowSlidePrev = c),
          (l.allowSlideNext = p),
          void l.emit("loopFix")
        );
      let h = m.slidesPerView;
      "auto" === h
        ? (h = l.slidesPerViewDynamic())
        : ((h = Math.ceil(parseFloat(m.slidesPerView, 10))),
          f && h % 2 == 0 && (h += 1));
      const v = m.slidesPerGroupAuto ? h : m.slidesPerGroup;
      let g = v;
      g % v != 0 && (g += v - (g % v)),
        (g += m.loopAdditionalSlides),
        (l.loopedSlides = g);
      const w = l.grid && m.grid && m.grid.rows > 1;
      d.length < h + g
        ? y(
            "Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"
          )
        : w &&
          "row" === m.grid.fill &&
          y(
            "Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`"
          );
      const b = [],
        E = [];
      let x = l.activeIndex;
      void 0 === a
        ? (a = l.getSlideIndex(
            d.filter((e) => e.classList.contains(m.slideActiveClass))[0]
          ))
        : (x = a);
      const S = "next" === i || !i,
        T = "prev" === i || !i;
      let M = 0,
        C = 0;
      const L = w ? Math.ceil(d.length / m.grid.rows) : d.length,
        P = (w ? d[a].column : a) + (f && void 0 === r ? -h / 2 + 0.5 : 0);
      if (P < g) {
        M = Math.max(g - P, v);
        for (let e = 0; e < g - P; e += 1) {
          const t = e - Math.floor(e / L) * L;
          if (w) {
            const e = L - t - 1;
            for (let t = d.length - 1; t >= 0; t -= 1)
              d[t].column === e && b.push(t);
          } else b.push(L - t - 1);
        }
      } else if (P + h > L - g) {
        C = Math.max(P - (L - 2 * g), v);
        for (let e = 0; e < C; e += 1) {
          const t = e - Math.floor(e / L) * L;
          w
            ? d.forEach((e, s) => {
                e.column === t && E.push(s);
              })
            : E.push(t);
        }
      }
      if (
        ((l.__preventObserver__ = !0),
        requestAnimationFrame(() => {
          l.__preventObserver__ = !1;
        }),
        T &&
          b.forEach((e) => {
            (d[e].swiperLoopMoveDOM = !0),
              u.prepend(d[e]),
              (d[e].swiperLoopMoveDOM = !1);
          }),
        S &&
          E.forEach((e) => {
            (d[e].swiperLoopMoveDOM = !0),
              u.append(d[e]),
              (d[e].swiperLoopMoveDOM = !1);
          }),
        l.recalcSlides(),
        "auto" === m.slidesPerView
          ? l.updateSlides()
          : w &&
            ((b.length > 0 && T) || (E.length > 0 && S)) &&
            l.slides.forEach((e, t) => {
              l.grid.updateSlide(t, e, l.slides);
            }),
        m.watchSlidesProgress && l.updateSlidesOffset(),
        s)
      )
        if (b.length > 0 && T) {
          if (void 0 === t) {
            const e = l.slidesGrid[x],
              t = l.slidesGrid[x + M] - e;
            o
              ? l.setTranslate(l.translate - t)
              : (l.slideTo(x + Math.ceil(M), 0, !1, !0),
                r &&
                  ((l.touchEventsData.startTranslate =
                    l.touchEventsData.startTranslate - t),
                  (l.touchEventsData.currentTranslate =
                    l.touchEventsData.currentTranslate - t)));
          } else if (r) {
            const e = w ? b.length / m.grid.rows : b.length;
            l.slideTo(l.activeIndex + e, 0, !1, !0),
              (l.touchEventsData.currentTranslate = l.translate);
          }
        } else if (E.length > 0 && S)
          if (void 0 === t) {
            const e = l.slidesGrid[x],
              t = l.slidesGrid[x - C] - e;
            o
              ? l.setTranslate(l.translate - t)
              : (l.slideTo(x - C, 0, !1, !0),
                r &&
                  ((l.touchEventsData.startTranslate =
                    l.touchEventsData.startTranslate - t),
                  (l.touchEventsData.currentTranslate =
                    l.touchEventsData.currentTranslate - t)));
          } else {
            const e = w ? E.length / m.grid.rows : E.length;
            l.slideTo(l.activeIndex - e, 0, !1, !0);
          }
      if (
        ((l.allowSlidePrev = c),
        (l.allowSlideNext = p),
        l.controller && l.controller.control && !n)
      ) {
        const e = {
          slideRealIndex: t,
          direction: i,
          setTranslate: r,
          activeSlideIndex: a,
          byController: !0,
        };
        Array.isArray(l.controller.control)
          ? l.controller.control.forEach((t) => {
              !t.destroyed &&
                t.params.loop &&
                t.loopFix({
                  ...e,
                  slideTo: t.params.slidesPerView === m.slidesPerView && s,
                });
            })
          : l.controller.control instanceof l.constructor &&
            l.controller.control.params.loop &&
            l.controller.control.loopFix({
              ...e,
              slideTo:
                l.controller.control.params.slidesPerView === m.slidesPerView &&
                s,
            });
      }
      l.emit("loopFix");
    },
    loopDestroy: function () {
      const e = this,
        { params: t, slidesEl: s } = e;
      if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
      e.recalcSlides();
      const i = [];
      e.slides.forEach((e) => {
        const t =
          void 0 === e.swiperSlideIndex
            ? 1 * e.getAttribute("data-swiper-slide-index")
            : e.swiperSlideIndex;
        i[t] = e;
      }),
        e.slides.forEach((e) => {
          e.removeAttribute("data-swiper-slide-index");
        }),
        i.forEach((e) => {
          s.append(e);
        }),
        e.recalcSlides(),
        e.slideTo(e.realIndex, 0);
    },
  };
  function R(e, t, s) {
    const i = l(),
      { params: r } = e,
      a = r.edgeSwipeDetection,
      n = r.edgeSwipeThreshold;
    return (
      !a ||
      !(s <= n || s >= i.innerWidth - n) ||
      ("prevent" === a && (t.preventDefault(), !0))
    );
  }
  function j(e) {
    const t = this,
      s = n();
    let i = e;
    i.originalEvent && (i = i.originalEvent);
    const r = t.touchEventsData;
    if ("pointerdown" === i.type) {
      if (null !== r.pointerId && r.pointerId !== i.pointerId) return;
      r.pointerId = i.pointerId;
    } else
      "touchstart" === i.type &&
        1 === i.targetTouches.length &&
        (r.touchId = i.targetTouches[0].identifier);
    if ("touchstart" === i.type) return void R(t, i, i.targetTouches[0].pageX);
    const { params: a, touches: o, enabled: d } = t;
    if (!d) return;
    if (!a.simulateTouch && "mouse" === i.pointerType) return;
    if (t.animating && a.preventInteractionOnTransition) return;
    !t.animating && a.cssMode && a.loop && t.loopFix();
    let c = i.target;
    if (
      "wrapper" === a.touchEventsTarget &&
      !(function (e, t) {
        const s = t.contains(e);
        if (!s && t instanceof HTMLSlotElement)
          return [...t.assignedElements()].includes(e);
        return s;
      })(c, t.wrapperEl)
    )
      return;
    if ("which" in i && 3 === i.which) return;
    if ("button" in i && i.button > 0) return;
    if (r.isTouched && r.isMoved) return;
    const u = !!a.noSwipingClass && "" !== a.noSwipingClass,
      m = i.composedPath ? i.composedPath() : i.path;
    u && i.target && i.target.shadowRoot && m && (c = m[0]);
    const f = a.noSwipingSelector
        ? a.noSwipingSelector
        : `.${a.noSwipingClass}`,
      h = !(!i.target || !i.target.shadowRoot);
    if (
      a.noSwiping &&
      (h
        ? (function (e, t) {
            return (
              void 0 === t && (t = this),
              (function t(s) {
                if (!s || s === n() || s === l()) return null;
                s.assignedSlot && (s = s.assignedSlot);
                const i = s.closest(e);
                return i || s.getRootNode ? i || t(s.getRootNode().host) : null;
              })(t)
            );
          })(f, c)
        : c.closest(f))
    )
      return void (t.allowClick = !0);
    if (a.swipeHandler && !c.closest(a.swipeHandler)) return;
    (o.currentX = i.pageX), (o.currentY = i.pageY);
    const v = o.currentX,
      g = o.currentY;
    if (!R(t, i, v)) return;
    Object.assign(r, {
      isTouched: !0,
      isMoved: !1,
      allowTouchCallbacks: !0,
      isScrolling: void 0,
      startMoving: void 0,
    }),
      (o.startX = v),
      (o.startY = g),
      (r.touchStartTime = p()),
      (t.allowClick = !0),
      t.updateSize(),
      (t.swipeDirection = void 0),
      a.threshold > 0 && (r.allowThresholdMove = !1);
    let w = !0;
    c.matches(r.focusableElements) &&
      ((w = !1), "SELECT" === c.nodeName && (r.isTouched = !1)),
      s.activeElement &&
        s.activeElement.matches(r.focusableElements) &&
        s.activeElement !== c &&
        ("mouse" === i.pointerType ||
          ("mouse" !== i.pointerType && !c.matches(r.focusableElements))) &&
        s.activeElement.blur();
    const y = w && t.allowTouchMove && a.touchStartPreventDefault;
    (!a.touchStartForcePreventDefault && !y) ||
      c.isContentEditable ||
      i.preventDefault(),
      a.freeMode &&
        a.freeMode.enabled &&
        t.freeMode &&
        t.animating &&
        !a.cssMode &&
        t.freeMode.onTouchStart(),
      t.emit("touchStart", i);
  }
  function W(e) {
    const t = n(),
      s = this,
      i = s.touchEventsData,
      { params: r, touches: a, rtlTranslate: o, enabled: l } = s;
    if (!l) return;
    if (!r.simulateTouch && "mouse" === e.pointerType) return;
    let d,
      c = e;
    if ((c.originalEvent && (c = c.originalEvent), "pointermove" === c.type)) {
      if (null !== i.touchId) return;
      if (c.pointerId !== i.pointerId) return;
    }
    if ("touchmove" === c.type) {
      if (
        ((d = [...c.changedTouches].filter(
          (e) => e.identifier === i.touchId
        )[0]),
        !d || d.identifier !== i.touchId)
      )
        return;
    } else d = c;
    if (!i.isTouched)
      return void (
        i.startMoving &&
        i.isScrolling &&
        s.emit("touchMoveOpposite", c)
      );
    const u = d.pageX,
      m = d.pageY;
    if (c.preventedByNestedSwiper) return (a.startX = u), void (a.startY = m);
    if (!s.allowTouchMove)
      return (
        c.target.matches(i.focusableElements) || (s.allowClick = !1),
        void (
          i.isTouched &&
          (Object.assign(a, { startX: u, startY: m, currentX: u, currentY: m }),
          (i.touchStartTime = p()))
        )
      );
    if (r.touchReleaseOnEdges && !r.loop)
      if (s.isVertical()) {
        if (
          (m < a.startY && s.translate <= s.maxTranslate()) ||
          (m > a.startY && s.translate >= s.minTranslate())
        )
          return (i.isTouched = !1), void (i.isMoved = !1);
      } else if (
        (u < a.startX && s.translate <= s.maxTranslate()) ||
        (u > a.startX && s.translate >= s.minTranslate())
      )
        return;
    if (
      (t.activeElement &&
        t.activeElement.matches(i.focusableElements) &&
        t.activeElement !== c.target &&
        "mouse" !== c.pointerType &&
        t.activeElement.blur(),
      t.activeElement &&
        c.target === t.activeElement &&
        c.target.matches(i.focusableElements))
    )
      return (i.isMoved = !0), void (s.allowClick = !1);
    i.allowTouchCallbacks && s.emit("touchMove", c),
      (a.previousX = a.currentX),
      (a.previousY = a.currentY),
      (a.currentX = u),
      (a.currentY = m);
    const f = a.currentX - a.startX,
      h = a.currentY - a.startY;
    if (s.params.threshold && Math.sqrt(f ** 2 + h ** 2) < s.params.threshold)
      return;
    if (void 0 === i.isScrolling) {
      let e;
      (s.isHorizontal() && a.currentY === a.startY) ||
      (s.isVertical() && a.currentX === a.startX)
        ? (i.isScrolling = !1)
        : f * f + h * h >= 25 &&
          ((e = (180 * Math.atan2(Math.abs(h), Math.abs(f))) / Math.PI),
          (i.isScrolling = s.isHorizontal()
            ? e > r.touchAngle
            : 90 - e > r.touchAngle));
    }
    if (
      (i.isScrolling && s.emit("touchMoveOpposite", c),
      void 0 === i.startMoving &&
        ((a.currentX === a.startX && a.currentY === a.startY) ||
          (i.startMoving = !0)),
      i.isScrolling ||
        ("touchmove" === c.type && i.preventTouchMoveFromPointerMove))
    )
      return void (i.isTouched = !1);
    if (!i.startMoving) return;
    (s.allowClick = !1),
      !r.cssMode && c.cancelable && c.preventDefault(),
      r.touchMoveStopPropagation && !r.nested && c.stopPropagation();
    let v = s.isHorizontal() ? f : h,
      g = s.isHorizontal()
        ? a.currentX - a.previousX
        : a.currentY - a.previousY;
    r.oneWayMovement &&
      ((v = Math.abs(v) * (o ? 1 : -1)), (g = Math.abs(g) * (o ? 1 : -1))),
      (a.diff = v),
      (v *= r.touchRatio),
      o && ((v = -v), (g = -g));
    const w = s.touchesDirection;
    (s.swipeDirection = v > 0 ? "prev" : "next"),
      (s.touchesDirection = g > 0 ? "prev" : "next");
    const y = s.params.loop && !r.cssMode,
      b =
        ("next" === s.touchesDirection && s.allowSlideNext) ||
        ("prev" === s.touchesDirection && s.allowSlidePrev);
    if (!i.isMoved) {
      if (
        (y && b && s.loopFix({ direction: s.swipeDirection }),
        (i.startTranslate = s.getTranslate()),
        s.setTransition(0),
        s.animating)
      ) {
        const e = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0,
          detail: { bySwiperTouchMove: !0 },
        });
        s.wrapperEl.dispatchEvent(e);
      }
      (i.allowMomentumBounce = !1),
        !r.grabCursor ||
          (!0 !== s.allowSlideNext && !0 !== s.allowSlidePrev) ||
          s.setGrabCursor(!0),
        s.emit("sliderFirstMove", c);
    }
    if (
      (new Date().getTime(),
      i.isMoved &&
        i.allowThresholdMove &&
        w !== s.touchesDirection &&
        y &&
        b &&
        Math.abs(v) >= 1)
    )
      return (
        Object.assign(a, {
          startX: u,
          startY: m,
          currentX: u,
          currentY: m,
          startTranslate: i.currentTranslate,
        }),
        (i.loopSwapReset = !0),
        void (i.startTranslate = i.currentTranslate)
      );
    s.emit("sliderMove", c),
      (i.isMoved = !0),
      (i.currentTranslate = v + i.startTranslate);
    let E = !0,
      x = r.resistanceRatio;
    if (
      (r.touchReleaseOnEdges && (x = 0),
      v > 0
        ? (y &&
            b &&
            i.allowThresholdMove &&
            i.currentTranslate >
              (r.centeredSlides
                ? s.minTranslate() -
                  s.slidesSizesGrid[s.activeIndex + 1] -
                  ("auto" !== r.slidesPerView &&
                  s.slides.length - r.slidesPerView >= 2
                    ? s.slidesSizesGrid[s.activeIndex + 1] +
                      s.params.spaceBetween
                    : 0) -
                  s.params.spaceBetween
                : s.minTranslate()) &&
            s.loopFix({
              direction: "prev",
              setTranslate: !0,
              activeSlideIndex: 0,
            }),
          i.currentTranslate > s.minTranslate() &&
            ((E = !1),
            r.resistance &&
              (i.currentTranslate =
                s.minTranslate() -
                1 +
                (-s.minTranslate() + i.startTranslate + v) ** x)))
        : v < 0 &&
          (y &&
            b &&
            i.allowThresholdMove &&
            i.currentTranslate <
              (r.centeredSlides
                ? s.maxTranslate() +
                  s.slidesSizesGrid[s.slidesSizesGrid.length - 1] +
                  s.params.spaceBetween +
                  ("auto" !== r.slidesPerView &&
                  s.slides.length - r.slidesPerView >= 2
                    ? s.slidesSizesGrid[s.slidesSizesGrid.length - 1] +
                      s.params.spaceBetween
                    : 0)
                : s.maxTranslate()) &&
            s.loopFix({
              direction: "next",
              setTranslate: !0,
              activeSlideIndex:
                s.slides.length -
                ("auto" === r.slidesPerView
                  ? s.slidesPerViewDynamic()
                  : Math.ceil(parseFloat(r.slidesPerView, 10))),
            }),
          i.currentTranslate < s.maxTranslate() &&
            ((E = !1),
            r.resistance &&
              (i.currentTranslate =
                s.maxTranslate() +
                1 -
                (s.maxTranslate() - i.startTranslate - v) ** x))),
      E && (c.preventedByNestedSwiper = !0),
      !s.allowSlideNext &&
        "next" === s.swipeDirection &&
        i.currentTranslate < i.startTranslate &&
        (i.currentTranslate = i.startTranslate),
      !s.allowSlidePrev &&
        "prev" === s.swipeDirection &&
        i.currentTranslate > i.startTranslate &&
        (i.currentTranslate = i.startTranslate),
      s.allowSlidePrev ||
        s.allowSlideNext ||
        (i.currentTranslate = i.startTranslate),
      r.threshold > 0)
    ) {
      if (!(Math.abs(v) > r.threshold || i.allowThresholdMove))
        return void (i.currentTranslate = i.startTranslate);
      if (!i.allowThresholdMove)
        return (
          (i.allowThresholdMove = !0),
          (a.startX = a.currentX),
          (a.startY = a.currentY),
          (i.currentTranslate = i.startTranslate),
          void (a.diff = s.isHorizontal()
            ? a.currentX - a.startX
            : a.currentY - a.startY)
        );
    }
    r.followFinger &&
      !r.cssMode &&
      (((r.freeMode && r.freeMode.enabled && s.freeMode) ||
        r.watchSlidesProgress) &&
        (s.updateActiveIndex(), s.updateSlidesClasses()),
      r.freeMode &&
        r.freeMode.enabled &&
        s.freeMode &&
        s.freeMode.onTouchMove(),
      s.updateProgress(i.currentTranslate),
      s.setTranslate(i.currentTranslate));
  }
  function U(e) {
    const t = this,
      s = t.touchEventsData;
    let i,
      r = e;
    r.originalEvent && (r = r.originalEvent);
    if ("touchend" === r.type || "touchcancel" === r.type) {
      if (
        ((i = [...r.changedTouches].filter(
          (e) => e.identifier === s.touchId
        )[0]),
        !i || i.identifier !== s.touchId)
      )
        return;
    } else {
      if (null !== s.touchId) return;
      if (r.pointerId !== s.pointerId) return;
      i = r;
    }
    if (
      ["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(
        r.type
      )
    ) {
      if (
        !(
          ["pointercancel", "contextmenu"].includes(r.type) &&
          (t.browser.isSafari || t.browser.isWebView)
        )
      )
        return;
    }
    (s.pointerId = null), (s.touchId = null);
    const {
      params: a,
      touches: n,
      rtlTranslate: o,
      slidesGrid: l,
      enabled: d,
    } = t;
    if (!d) return;
    if (!a.simulateTouch && "mouse" === r.pointerType) return;
    if (
      (s.allowTouchCallbacks && t.emit("touchEnd", r),
      (s.allowTouchCallbacks = !1),
      !s.isTouched)
    )
      return (
        s.isMoved && a.grabCursor && t.setGrabCursor(!1),
        (s.isMoved = !1),
        void (s.startMoving = !1)
      );
    a.grabCursor &&
      s.isMoved &&
      s.isTouched &&
      (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
      t.setGrabCursor(!1);
    const u = p(),
      m = u - s.touchStartTime;
    if (t.allowClick) {
      const e = r.path || (r.composedPath && r.composedPath());
      t.updateClickedSlide((e && e[0]) || r.target, e),
        t.emit("tap click", r),
        m < 300 &&
          u - s.lastClickTime < 300 &&
          t.emit("doubleTap doubleClick", r);
    }
    if (
      ((s.lastClickTime = p()),
      c(() => {
        t.destroyed || (t.allowClick = !0);
      }),
      !s.isTouched ||
        !s.isMoved ||
        !t.swipeDirection ||
        (0 === n.diff && !s.loopSwapReset) ||
        (s.currentTranslate === s.startTranslate && !s.loopSwapReset))
    )
      return (s.isTouched = !1), (s.isMoved = !1), void (s.startMoving = !1);
    let f;
    if (
      ((s.isTouched = !1),
      (s.isMoved = !1),
      (s.startMoving = !1),
      (f = a.followFinger
        ? o
          ? t.translate
          : -t.translate
        : -s.currentTranslate),
      a.cssMode)
    )
      return;
    if (a.freeMode && a.freeMode.enabled)
      return void t.freeMode.onTouchEnd({ currentPos: f });
    const h = f >= -t.maxTranslate() && !t.params.loop;
    let v = 0,
      g = t.slidesSizesGrid[0];
    for (
      let e = 0;
      e < l.length;
      e += e < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup
    ) {
      const t = e < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
      void 0 !== l[e + t]
        ? (h || (f >= l[e] && f < l[e + t])) && ((v = e), (g = l[e + t] - l[e]))
        : (h || f >= l[e]) &&
          ((v = e), (g = l[l.length - 1] - l[l.length - 2]));
    }
    let w = null,
      y = null;
    a.rewind &&
      (t.isBeginning
        ? (y =
            a.virtual && a.virtual.enabled && t.virtual
              ? t.virtual.slides.length - 1
              : t.slides.length - 1)
        : t.isEnd && (w = 0));
    const b = (f - l[v]) / g,
      E = v < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
    if (m > a.longSwipesMs) {
      if (!a.longSwipes) return void t.slideTo(t.activeIndex);
      "next" === t.swipeDirection &&
        (b >= a.longSwipesRatio
          ? t.slideTo(a.rewind && t.isEnd ? w : v + E)
          : t.slideTo(v)),
        "prev" === t.swipeDirection &&
          (b > 1 - a.longSwipesRatio
            ? t.slideTo(v + E)
            : null !== y && b < 0 && Math.abs(b) > a.longSwipesRatio
            ? t.slideTo(y)
            : t.slideTo(v));
    } else {
      if (!a.shortSwipes) return void t.slideTo(t.activeIndex);
      t.navigation &&
      (r.target === t.navigation.nextEl || r.target === t.navigation.prevEl)
        ? r.target === t.navigation.nextEl
          ? t.slideTo(v + E)
          : t.slideTo(v)
        : ("next" === t.swipeDirection && t.slideTo(null !== w ? w : v + E),
          "prev" === t.swipeDirection && t.slideTo(null !== y ? y : v));
    }
  }
  function K() {
    const e = this,
      { params: t, el: s } = e;
    if (s && 0 === s.offsetWidth) return;
    t.breakpoints && e.setBreakpoint();
    const { allowSlideNext: i, allowSlidePrev: r, snapGrid: a } = e,
      n = e.virtual && e.params.virtual.enabled;
    (e.allowSlideNext = !0),
      (e.allowSlidePrev = !0),
      e.updateSize(),
      e.updateSlides(),
      e.updateSlidesClasses();
    const o = n && t.loop;
    !("auto" === t.slidesPerView || t.slidesPerView > 1) ||
    !e.isEnd ||
    e.isBeginning ||
    e.params.centeredSlides ||
    o
      ? e.params.loop && !n
        ? e.slideToLoop(e.realIndex, 0, !1, !0)
        : e.slideTo(e.activeIndex, 0, !1, !0)
      : e.slideTo(e.slides.length - 1, 0, !1, !0),
      e.autoplay &&
        e.autoplay.running &&
        e.autoplay.paused &&
        (clearTimeout(e.autoplay.resizeTimeout),
        (e.autoplay.resizeTimeout = setTimeout(() => {
          e.autoplay &&
            e.autoplay.running &&
            e.autoplay.paused &&
            e.autoplay.resume();
        }, 500))),
      (e.allowSlidePrev = r),
      (e.allowSlideNext = i),
      e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow();
  }
  function Z(e) {
    const t = this;
    t.enabled &&
      (t.allowClick ||
        (t.params.preventClicks && e.preventDefault(),
        t.params.preventClicksPropagation &&
          t.animating &&
          (e.stopPropagation(), e.stopImmediatePropagation())));
  }
  function Q() {
    const e = this,
      { wrapperEl: t, rtlTranslate: s, enabled: i } = e;
    if (!i) return;
    let r;
    (e.previousTranslate = e.translate),
      e.isHorizontal()
        ? (e.translate = -t.scrollLeft)
        : (e.translate = -t.scrollTop),
      0 === e.translate && (e.translate = 0),
      e.updateActiveIndex(),
      e.updateSlidesClasses();
    const a = e.maxTranslate() - e.minTranslate();
    (r = 0 === a ? 0 : (e.translate - e.minTranslate()) / a),
      r !== e.progress && e.updateProgress(s ? -e.translate : e.translate),
      e.emit("setTranslate", e.translate, !1);
  }
  function J(e) {
    const t = this;
    G(t, e.target),
      t.params.cssMode ||
        ("auto" !== t.params.slidesPerView && !t.params.autoHeight) ||
        t.update();
  }
  function ee() {
    const e = this;
    e.documentTouchHandlerProceeded ||
      ((e.documentTouchHandlerProceeded = !0),
      e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
  }
  const te = (e, t) => {
    const s = n(),
      { params: i, el: r, wrapperEl: a, device: o } = e,
      l = !!i.nested,
      d = "on" === t ? "addEventListener" : "removeEventListener",
      c = t;
    r &&
      "string" != typeof r &&
      (s[d]("touchstart", e.onDocumentTouchStart, { passive: !1, capture: l }),
      r[d]("touchstart", e.onTouchStart, { passive: !1 }),
      r[d]("pointerdown", e.onTouchStart, { passive: !1 }),
      s[d]("touchmove", e.onTouchMove, { passive: !1, capture: l }),
      s[d]("pointermove", e.onTouchMove, { passive: !1, capture: l }),
      s[d]("touchend", e.onTouchEnd, { passive: !0 }),
      s[d]("pointerup", e.onTouchEnd, { passive: !0 }),
      s[d]("pointercancel", e.onTouchEnd, { passive: !0 }),
      s[d]("touchcancel", e.onTouchEnd, { passive: !0 }),
      s[d]("pointerout", e.onTouchEnd, { passive: !0 }),
      s[d]("pointerleave", e.onTouchEnd, { passive: !0 }),
      s[d]("contextmenu", e.onTouchEnd, { passive: !0 }),
      (i.preventClicks || i.preventClicksPropagation) &&
        r[d]("click", e.onClick, !0),
      i.cssMode && a[d]("scroll", e.onScroll),
      i.updateOnWindowResize
        ? e[c](
            o.ios || o.android
              ? "resize orientationchange observerUpdate"
              : "resize observerUpdate",
            K,
            !0
          )
        : e[c]("observerUpdate", K, !0),
      r[d]("load", e.onLoad, { capture: !0 }));
  };
  const se = (e, t) => e.grid && t.grid && t.grid.rows > 1;
  var ie = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
  function re(e, t) {
    return function (s) {
      void 0 === s && (s = {});
      const i = Object.keys(s)[0],
        r = s[i];
      "object" == typeof r && null !== r
        ? (!0 === e[i] && (e[i] = { enabled: !0 }),
          "navigation" === i &&
            e[i] &&
            e[i].enabled &&
            !e[i].prevEl &&
            !e[i].nextEl &&
            (e[i].auto = !0),
          ["pagination", "scrollbar"].indexOf(i) >= 0 &&
            e[i] &&
            e[i].enabled &&
            !e[i].el &&
            (e[i].auto = !0),
          i in e && "enabled" in r
            ? ("object" != typeof e[i] ||
                "enabled" in e[i] ||
                (e[i].enabled = !0),
              e[i] || (e[i] = { enabled: !1 }),
              f(t, s))
            : f(t, s))
        : f(t, s);
    };
  }
  const ae = {
      eventsEmitter: D,
      update: V,
      translate: H,
      transition: {
        setTransition: function (e, t) {
          const s = this;
          s.params.cssMode ||
            ((s.wrapperEl.style.transitionDuration = `${e}ms`),
            (s.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : "")),
            s.emit("setTransition", e, t);
        },
        transitionStart: function (e, t) {
          void 0 === e && (e = !0);
          const s = this,
            { params: i } = s;
          i.cssMode ||
            (i.autoHeight && s.updateAutoHeight(),
            X({ swiper: s, runCallbacks: e, direction: t, step: "Start" }));
        },
        transitionEnd: function (e, t) {
          void 0 === e && (e = !0);
          const s = this,
            { params: i } = s;
          (s.animating = !1),
            i.cssMode ||
              (s.setTransition(0),
              X({ swiper: s, runCallbacks: e, direction: t, step: "End" }));
        },
      },
      slide: Y,
      loop: F,
      grabCursor: {
        setGrabCursor: function (e) {
          const t = this;
          if (
            !t.params.simulateTouch ||
            (t.params.watchOverflow && t.isLocked) ||
            t.params.cssMode
          )
            return;
          const s =
            "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
          t.isElement && (t.__preventObserver__ = !0),
            (s.style.cursor = "move"),
            (s.style.cursor = e ? "grabbing" : "grab"),
            t.isElement &&
              requestAnimationFrame(() => {
                t.__preventObserver__ = !1;
              });
        },
        unsetGrabCursor: function () {
          const e = this;
          (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e.isElement && (e.__preventObserver__ = !0),
            (e[
              "container" === e.params.touchEventsTarget ? "el" : "wrapperEl"
            ].style.cursor = ""),
            e.isElement &&
              requestAnimationFrame(() => {
                e.__preventObserver__ = !1;
              }));
        },
      },
      events: {
        attachEvents: function () {
          const e = this,
            { params: t } = e;
          (e.onTouchStart = j.bind(e)),
            (e.onTouchMove = W.bind(e)),
            (e.onTouchEnd = U.bind(e)),
            (e.onDocumentTouchStart = ee.bind(e)),
            t.cssMode && (e.onScroll = Q.bind(e)),
            (e.onClick = Z.bind(e)),
            (e.onLoad = J.bind(e)),
            te(e, "on");
        },
        detachEvents: function () {
          te(this, "off");
        },
      },
      breakpoints: {
        setBreakpoint: function () {
          const e = this,
            { realIndex: t, initialized: s, params: i, el: r } = e,
            a = i.breakpoints;
          if (!a || (a && 0 === Object.keys(a).length)) return;
          const n = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
          if (!n || e.currentBreakpoint === n) return;
          const o = (n in a ? a[n] : void 0) || e.originalParams,
            l = se(e, i),
            d = se(e, o),
            c = e.params.grabCursor,
            p = o.grabCursor,
            u = i.enabled;
          l && !d
            ? (r.classList.remove(
                `${i.containerModifierClass}grid`,
                `${i.containerModifierClass}grid-column`
              ),
              e.emitContainerClasses())
            : !l &&
              d &&
              (r.classList.add(`${i.containerModifierClass}grid`),
              ((o.grid.fill && "column" === o.grid.fill) ||
                (!o.grid.fill && "column" === i.grid.fill)) &&
                r.classList.add(`${i.containerModifierClass}grid-column`),
              e.emitContainerClasses()),
            c && !p ? e.unsetGrabCursor() : !c && p && e.setGrabCursor(),
            ["navigation", "pagination", "scrollbar"].forEach((t) => {
              if (void 0 === o[t]) return;
              const s = i[t] && i[t].enabled,
                r = o[t] && o[t].enabled;
              s && !r && e[t].disable(), !s && r && e[t].enable();
            });
          const m = o.direction && o.direction !== i.direction,
            h = i.loop && (o.slidesPerView !== i.slidesPerView || m),
            v = i.loop;
          m && s && e.changeDirection(), f(e.params, o);
          const g = e.params.enabled,
            w = e.params.loop;
          Object.assign(e, {
            allowTouchMove: e.params.allowTouchMove,
            allowSlideNext: e.params.allowSlideNext,
            allowSlidePrev: e.params.allowSlidePrev,
          }),
            u && !g ? e.disable() : !u && g && e.enable(),
            (e.currentBreakpoint = n),
            e.emit("_beforeBreakpoint", o),
            s &&
              (h
                ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides())
                : !v && w
                ? (e.loopCreate(t), e.updateSlides())
                : v && !w && e.loopDestroy()),
            e.emit("breakpoint", o);
        },
        getBreakpoint: function (e, t, s) {
          if ((void 0 === t && (t = "window"), !e || ("container" === t && !s)))
            return;
          let i = !1;
          const r = l(),
            a = "window" === t ? r.innerHeight : s.clientHeight,
            n = Object.keys(e).map((e) => {
              if ("string" == typeof e && 0 === e.indexOf("@")) {
                const t = parseFloat(e.substr(1));
                return { value: a * t, point: e };
              }
              return { value: e, point: e };
            });
          n.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
          for (let e = 0; e < n.length; e += 1) {
            const { point: a, value: o } = n[e];
            "window" === t
              ? r.matchMedia(`(min-width: ${o}px)`).matches && (i = a)
              : o <= s.clientWidth && (i = a);
          }
          return i || "max";
        },
      },
      checkOverflow: {
        checkOverflow: function () {
          const e = this,
            { isLocked: t, params: s } = e,
            { slidesOffsetBefore: i } = s;
          if (i) {
            const t = e.slides.length - 1,
              s = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
            e.isLocked = e.size > s;
          } else e.isLocked = 1 === e.snapGrid.length;
          !0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked),
            !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
            t && t !== e.isLocked && (e.isEnd = !1),
            t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
        },
      },
      classes: {
        addClasses: function () {
          const e = this,
            { classNames: t, params: s, rtl: i, el: r, device: a } = e,
            n = (function (e, t) {
              const s = [];
              return (
                e.forEach((e) => {
                  "object" == typeof e
                    ? Object.keys(e).forEach((i) => {
                        e[i] && s.push(t + i);
                      })
                    : "string" == typeof e && s.push(t + e);
                }),
                s
              );
            })(
              [
                "initialized",
                s.direction,
                { "free-mode": e.params.freeMode && s.freeMode.enabled },
                { autoheight: s.autoHeight },
                { rtl: i },
                { grid: s.grid && s.grid.rows > 1 },
                {
                  "grid-column":
                    s.grid && s.grid.rows > 1 && "column" === s.grid.fill,
                },
                { android: a.android },
                { ios: a.ios },
                { "css-mode": s.cssMode },
                { centered: s.cssMode && s.centeredSlides },
                { "watch-progress": s.watchSlidesProgress },
              ],
              s.containerModifierClass
            );
          t.push(...n), r.classList.add(...t), e.emitContainerClasses();
        },
        removeClasses: function () {
          const { el: e, classNames: t } = this;
          e &&
            "string" != typeof e &&
            (e.classList.remove(...t), this.emitContainerClasses());
        },
      },
    },
    ne = {};
  class oe {
    constructor() {
      let e, t;
      for (var s = arguments.length, i = new Array(s), r = 0; r < s; r++)
        i[r] = arguments[r];
      1 === i.length &&
      i[0].constructor &&
      "Object" === Object.prototype.toString.call(i[0]).slice(8, -1)
        ? (t = i[0])
        : ([e, t] = i),
        t || (t = {}),
        (t = f({}, t)),
        e && !t.el && (t.el = e);
      const a = n();
      if (
        t.el &&
        "string" == typeof t.el &&
        a.querySelectorAll(t.el).length > 1
      ) {
        const e = [];
        return (
          a.querySelectorAll(t.el).forEach((s) => {
            const i = f({}, t, { el: s });
            e.push(new oe(i));
          }),
          e
        );
      }
      const o = this;
      (o.__swiper__ = !0),
        (o.support = I()),
        (o.device = O({ userAgent: t.userAgent })),
        (o.browser = $()),
        (o.eventsListeners = {}),
        (o.eventsAnyListeners = []),
        (o.modules = [...o.__modules__]),
        t.modules && Array.isArray(t.modules) && o.modules.push(...t.modules);
      const l = {};
      o.modules.forEach((e) => {
        e({
          params: t,
          swiper: o,
          extendParams: re(t, l),
          on: o.on.bind(o),
          once: o.once.bind(o),
          off: o.off.bind(o),
          emit: o.emit.bind(o),
        });
      });
      const d = f({}, ie, l);
      return (
        (o.params = f({}, d, ne, t)),
        (o.originalParams = f({}, o.params)),
        (o.passedParams = f({}, t)),
        o.params &&
          o.params.on &&
          Object.keys(o.params.on).forEach((e) => {
            o.on(e, o.params.on[e]);
          }),
        o.params && o.params.onAny && o.onAny(o.params.onAny),
        Object.assign(o, {
          enabled: o.params.enabled,
          el: e,
          classNames: [],
          slides: [],
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: () => "horizontal" === o.params.direction,
          isVertical: () => "vertical" === o.params.direction,
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          cssOverflowAdjustment() {
            return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
          },
          allowSlideNext: o.params.allowSlideNext,
          allowSlidePrev: o.params.allowSlidePrev,
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            focusableElements: o.params.focusableElements,
            lastClickTime: 0,
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            startMoving: void 0,
            pointerId: null,
            touchId: null,
          },
          allowClick: !0,
          allowTouchMove: o.params.allowTouchMove,
          touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
          imagesToLoad: [],
          imagesLoaded: 0,
        }),
        o.emit("_swiper"),
        o.params.init && o.init(),
        o
      );
    }
    getDirectionLabel(e) {
      return this.isHorizontal()
        ? e
        : {
            width: "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            marginRight: "marginBottom",
          }[e];
    }
    getSlideIndex(e) {
      const { slidesEl: t, params: s } = this,
        i = S(w(t, `.${s.slideClass}, swiper-slide`)[0]);
      return S(e) - i;
    }
    getSlideIndexByData(e) {
      return this.getSlideIndex(
        this.slides.filter(
          (t) => 1 * t.getAttribute("data-swiper-slide-index") === e
        )[0]
      );
    }
    recalcSlides() {
      const { slidesEl: e, params: t } = this;
      this.slides = w(e, `.${t.slideClass}, swiper-slide`);
    }
    enable() {
      const e = this;
      e.enabled ||
        ((e.enabled = !0),
        e.params.grabCursor && e.setGrabCursor(),
        e.emit("enable"));
    }
    disable() {
      const e = this;
      e.enabled &&
        ((e.enabled = !1),
        e.params.grabCursor && e.unsetGrabCursor(),
        e.emit("disable"));
    }
    setProgress(e, t) {
      const s = this;
      e = Math.min(Math.max(e, 0), 1);
      const i = s.minTranslate(),
        r = (s.maxTranslate() - i) * e + i;
      s.translateTo(r, void 0 === t ? 0 : t),
        s.updateActiveIndex(),
        s.updateSlidesClasses();
    }
    emitContainerClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const t = e.el.className
        .split(" ")
        .filter(
          (t) =>
            0 === t.indexOf("swiper") ||
            0 === t.indexOf(e.params.containerModifierClass)
        );
      e.emit("_containerClasses", t.join(" "));
    }
    getSlideClasses(e) {
      const t = this;
      return t.destroyed
        ? ""
        : e.className
            .split(" ")
            .filter(
              (e) =>
                0 === e.indexOf("swiper-slide") ||
                0 === e.indexOf(t.params.slideClass)
            )
            .join(" ");
    }
    emitSlidesClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const t = [];
      e.slides.forEach((s) => {
        const i = e.getSlideClasses(s);
        t.push({ slideEl: s, classNames: i }), e.emit("_slideClass", s, i);
      }),
        e.emit("_slideClasses", t);
    }
    slidesPerViewDynamic(e, t) {
      void 0 === e && (e = "current"), void 0 === t && (t = !1);
      const {
        params: s,
        slides: i,
        slidesGrid: r,
        slidesSizesGrid: a,
        size: n,
        activeIndex: o,
      } = this;
      let l = 1;
      if ("number" == typeof s.slidesPerView) return s.slidesPerView;
      if (s.centeredSlides) {
        let e,
          t = i[o] ? Math.ceil(i[o].swiperSlideSize) : 0;
        for (let s = o + 1; s < i.length; s += 1)
          i[s] &&
            !e &&
            ((t += Math.ceil(i[s].swiperSlideSize)),
            (l += 1),
            t > n && (e = !0));
        for (let s = o - 1; s >= 0; s -= 1)
          i[s] &&
            !e &&
            ((t += i[s].swiperSlideSize), (l += 1), t > n && (e = !0));
      } else if ("current" === e)
        for (let e = o + 1; e < i.length; e += 1) {
          (t ? r[e] + a[e] - r[o] < n : r[e] - r[o] < n) && (l += 1);
        }
      else
        for (let e = o - 1; e >= 0; e -= 1) {
          r[o] - r[e] < n && (l += 1);
        }
      return l;
    }
    update() {
      const e = this;
      if (!e || e.destroyed) return;
      const { snapGrid: t, params: s } = e;
      function i() {
        const t = e.rtlTranslate ? -1 * e.translate : e.translate,
          s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
        e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses();
      }
      let r;
      if (
        (s.breakpoints && e.setBreakpoint(),
        [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
          t.complete && G(e, t);
        }),
        e.updateSize(),
        e.updateSlides(),
        e.updateProgress(),
        e.updateSlidesClasses(),
        s.freeMode && s.freeMode.enabled && !s.cssMode)
      )
        i(), s.autoHeight && e.updateAutoHeight();
      else {
        if (
          ("auto" === s.slidesPerView || s.slidesPerView > 1) &&
          e.isEnd &&
          !s.centeredSlides
        ) {
          const t =
            e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides;
          r = e.slideTo(t.length - 1, 0, !1, !0);
        } else r = e.slideTo(e.activeIndex, 0, !1, !0);
        r || i();
      }
      s.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
        e.emit("update");
    }
    changeDirection(e, t) {
      void 0 === t && (t = !0);
      const s = this,
        i = s.params.direction;
      return (
        e || (e = "horizontal" === i ? "vertical" : "horizontal"),
        e === i ||
          ("horizontal" !== e && "vertical" !== e) ||
          (s.el.classList.remove(`${s.params.containerModifierClass}${i}`),
          s.el.classList.add(`${s.params.containerModifierClass}${e}`),
          s.emitContainerClasses(),
          (s.params.direction = e),
          s.slides.forEach((t) => {
            "vertical" === e ? (t.style.width = "") : (t.style.height = "");
          }),
          s.emit("changeDirection"),
          t && s.update()),
        s
      );
    }
    changeLanguageDirection(e) {
      const t = this;
      (t.rtl && "rtl" === e) ||
        (!t.rtl && "ltr" === e) ||
        ((t.rtl = "rtl" === e),
        (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
        t.rtl
          ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`),
            (t.el.dir = "rtl"))
          : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`),
            (t.el.dir = "ltr")),
        t.update());
    }
    mount(e) {
      const t = this;
      if (t.mounted) return !0;
      let s = e || t.params.el;
      if (("string" == typeof s && (s = document.querySelector(s)), !s))
        return !1;
      (s.swiper = t),
        s.parentNode &&
          s.parentNode.host &&
          s.parentNode.host.nodeName ===
            t.params.swiperElementNodeName.toUpperCase() &&
          (t.isElement = !0);
      const i = () =>
        `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
      let r = (() => {
        if (s && s.shadowRoot && s.shadowRoot.querySelector) {
          return s.shadowRoot.querySelector(i());
        }
        return w(s, i())[0];
      })();
      return (
        !r &&
          t.params.createElements &&
          ((r = b("div", t.params.wrapperClass)),
          s.append(r),
          w(s, `.${t.params.slideClass}`).forEach((e) => {
            r.append(e);
          })),
        Object.assign(t, {
          el: s,
          wrapperEl: r,
          slidesEl:
            t.isElement && !s.parentNode.host.slideSlots
              ? s.parentNode.host
              : r,
          hostEl: t.isElement ? s.parentNode.host : s,
          mounted: !0,
          rtl: "rtl" === s.dir.toLowerCase() || "rtl" === x(s, "direction"),
          rtlTranslate:
            "horizontal" === t.params.direction &&
            ("rtl" === s.dir.toLowerCase() || "rtl" === x(s, "direction")),
          wrongRTL: "-webkit-box" === x(r, "display"),
        }),
        !0
      );
    }
    init(e) {
      const t = this;
      if (t.initialized) return t;
      if (!1 === t.mount(e)) return t;
      t.emit("beforeInit"),
        t.params.breakpoints && t.setBreakpoint(),
        t.addClasses(),
        t.updateSize(),
        t.updateSlides(),
        t.params.watchOverflow && t.checkOverflow(),
        t.params.grabCursor && t.enabled && t.setGrabCursor(),
        t.params.loop && t.virtual && t.params.virtual.enabled
          ? t.slideTo(
              t.params.initialSlide + t.virtual.slidesBefore,
              0,
              t.params.runCallbacksOnInit,
              !1,
              !0
            )
          : t.slideTo(
              t.params.initialSlide,
              0,
              t.params.runCallbacksOnInit,
              !1,
              !0
            ),
        t.params.loop && t.loopCreate(),
        t.attachEvents();
      const s = [...t.el.querySelectorAll('[loading="lazy"]')];
      return (
        t.isElement && s.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
        s.forEach((e) => {
          e.complete
            ? G(t, e)
            : e.addEventListener("load", (e) => {
                G(t, e.target);
              });
        }),
        N(t),
        (t.initialized = !0),
        N(t),
        t.emit("init"),
        t.emit("afterInit"),
        t
      );
    }
    destroy(e, t) {
      void 0 === e && (e = !0), void 0 === t && (t = !0);
      const s = this,
        { params: i, el: r, wrapperEl: a, slides: n } = s;
      return (
        void 0 === s.params ||
          s.destroyed ||
          (s.emit("beforeDestroy"),
          (s.initialized = !1),
          s.detachEvents(),
          i.loop && s.loopDestroy(),
          t &&
            (s.removeClasses(),
            r && "string" != typeof r && r.removeAttribute("style"),
            a && a.removeAttribute("style"),
            n &&
              n.length &&
              n.forEach((e) => {
                e.classList.remove(
                  i.slideVisibleClass,
                  i.slideFullyVisibleClass,
                  i.slideActiveClass,
                  i.slideNextClass,
                  i.slidePrevClass
                ),
                  e.removeAttribute("style"),
                  e.removeAttribute("data-swiper-slide-index");
              })),
          s.emit("destroy"),
          Object.keys(s.eventsListeners).forEach((e) => {
            s.off(e);
          }),
          !1 !== e &&
            (s.el && "string" != typeof s.el && (s.el.swiper = null),
            (function (e) {
              const t = e;
              Object.keys(t).forEach((e) => {
                try {
                  t[e] = null;
                } catch (e) {}
                try {
                  delete t[e];
                } catch (e) {}
              });
            })(s)),
          (s.destroyed = !0)),
        null
      );
    }
    static extendDefaults(e) {
      f(ne, e);
    }
    static get extendedDefaults() {
      return ne;
    }
    static get defaults() {
      return ie;
    }
    static installModule(e) {
      oe.prototype.__modules__ || (oe.prototype.__modules__ = []);
      const t = oe.prototype.__modules__;
      "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
    }
    static use(e) {
      return Array.isArray(e)
        ? (e.forEach((e) => oe.installModule(e)), oe)
        : (oe.installModule(e), oe);
    }
  }
  function le(e, t, s, i) {
    return (
      e.params.createElements &&
        Object.keys(i).forEach((r) => {
          if (!s[r] && !0 === s.auto) {
            let a = w(e.el, `.${i[r]}`)[0];
            a || ((a = b("div", i[r])), (a.className = i[r]), e.el.append(a)),
              (s[r] = a),
              (t[r] = a);
          }
        }),
      s
    );
  }
  function de(e) {
    let { swiper: t, extendParams: s, on: i, emit: r } = e;
    function a(e) {
      let s;
      return e &&
        "string" == typeof e &&
        t.isElement &&
        ((s = t.el.querySelector(e) || t.hostEl.querySelector(e)), s)
        ? s
        : (e &&
            ("string" == typeof e && (s = [...document.querySelectorAll(e)]),
            t.params.uniqueNavElements &&
            "string" == typeof e &&
            s &&
            s.length > 1 &&
            1 === t.el.querySelectorAll(e).length
              ? (s = t.el.querySelector(e))
              : s && 1 === s.length && (s = s[0])),
          e && !s ? e : s);
    }
    function n(e, s) {
      const i = t.params.navigation;
      (e = L(e)).forEach((e) => {
        e &&
          (e.classList[s ? "add" : "remove"](...i.disabledClass.split(" ")),
          "BUTTON" === e.tagName && (e.disabled = s),
          t.params.watchOverflow &&
            t.enabled &&
            e.classList[t.isLocked ? "add" : "remove"](i.lockClass));
      });
    }
    function o() {
      const { nextEl: e, prevEl: s } = t.navigation;
      if (t.params.loop) return n(s, !1), void n(e, !1);
      n(s, t.isBeginning && !t.params.rewind),
        n(e, t.isEnd && !t.params.rewind);
    }
    function l(e) {
      e.preventDefault(),
        (!t.isBeginning || t.params.loop || t.params.rewind) &&
          (t.slidePrev(), r("navigationPrev"));
    }
    function d(e) {
      e.preventDefault(),
        (!t.isEnd || t.params.loop || t.params.rewind) &&
          (t.slideNext(), r("navigationNext"));
    }
    function c() {
      const e = t.params.navigation;
      if (
        ((t.params.navigation = le(
          t,
          t.originalParams.navigation,
          t.params.navigation,
          { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }
        )),
        !e.nextEl && !e.prevEl)
      )
        return;
      let s = a(e.nextEl),
        i = a(e.prevEl);
      Object.assign(t.navigation, { nextEl: s, prevEl: i }),
        (s = L(s)),
        (i = L(i));
      const r = (s, i) => {
        s && s.addEventListener("click", "next" === i ? d : l),
          !t.enabled && s && s.classList.add(...e.lockClass.split(" "));
      };
      s.forEach((e) => r(e, "next")), i.forEach((e) => r(e, "prev"));
    }
    function p() {
      let { nextEl: e, prevEl: s } = t.navigation;
      (e = L(e)), (s = L(s));
      const i = (e, s) => {
        e.removeEventListener("click", "next" === s ? d : l),
          e.classList.remove(...t.params.navigation.disabledClass.split(" "));
      };
      e.forEach((e) => i(e, "next")), s.forEach((e) => i(e, "prev"));
    }
    s({
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: !1,
        disabledClass: "swiper-button-disabled",
        hiddenClass: "swiper-button-hidden",
        lockClass: "swiper-button-lock",
        navigationDisabledClass: "swiper-navigation-disabled",
      },
    }),
      (t.navigation = { nextEl: null, prevEl: null }),
      i("init", () => {
        !1 === t.params.navigation.enabled ? u() : (c(), o());
      }),
      i("toEdge fromEdge lock unlock", () => {
        o();
      }),
      i("destroy", () => {
        p();
      }),
      i("enable disable", () => {
        let { nextEl: e, prevEl: s } = t.navigation;
        (e = L(e)),
          (s = L(s)),
          t.enabled
            ? o()
            : [...e, ...s]
                .filter((e) => !!e)
                .forEach((e) => e.classList.add(t.params.navigation.lockClass));
      }),
      i("click", (e, s) => {
        let { nextEl: i, prevEl: a } = t.navigation;
        (i = L(i)), (a = L(a));
        const n = s.target;
        let o = a.includes(n) || i.includes(n);
        if (t.isElement && !o) {
          const e = s.path || (s.composedPath && s.composedPath());
          e && (o = e.find((e) => i.includes(e) || a.includes(e)));
        }
        if (t.params.navigation.hideOnClick && !o) {
          if (
            t.pagination &&
            t.params.pagination &&
            t.params.pagination.clickable &&
            (t.pagination.el === n || t.pagination.el.contains(n))
          )
            return;
          let e;
          i.length
            ? (e = i[0].classList.contains(t.params.navigation.hiddenClass))
            : a.length &&
              (e = a[0].classList.contains(t.params.navigation.hiddenClass)),
            r(!0 === e ? "navigationShow" : "navigationHide"),
            [...i, ...a]
              .filter((e) => !!e)
              .forEach((e) =>
                e.classList.toggle(t.params.navigation.hiddenClass)
              );
        }
      });
    const u = () => {
      t.el.classList.add(
        ...t.params.navigation.navigationDisabledClass.split(" ")
      ),
        p();
    };
    Object.assign(t.navigation, {
      enable: () => {
        t.el.classList.remove(
          ...t.params.navigation.navigationDisabledClass.split(" ")
        ),
          c(),
          o();
      },
      disable: u,
      update: o,
      init: c,
      destroy: p,
    });
  }
  function ce(e) {
    return (
      void 0 === e && (e = ""),
      `.${e
        .trim()
        .replace(/([\.:!+\/])/g, "\\$1")
        .replace(/ /g, ".")}`
    );
  }
  function pe(e) {
    const t = this,
      { params: s, slidesEl: i } = t;
    s.loop && t.loopDestroy();
    const r = (e) => {
      if ("string" == typeof e) {
        const t = document.createElement("div");
        (t.innerHTML = e), i.append(t.children[0]), (t.innerHTML = "");
      } else i.append(e);
    };
    if ("object" == typeof e && "length" in e)
      for (let t = 0; t < e.length; t += 1) e[t] && r(e[t]);
    else r(e);
    t.recalcSlides(),
      s.loop && t.loopCreate(),
      (s.observer && !t.isElement) || t.update();
  }
  function ue(e) {
    const t = this,
      { params: s, activeIndex: i, slidesEl: r } = t;
    s.loop && t.loopDestroy();
    let a = i + 1;
    const n = (e) => {
      if ("string" == typeof e) {
        const t = document.createElement("div");
        (t.innerHTML = e), r.prepend(t.children[0]), (t.innerHTML = "");
      } else r.prepend(e);
    };
    if ("object" == typeof e && "length" in e) {
      for (let t = 0; t < e.length; t += 1) e[t] && n(e[t]);
      a = i + e.length;
    } else n(e);
    t.recalcSlides(),
      s.loop && t.loopCreate(),
      (s.observer && !t.isElement) || t.update(),
      t.slideTo(a, 0, !1);
  }
  function me(e, t) {
    const s = this,
      { params: i, activeIndex: r, slidesEl: a } = s;
    let n = r;
    i.loop && ((n -= s.loopedSlides), s.loopDestroy(), s.recalcSlides());
    const o = s.slides.length;
    if (e <= 0) return void s.prependSlide(t);
    if (e >= o) return void s.appendSlide(t);
    let l = n > e ? n + 1 : n;
    const d = [];
    for (let t = o - 1; t >= e; t -= 1) {
      const e = s.slides[t];
      e.remove(), d.unshift(e);
    }
    if ("object" == typeof t && "length" in t) {
      for (let e = 0; e < t.length; e += 1) t[e] && a.append(t[e]);
      l = n > e ? n + t.length : n;
    } else a.append(t);
    for (let e = 0; e < d.length; e += 1) a.append(d[e]);
    s.recalcSlides(),
      i.loop && s.loopCreate(),
      (i.observer && !s.isElement) || s.update(),
      i.loop ? s.slideTo(l + s.loopedSlides, 0, !1) : s.slideTo(l, 0, !1);
  }
  function fe(e) {
    const t = this,
      { params: s, activeIndex: i } = t;
    let r = i;
    s.loop && ((r -= t.loopedSlides), t.loopDestroy());
    let a,
      n = r;
    if ("object" == typeof e && "length" in e) {
      for (let s = 0; s < e.length; s += 1)
        (a = e[s]), t.slides[a] && t.slides[a].remove(), a < n && (n -= 1);
      n = Math.max(n, 0);
    } else
      (a = e),
        t.slides[a] && t.slides[a].remove(),
        a < n && (n -= 1),
        (n = Math.max(n, 0));
    t.recalcSlides(),
      s.loop && t.loopCreate(),
      (s.observer && !t.isElement) || t.update(),
      s.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1);
  }
  function he() {
    const e = this,
      t = [];
    for (let s = 0; s < e.slides.length; s += 1) t.push(s);
    e.removeSlide(t);
  }
  function ve(e) {
    const {
      effect: t,
      swiper: s,
      on: i,
      setTranslate: r,
      setTransition: a,
      overwriteParams: n,
      perspective: o,
      recreateShadows: l,
      getEffectParams: d,
    } = e;
    let c;
    i("beforeInit", () => {
      if (s.params.effect !== t) return;
      s.classNames.push(`${s.params.containerModifierClass}${t}`),
        o && o() && s.classNames.push(`${s.params.containerModifierClass}3d`);
      const e = n ? n() : {};
      Object.assign(s.params, e), Object.assign(s.originalParams, e);
    }),
      i("setTranslate", () => {
        s.params.effect === t && r();
      }),
      i("setTransition", (e, i) => {
        s.params.effect === t && a(i);
      }),
      i("transitionEnd", () => {
        if (s.params.effect === t && l) {
          if (!d || !d().slideShadows) return;
          s.slides.forEach((e) => {
            e.querySelectorAll(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            ).forEach((e) => e.remove());
          }),
            l();
        }
      }),
      i("virtualUpdate", () => {
        s.params.effect === t &&
          (s.slides.length || (c = !0),
          requestAnimationFrame(() => {
            c && s.slides && s.slides.length && (r(), (c = !1));
          }));
      });
  }
  function ge(e, t) {
    const s = g(t);
    return (
      s !== t &&
        ((s.style.backfaceVisibility = "hidden"),
        (s.style["-webkit-backface-visibility"] = "hidden")),
      s
    );
  }
  function we(e) {
    let { swiper: t, duration: s, transformElements: i, allSlides: r } = e;
    const { activeIndex: a } = t;
    if (t.params.virtualTranslate && 0 !== s) {
      let e,
        s = !1;
      (e = r
        ? i
        : i.filter((e) => {
            const s = e.classList.contains("swiper-slide-transform")
              ? ((e) => {
                  if (!e.parentElement)
                    return t.slides.filter(
                      (t) => t.shadowRoot && t.shadowRoot === e.parentNode
                    )[0];
                  return e.parentElement;
                })(e)
              : e;
            return t.getSlideIndex(s) === a;
          })),
        e.forEach((e) => {
          M(e, () => {
            if (s) return;
            if (!t || t.destroyed) return;
            (s = !0), (t.animating = !1);
            const e = new window.CustomEvent("transitionend", {
              bubbles: !0,
              cancelable: !0,
            });
            t.wrapperEl.dispatchEvent(e);
          });
        });
    }
  }
  function ye(e, t, s) {
    const i = `swiper-slide-shadow${s ? `-${s}` : ""}${
        e ? ` swiper-slide-shadow-${e}` : ""
      }`,
      r = g(t);
    let a = r.querySelector(`.${i.split(" ").join(".")}`);
    return a || ((a = b("div", i.split(" "))), r.append(a)), a;
  }
  Object.keys(ae).forEach((e) => {
    Object.keys(ae[e]).forEach((t) => {
      oe.prototype[t] = ae[e][t];
    });
  }),
    oe.use([
      function (e) {
        let { swiper: t, on: s, emit: i } = e;
        const r = l();
        let a = null,
          n = null;
        const o = () => {
            t &&
              !t.destroyed &&
              t.initialized &&
              (i("beforeResize"), i("resize"));
          },
          d = () => {
            t && !t.destroyed && t.initialized && i("orientationchange");
          };
        s("init", () => {
          t.params.resizeObserver && void 0 !== r.ResizeObserver
            ? t &&
              !t.destroyed &&
              t.initialized &&
              ((a = new ResizeObserver((e) => {
                n = r.requestAnimationFrame(() => {
                  const { width: s, height: i } = t;
                  let r = s,
                    a = i;
                  e.forEach((e) => {
                    let { contentBoxSize: s, contentRect: i, target: n } = e;
                    (n && n !== t.el) ||
                      ((r = i ? i.width : (s[0] || s).inlineSize),
                      (a = i ? i.height : (s[0] || s).blockSize));
                  }),
                    (r === s && a === i) || o();
                });
              })),
              a.observe(t.el))
            : (r.addEventListener("resize", o),
              r.addEventListener("orientationchange", d));
        }),
          s("destroy", () => {
            n && r.cancelAnimationFrame(n),
              a && a.unobserve && t.el && (a.unobserve(t.el), (a = null)),
              r.removeEventListener("resize", o),
              r.removeEventListener("orientationchange", d);
          });
      },
      function (e) {
        let { swiper: t, extendParams: s, on: i, emit: r } = e;
        const a = [],
          n = l(),
          o = function (e, s) {
            void 0 === s && (s = {});
            const i = new (n.MutationObserver || n.WebkitMutationObserver)(
              (e) => {
                if (t.__preventObserver__) return;
                if (1 === e.length) return void r("observerUpdate", e[0]);
                const s = function () {
                  r("observerUpdate", e[0]);
                };
                n.requestAnimationFrame
                  ? n.requestAnimationFrame(s)
                  : n.setTimeout(s, 0);
              }
            );
            i.observe(e, {
              attributes: void 0 === s.attributes || s.attributes,
              childList: t.isElement || (void 0 === s.childList || s).childList,
              characterData: void 0 === s.characterData || s.characterData,
            }),
              a.push(i);
          };
        s({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          i("init", () => {
            if (t.params.observer) {
              if (t.params.observeParents) {
                const e = T(t.hostEl);
                for (let t = 0; t < e.length; t += 1) o(e[t]);
              }
              o(t.hostEl, { childList: t.params.observeSlideChildren }),
                o(t.wrapperEl, { attributes: !1 });
            }
          }),
          i("destroy", () => {
            a.forEach((e) => {
              e.disconnect();
            }),
              a.splice(0, a.length);
          });
      },
    ]);
  const be = [
    function (e) {
      let t,
        { swiper: s, extendParams: i, on: r, emit: a } = e;
      i({
        virtual: {
          enabled: !1,
          slides: [],
          cache: !0,
          renderSlide: null,
          renderExternal: null,
          renderExternalUpdate: !0,
          addSlidesBefore: 0,
          addSlidesAfter: 0,
        },
      });
      const o = n();
      s.virtual = {
        cache: {},
        from: void 0,
        to: void 0,
        slides: [],
        offset: 0,
        slidesGrid: [],
      };
      const l = o.createElement("div");
      function d(e, t) {
        const i = s.params.virtual;
        if (i.cache && s.virtual.cache[t]) return s.virtual.cache[t];
        let r;
        return (
          i.renderSlide
            ? ((r = i.renderSlide.call(s, e, t)),
              "string" == typeof r && ((l.innerHTML = r), (r = l.children[0])))
            : (r = s.isElement
                ? b("swiper-slide")
                : b("div", s.params.slideClass)),
          r.setAttribute("data-swiper-slide-index", t),
          i.renderSlide || (r.innerHTML = e),
          i.cache && (s.virtual.cache[t] = r),
          r
        );
      }
      function c(e, t) {
        const {
          slidesPerView: i,
          slidesPerGroup: r,
          centeredSlides: n,
          loop: o,
          initialSlide: l,
        } = s.params;
        if (t && !o && l > 0) return;
        const { addSlidesBefore: c, addSlidesAfter: p } = s.params.virtual,
          { from: u, to: m, slides: f, slidesGrid: h, offset: v } = s.virtual;
        s.params.cssMode || s.updateActiveIndex();
        const g = s.activeIndex || 0;
        let y, b, E;
        (y = s.rtlTranslate ? "right" : s.isHorizontal() ? "left" : "top"),
          n
            ? ((b = Math.floor(i / 2) + r + p), (E = Math.floor(i / 2) + r + c))
            : ((b = i + (r - 1) + p), (E = (o ? i : r) + c));
        let x = g - E,
          S = g + b;
        o || ((x = Math.max(x, 0)), (S = Math.min(S, f.length - 1)));
        let T = (s.slidesGrid[x] || 0) - (s.slidesGrid[0] || 0);
        function M() {
          s.updateSlides(),
            s.updateProgress(),
            s.updateSlidesClasses(),
            a("virtualUpdate");
        }
        if (
          (o && g >= E
            ? ((x -= E), n || (T += s.slidesGrid[0]))
            : o && g < E && ((x = -E), n && (T += s.slidesGrid[0])),
          Object.assign(s.virtual, {
            from: x,
            to: S,
            offset: T,
            slidesGrid: s.slidesGrid,
            slidesBefore: E,
            slidesAfter: b,
          }),
          u === x && m === S && !e)
        )
          return (
            s.slidesGrid !== h &&
              T !== v &&
              s.slides.forEach((e) => {
                e.style[y] = T - Math.abs(s.cssOverflowAdjustment()) + "px";
              }),
            s.updateProgress(),
            void a("virtualUpdate")
          );
        if (s.params.virtual.renderExternal)
          return (
            s.params.virtual.renderExternal.call(s, {
              offset: T,
              from: x,
              to: S,
              slides: (function () {
                const e = [];
                for (let t = x; t <= S; t += 1) e.push(f[t]);
                return e;
              })(),
            }),
            void (s.params.virtual.renderExternalUpdate
              ? M()
              : a("virtualUpdate"))
          );
        const C = [],
          L = [],
          P = (e) => {
            let t = e;
            return (
              e < 0 ? (t = f.length + e) : t >= f.length && (t -= f.length), t
            );
          };
        if (e)
          s.slides
            .filter((e) => e.matches(`.${s.params.slideClass}, swiper-slide`))
            .forEach((e) => {
              e.remove();
            });
        else
          for (let e = u; e <= m; e += 1)
            if (e < x || e > S) {
              const t = P(e);
              s.slides
                .filter((e) =>
                  e.matches(
                    `.${s.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`
                  )
                )
                .forEach((e) => {
                  e.remove();
                });
            }
        const k = o ? -f.length : 0,
          A = o ? 2 * f.length : f.length;
        for (let t = k; t < A; t += 1)
          if (t >= x && t <= S) {
            const s = P(t);
            void 0 === m || e
              ? L.push(s)
              : (t > m && L.push(s), t < u && C.push(s));
          }
        if (
          (L.forEach((e) => {
            s.slidesEl.append(d(f[e], e));
          }),
          o)
        )
          for (let e = C.length - 1; e >= 0; e -= 1) {
            const t = C[e];
            s.slidesEl.prepend(d(f[t], t));
          }
        else
          C.sort((e, t) => t - e),
            C.forEach((e) => {
              s.slidesEl.prepend(d(f[e], e));
            });
        w(s.slidesEl, ".swiper-slide, swiper-slide").forEach((e) => {
          e.style[y] = T - Math.abs(s.cssOverflowAdjustment()) + "px";
        }),
          M();
      }
      r("beforeInit", () => {
        if (!s.params.virtual.enabled) return;
        let e;
        if (void 0 === s.passedParams.virtual.slides) {
          const t = [...s.slidesEl.children].filter((e) =>
            e.matches(`.${s.params.slideClass}, swiper-slide`)
          );
          t &&
            t.length &&
            ((s.virtual.slides = [...t]),
            (e = !0),
            t.forEach((e, t) => {
              e.setAttribute("data-swiper-slide-index", t),
                (s.virtual.cache[t] = e),
                e.remove();
            }));
        }
        e || (s.virtual.slides = s.params.virtual.slides),
          s.classNames.push(`${s.params.containerModifierClass}virtual`),
          (s.params.watchSlidesProgress = !0),
          (s.originalParams.watchSlidesProgress = !0),
          c(!1, !0);
      }),
        r("setTranslate", () => {
          s.params.virtual.enabled &&
            (s.params.cssMode && !s._immediateVirtual
              ? (clearTimeout(t),
                (t = setTimeout(() => {
                  c();
                }, 100)))
              : c());
        }),
        r("init update resize", () => {
          s.params.virtual.enabled &&
            s.params.cssMode &&
            h(s.wrapperEl, "--swiper-virtual-size", `${s.virtualSize}px`);
        }),
        Object.assign(s.virtual, {
          appendSlide: function (e) {
            if ("object" == typeof e && "length" in e)
              for (let t = 0; t < e.length; t += 1)
                e[t] && s.virtual.slides.push(e[t]);
            else s.virtual.slides.push(e);
            c(!0);
          },
          prependSlide: function (e) {
            const t = s.activeIndex;
            let i = t + 1,
              r = 1;
            if (Array.isArray(e)) {
              for (let t = 0; t < e.length; t += 1)
                e[t] && s.virtual.slides.unshift(e[t]);
              (i = t + e.length), (r = e.length);
            } else s.virtual.slides.unshift(e);
            if (s.params.virtual.cache) {
              const e = s.virtual.cache,
                t = {};
              Object.keys(e).forEach((s) => {
                const i = e[s],
                  a = i.getAttribute("data-swiper-slide-index");
                a &&
                  i.setAttribute(
                    "data-swiper-slide-index",
                    parseInt(a, 10) + r
                  ),
                  (t[parseInt(s, 10) + r] = i);
              }),
                (s.virtual.cache = t);
            }
            c(!0), s.slideTo(i, 0);
          },
          removeSlide: function (e) {
            if (null == e) return;
            let t = s.activeIndex;
            if (Array.isArray(e))
              for (let i = e.length - 1; i >= 0; i -= 1)
                s.params.virtual.cache &&
                  (delete s.virtual.cache[e[i]],
                  Object.keys(s.virtual.cache).forEach((t) => {
                    t > e &&
                      ((s.virtual.cache[t - 1] = s.virtual.cache[t]),
                      s.virtual.cache[t - 1].setAttribute(
                        "data-swiper-slide-index",
                        t - 1
                      ),
                      delete s.virtual.cache[t]);
                  })),
                  s.virtual.slides.splice(e[i], 1),
                  e[i] < t && (t -= 1),
                  (t = Math.max(t, 0));
            else
              s.params.virtual.cache &&
                (delete s.virtual.cache[e],
                Object.keys(s.virtual.cache).forEach((t) => {
                  t > e &&
                    ((s.virtual.cache[t - 1] = s.virtual.cache[t]),
                    s.virtual.cache[t - 1].setAttribute(
                      "data-swiper-slide-index",
                      t - 1
                    ),
                    delete s.virtual.cache[t]);
                })),
                s.virtual.slides.splice(e, 1),
                e < t && (t -= 1),
                (t = Math.max(t, 0));
            c(!0), s.slideTo(t, 0);
          },
          removeAllSlides: function () {
            (s.virtual.slides = []),
              s.params.virtual.cache && (s.virtual.cache = {}),
              c(!0),
              s.slideTo(0, 0);
          },
          update: c,
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i, emit: r } = e;
      const a = n(),
        o = l();
      function d(e) {
        if (!t.enabled) return;
        const { rtlTranslate: s } = t;
        let i = e;
        i.originalEvent && (i = i.originalEvent);
        const n = i.keyCode || i.charCode,
          l = t.params.keyboard.pageUpDown,
          d = l && 33 === n,
          c = l && 34 === n,
          p = 37 === n,
          u = 39 === n,
          m = 38 === n,
          f = 40 === n;
        if (
          !t.allowSlideNext &&
          ((t.isHorizontal() && u) || (t.isVertical() && f) || c)
        )
          return !1;
        if (
          !t.allowSlidePrev &&
          ((t.isHorizontal() && p) || (t.isVertical() && m) || d)
        )
          return !1;
        if (
          !(
            i.shiftKey ||
            i.altKey ||
            i.ctrlKey ||
            i.metaKey ||
            (a.activeElement &&
              a.activeElement.nodeName &&
              ("input" === a.activeElement.nodeName.toLowerCase() ||
                "textarea" === a.activeElement.nodeName.toLowerCase()))
          )
        ) {
          if (
            t.params.keyboard.onlyInViewport &&
            (d || c || p || u || m || f)
          ) {
            let e = !1;
            if (
              T(t.el, `.${t.params.slideClass}, swiper-slide`).length > 0 &&
              0 === T(t.el, `.${t.params.slideActiveClass}`).length
            )
              return;
            const i = t.el,
              r = i.clientWidth,
              a = i.clientHeight,
              n = o.innerWidth,
              l = o.innerHeight,
              d = E(i);
            s && (d.left -= i.scrollLeft);
            const c = [
              [d.left, d.top],
              [d.left + r, d.top],
              [d.left, d.top + a],
              [d.left + r, d.top + a],
            ];
            for (let t = 0; t < c.length; t += 1) {
              const s = c[t];
              if (s[0] >= 0 && s[0] <= n && s[1] >= 0 && s[1] <= l) {
                if (0 === s[0] && 0 === s[1]) continue;
                e = !0;
              }
            }
            if (!e) return;
          }
          t.isHorizontal()
            ? ((d || c || p || u) &&
                (i.preventDefault ? i.preventDefault() : (i.returnValue = !1)),
              (((c || u) && !s) || ((d || p) && s)) && t.slideNext(),
              (((d || p) && !s) || ((c || u) && s)) && t.slidePrev())
            : ((d || c || m || f) &&
                (i.preventDefault ? i.preventDefault() : (i.returnValue = !1)),
              (c || f) && t.slideNext(),
              (d || m) && t.slidePrev()),
            r("keyPress", n);
        }
      }
      function c() {
        t.keyboard.enabled ||
          (a.addEventListener("keydown", d), (t.keyboard.enabled = !0));
      }
      function p() {
        t.keyboard.enabled &&
          (a.removeEventListener("keydown", d), (t.keyboard.enabled = !1));
      }
      (t.keyboard = { enabled: !1 }),
        s({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
        i("init", () => {
          t.params.keyboard.enabled && c();
        }),
        i("destroy", () => {
          t.keyboard.enabled && p();
        }),
        Object.assign(t.keyboard, { enable: c, disable: p });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i, emit: r } = e;
      const a = l();
      let n;
      s({
        mousewheel: {
          enabled: !1,
          releaseOnEdges: !1,
          invert: !1,
          forceToAxis: !1,
          sensitivity: 1,
          eventsTarget: "container",
          thresholdDelta: null,
          thresholdTime: null,
          noMousewheelClass: "swiper-no-mousewheel",
        },
      }),
        (t.mousewheel = { enabled: !1 });
      let o,
        d = p();
      const u = [];
      function m() {
        t.enabled && (t.mouseEntered = !0);
      }
      function f() {
        t.enabled && (t.mouseEntered = !1);
      }
      function h(e) {
        return (
          !(
            t.params.mousewheel.thresholdDelta &&
            e.delta < t.params.mousewheel.thresholdDelta
          ) &&
          !(
            t.params.mousewheel.thresholdTime &&
            p() - d < t.params.mousewheel.thresholdTime
          ) &&
          ((e.delta >= 6 && p() - d < 60) ||
            (e.direction < 0
              ? (t.isEnd && !t.params.loop) ||
                t.animating ||
                (t.slideNext(), r("scroll", e.raw))
              : (t.isBeginning && !t.params.loop) ||
                t.animating ||
                (t.slidePrev(), r("scroll", e.raw)),
            (d = new a.Date().getTime()),
            !1))
        );
      }
      function v(e) {
        let s = e,
          i = !0;
        if (!t.enabled) return;
        if (e.target.closest(`.${t.params.mousewheel.noMousewheelClass}`))
          return;
        const a = t.params.mousewheel;
        t.params.cssMode && s.preventDefault();
        let l = t.el;
        "container" !== t.params.mousewheel.eventsTarget &&
          (l = document.querySelector(t.params.mousewheel.eventsTarget));
        const d = l && l.contains(s.target);
        if (!t.mouseEntered && !d && !a.releaseOnEdges) return !0;
        s.originalEvent && (s = s.originalEvent);
        let m = 0;
        const f = t.rtlTranslate ? -1 : 1,
          v = (function (e) {
            let t = 0,
              s = 0,
              i = 0,
              r = 0;
            return (
              "detail" in e && (s = e.detail),
              "wheelDelta" in e && (s = -e.wheelDelta / 120),
              "wheelDeltaY" in e && (s = -e.wheelDeltaY / 120),
              "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
              "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = s), (s = 0)),
              (i = 10 * t),
              (r = 10 * s),
              "deltaY" in e && (r = e.deltaY),
              "deltaX" in e && (i = e.deltaX),
              e.shiftKey && !i && ((i = r), (r = 0)),
              (i || r) &&
                e.deltaMode &&
                (1 === e.deltaMode
                  ? ((i *= 40), (r *= 40))
                  : ((i *= 800), (r *= 800))),
              i && !t && (t = i < 1 ? -1 : 1),
              r && !s && (s = r < 1 ? -1 : 1),
              { spinX: t, spinY: s, pixelX: i, pixelY: r }
            );
          })(s);
        if (a.forceToAxis)
          if (t.isHorizontal()) {
            if (!(Math.abs(v.pixelX) > Math.abs(v.pixelY))) return !0;
            m = -v.pixelX * f;
          } else {
            if (!(Math.abs(v.pixelY) > Math.abs(v.pixelX))) return !0;
            m = -v.pixelY;
          }
        else
          m =
            Math.abs(v.pixelX) > Math.abs(v.pixelY) ? -v.pixelX * f : -v.pixelY;
        if (0 === m) return !0;
        a.invert && (m = -m);
        let g = t.getTranslate() + m * a.sensitivity;
        if (
          (g >= t.minTranslate() && (g = t.minTranslate()),
          g <= t.maxTranslate() && (g = t.maxTranslate()),
          (i =
            !!t.params.loop ||
            !(g === t.minTranslate() || g === t.maxTranslate())),
          i && t.params.nested && s.stopPropagation(),
          t.params.freeMode && t.params.freeMode.enabled)
        ) {
          const e = { time: p(), delta: Math.abs(m), direction: Math.sign(m) },
            i =
              o &&
              e.time < o.time + 500 &&
              e.delta <= o.delta &&
              e.direction === o.direction;
          if (!i) {
            o = void 0;
            let l = t.getTranslate() + m * a.sensitivity;
            const d = t.isBeginning,
              p = t.isEnd;
            if (
              (l >= t.minTranslate() && (l = t.minTranslate()),
              l <= t.maxTranslate() && (l = t.maxTranslate()),
              t.setTransition(0),
              t.setTranslate(l),
              t.updateProgress(),
              t.updateActiveIndex(),
              t.updateSlidesClasses(),
              ((!d && t.isBeginning) || (!p && t.isEnd)) &&
                t.updateSlidesClasses(),
              t.params.loop &&
                t.loopFix({
                  direction: e.direction < 0 ? "next" : "prev",
                  byMousewheel: !0,
                }),
              t.params.freeMode.sticky)
            ) {
              clearTimeout(n), (n = void 0), u.length >= 15 && u.shift();
              const s = u.length ? u[u.length - 1] : void 0,
                i = u[0];
              if (
                (u.push(e),
                s && (e.delta > s.delta || e.direction !== s.direction))
              )
                u.splice(0);
              else if (
                u.length >= 15 &&
                e.time - i.time < 500 &&
                i.delta - e.delta >= 1 &&
                e.delta <= 6
              ) {
                const s = m > 0 ? 0.8 : 0.2;
                (o = e),
                  u.splice(0),
                  (n = c(() => {
                    !t.destroyed &&
                      t.params &&
                      t.slideToClosest(t.params.speed, !0, void 0, s);
                  }, 0));
              }
              n ||
                (n = c(() => {
                  if (t.destroyed || !t.params) return;
                  (o = e),
                    u.splice(0),
                    t.slideToClosest(t.params.speed, !0, void 0, 0.5);
                }, 500));
            }
            if (
              (i || r("scroll", s),
              t.params.autoplay &&
                t.params.autoplayDisableOnInteraction &&
                t.autoplay.stop(),
              a.releaseOnEdges &&
                (l === t.minTranslate() || l === t.maxTranslate()))
            )
              return !0;
          }
        } else {
          const s = {
            time: p(),
            delta: Math.abs(m),
            direction: Math.sign(m),
            raw: e,
          };
          u.length >= 2 && u.shift();
          const i = u.length ? u[u.length - 1] : void 0;
          if (
            (u.push(s),
            i
              ? (s.direction !== i.direction ||
                  s.delta > i.delta ||
                  s.time > i.time + 150) &&
                h(s)
              : h(s),
            (function (e) {
              const s = t.params.mousewheel;
              if (e.direction < 0) {
                if (t.isEnd && !t.params.loop && s.releaseOnEdges) return !0;
              } else if (t.isBeginning && !t.params.loop && s.releaseOnEdges)
                return !0;
              return !1;
            })(s))
          )
            return !0;
        }
        return s.preventDefault ? s.preventDefault() : (s.returnValue = !1), !1;
      }
      function g(e) {
        let s = t.el;
        "container" !== t.params.mousewheel.eventsTarget &&
          (s = document.querySelector(t.params.mousewheel.eventsTarget)),
          s[e]("mouseenter", m),
          s[e]("mouseleave", f),
          s[e]("wheel", v);
      }
      function w() {
        return t.params.cssMode
          ? (t.wrapperEl.removeEventListener("wheel", v), !0)
          : !t.mousewheel.enabled &&
              (g("addEventListener"), (t.mousewheel.enabled = !0), !0);
      }
      function y() {
        return t.params.cssMode
          ? (t.wrapperEl.addEventListener(event, v), !0)
          : !!t.mousewheel.enabled &&
              (g("removeEventListener"), (t.mousewheel.enabled = !1), !0);
      }
      i("init", () => {
        !t.params.mousewheel.enabled && t.params.cssMode && y(),
          t.params.mousewheel.enabled && w();
      }),
        i("destroy", () => {
          t.params.cssMode && w(), t.mousewheel.enabled && y();
        }),
        Object.assign(t.mousewheel, { enable: w, disable: y });
    },
    de,
    function (e) {
      let { swiper: t, extendParams: s, on: i, emit: r } = e;
      const a = "swiper-pagination";
      let n;
      s({
        pagination: {
          el: null,
          bulletElement: "span",
          clickable: !1,
          hideOnClick: !1,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: !1,
          type: "bullets",
          dynamicBullets: !1,
          dynamicMainBullets: 1,
          formatFractionCurrent: (e) => e,
          formatFractionTotal: (e) => e,
          bulletClass: `${a}-bullet`,
          bulletActiveClass: `${a}-bullet-active`,
          modifierClass: `${a}-`,
          currentClass: `${a}-current`,
          totalClass: `${a}-total`,
          hiddenClass: `${a}-hidden`,
          progressbarFillClass: `${a}-progressbar-fill`,
          progressbarOppositeClass: `${a}-progressbar-opposite`,
          clickableClass: `${a}-clickable`,
          lockClass: `${a}-lock`,
          horizontalClass: `${a}-horizontal`,
          verticalClass: `${a}-vertical`,
          paginationDisabledClass: `${a}-disabled`,
        },
      }),
        (t.pagination = { el: null, bullets: [] });
      let o = 0;
      function l() {
        return (
          !t.params.pagination.el ||
          !t.pagination.el ||
          (Array.isArray(t.pagination.el) && 0 === t.pagination.el.length)
        );
      }
      function d(e, s) {
        const { bulletActiveClass: i } = t.params.pagination;
        e &&
          (e = e[("prev" === s ? "previous" : "next") + "ElementSibling"]) &&
          (e.classList.add(`${i}-${s}`),
          (e = e[("prev" === s ? "previous" : "next") + "ElementSibling"]) &&
            e.classList.add(`${i}-${s}-${s}`));
      }
      function c(e) {
        const s = e.target.closest(ce(t.params.pagination.bulletClass));
        if (!s) return;
        e.preventDefault();
        const i = S(s) * t.params.slidesPerGroup;
        if (t.params.loop) {
          if (t.realIndex === i) return;
          const e =
            ((r = t.realIndex),
            (a = i),
            (n = t.slides.length),
            (a %= n) == 1 + (r %= n)
              ? "next"
              : a === r - 1
              ? "previous"
              : void 0);
          "next" === e
            ? t.slideNext()
            : "previous" === e
            ? t.slidePrev()
            : t.slideToLoop(i);
        } else t.slideTo(i);
        var r, a, n;
      }
      function p() {
        const e = t.rtl,
          s = t.params.pagination;
        if (l()) return;
        let i,
          a,
          c = t.pagination.el;
        c = L(c);
        const p =
            t.virtual && t.params.virtual.enabled
              ? t.virtual.slides.length
              : t.slides.length,
          u = t.params.loop
            ? Math.ceil(p / t.params.slidesPerGroup)
            : t.snapGrid.length;
        if (
          (t.params.loop
            ? ((a = t.previousRealIndex || 0),
              (i =
                t.params.slidesPerGroup > 1
                  ? Math.floor(t.realIndex / t.params.slidesPerGroup)
                  : t.realIndex))
            : void 0 !== t.snapIndex
            ? ((i = t.snapIndex), (a = t.previousSnapIndex))
            : ((a = t.previousIndex || 0), (i = t.activeIndex || 0)),
          "bullets" === s.type &&
            t.pagination.bullets &&
            t.pagination.bullets.length > 0)
        ) {
          const r = t.pagination.bullets;
          let l, p, u;
          if (
            (s.dynamicBullets &&
              ((n = C(r[0], t.isHorizontal() ? "width" : "height", !0)),
              c.forEach((e) => {
                e.style[t.isHorizontal() ? "width" : "height"] =
                  n * (s.dynamicMainBullets + 4) + "px";
              }),
              s.dynamicMainBullets > 1 &&
                void 0 !== a &&
                ((o += i - (a || 0)),
                o > s.dynamicMainBullets - 1
                  ? (o = s.dynamicMainBullets - 1)
                  : o < 0 && (o = 0)),
              (l = Math.max(i - o, 0)),
              (p = l + (Math.min(r.length, s.dynamicMainBullets) - 1)),
              (u = (p + l) / 2)),
            r.forEach((e) => {
              const t = [
                ...[
                  "",
                  "-next",
                  "-next-next",
                  "-prev",
                  "-prev-prev",
                  "-main",
                ].map((e) => `${s.bulletActiveClass}${e}`),
              ]
                .map((e) =>
                  "string" == typeof e && e.includes(" ") ? e.split(" ") : e
                )
                .flat();
              e.classList.remove(...t);
            }),
            c.length > 1)
          )
            r.forEach((e) => {
              const r = S(e);
              r === i
                ? e.classList.add(...s.bulletActiveClass.split(" "))
                : t.isElement && e.setAttribute("part", "bullet"),
                s.dynamicBullets &&
                  (r >= l &&
                    r <= p &&
                    e.classList.add(
                      ...`${s.bulletActiveClass}-main`.split(" ")
                    ),
                  r === l && d(e, "prev"),
                  r === p && d(e, "next"));
            });
          else {
            const e = r[i];
            if (
              (e && e.classList.add(...s.bulletActiveClass.split(" ")),
              t.isElement &&
                r.forEach((e, t) => {
                  e.setAttribute("part", t === i ? "bullet-active" : "bullet");
                }),
              s.dynamicBullets)
            ) {
              const e = r[l],
                t = r[p];
              for (let e = l; e <= p; e += 1)
                r[e] &&
                  r[e].classList.add(
                    ...`${s.bulletActiveClass}-main`.split(" ")
                  );
              d(e, "prev"), d(t, "next");
            }
          }
          if (s.dynamicBullets) {
            const i = Math.min(r.length, s.dynamicMainBullets + 4),
              a = (n * i - n) / 2 - u * n,
              o = e ? "right" : "left";
            r.forEach((e) => {
              e.style[t.isHorizontal() ? o : "top"] = `${a}px`;
            });
          }
        }
        c.forEach((e, a) => {
          if (
            ("fraction" === s.type &&
              (e.querySelectorAll(ce(s.currentClass)).forEach((e) => {
                e.textContent = s.formatFractionCurrent(i + 1);
              }),
              e.querySelectorAll(ce(s.totalClass)).forEach((e) => {
                e.textContent = s.formatFractionTotal(u);
              })),
            "progressbar" === s.type)
          ) {
            let r;
            r = s.progressbarOpposite
              ? t.isHorizontal()
                ? "vertical"
                : "horizontal"
              : t.isHorizontal()
              ? "horizontal"
              : "vertical";
            const a = (i + 1) / u;
            let n = 1,
              o = 1;
            "horizontal" === r ? (n = a) : (o = a),
              e.querySelectorAll(ce(s.progressbarFillClass)).forEach((e) => {
                (e.style.transform = `translate3d(0,0,0) scaleX(${n}) scaleY(${o})`),
                  (e.style.transitionDuration = `${t.params.speed}ms`);
              });
          }
          "custom" === s.type && s.renderCustom
            ? ((e.innerHTML = s.renderCustom(t, i + 1, u)),
              0 === a && r("paginationRender", e))
            : (0 === a && r("paginationRender", e), r("paginationUpdate", e)),
            t.params.watchOverflow &&
              t.enabled &&
              e.classList[t.isLocked ? "add" : "remove"](s.lockClass);
        });
      }
      function u() {
        const e = t.params.pagination;
        if (l()) return;
        const s =
          t.virtual && t.params.virtual.enabled
            ? t.virtual.slides.length
            : t.grid && t.params.grid.rows > 1
            ? t.slides.length / Math.ceil(t.params.grid.rows)
            : t.slides.length;
        let i = t.pagination.el;
        i = L(i);
        let a = "";
        if ("bullets" === e.type) {
          let i = t.params.loop
            ? Math.ceil(s / t.params.slidesPerGroup)
            : t.snapGrid.length;
          t.params.freeMode && t.params.freeMode.enabled && i > s && (i = s);
          for (let s = 0; s < i; s += 1)
            e.renderBullet
              ? (a += e.renderBullet.call(t, s, e.bulletClass))
              : (a += `<${e.bulletElement} ${
                  t.isElement ? 'part="bullet"' : ""
                } class="${e.bulletClass}"></${e.bulletElement}>`);
        }
        "fraction" === e.type &&
          (a = e.renderFraction
            ? e.renderFraction.call(t, e.currentClass, e.totalClass)
            : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
          "progressbar" === e.type &&
            (a = e.renderProgressbar
              ? e.renderProgressbar.call(t, e.progressbarFillClass)
              : `<span class="${e.progressbarFillClass}"></span>`),
          (t.pagination.bullets = []),
          i.forEach((s) => {
            "custom" !== e.type && (s.innerHTML = a || ""),
              "bullets" === e.type &&
                t.pagination.bullets.push(
                  ...s.querySelectorAll(ce(e.bulletClass))
                );
          }),
          "custom" !== e.type && r("paginationRender", i[0]);
      }
      function m() {
        t.params.pagination = le(
          t,
          t.originalParams.pagination,
          t.params.pagination,
          { el: "swiper-pagination" }
        );
        const e = t.params.pagination;
        if (!e.el) return;
        let s;
        "string" == typeof e.el &&
          t.isElement &&
          (s = t.el.querySelector(e.el)),
          s ||
            "string" != typeof e.el ||
            (s = [...document.querySelectorAll(e.el)]),
          s || (s = e.el),
          s &&
            0 !== s.length &&
            (t.params.uniqueNavElements &&
              "string" == typeof e.el &&
              Array.isArray(s) &&
              s.length > 1 &&
              ((s = [...t.el.querySelectorAll(e.el)]),
              s.length > 1 &&
                (s = s.filter((e) => T(e, ".swiper")[0] === t.el)[0])),
            Array.isArray(s) && 1 === s.length && (s = s[0]),
            Object.assign(t.pagination, { el: s }),
            (s = L(s)),
            s.forEach((s) => {
              "bullets" === e.type &&
                e.clickable &&
                s.classList.add(...(e.clickableClass || "").split(" ")),
                s.classList.add(e.modifierClass + e.type),
                s.classList.add(
                  t.isHorizontal() ? e.horizontalClass : e.verticalClass
                ),
                "bullets" === e.type &&
                  e.dynamicBullets &&
                  (s.classList.add(`${e.modifierClass}${e.type}-dynamic`),
                  (o = 0),
                  e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                "progressbar" === e.type &&
                  e.progressbarOpposite &&
                  s.classList.add(e.progressbarOppositeClass),
                e.clickable && s.addEventListener("click", c),
                t.enabled || s.classList.add(e.lockClass);
            }));
      }
      function f() {
        const e = t.params.pagination;
        if (l()) return;
        let s = t.pagination.el;
        s &&
          ((s = L(s)),
          s.forEach((s) => {
            s.classList.remove(e.hiddenClass),
              s.classList.remove(e.modifierClass + e.type),
              s.classList.remove(
                t.isHorizontal() ? e.horizontalClass : e.verticalClass
              ),
              e.clickable &&
                (s.classList.remove(...(e.clickableClass || "").split(" ")),
                s.removeEventListener("click", c));
          })),
          t.pagination.bullets &&
            t.pagination.bullets.forEach((t) =>
              t.classList.remove(...e.bulletActiveClass.split(" "))
            );
      }
      i("changeDirection", () => {
        if (!t.pagination || !t.pagination.el) return;
        const e = t.params.pagination;
        let { el: s } = t.pagination;
        (s = L(s)),
          s.forEach((s) => {
            s.classList.remove(e.horizontalClass, e.verticalClass),
              s.classList.add(
                t.isHorizontal() ? e.horizontalClass : e.verticalClass
              );
          });
      }),
        i("init", () => {
          !1 === t.params.pagination.enabled ? h() : (m(), u(), p());
        }),
        i("activeIndexChange", () => {
          void 0 === t.snapIndex && p();
        }),
        i("snapIndexChange", () => {
          p();
        }),
        i("snapGridLengthChange", () => {
          u(), p();
        }),
        i("destroy", () => {
          f();
        }),
        i("enable disable", () => {
          let { el: e } = t.pagination;
          e &&
            ((e = L(e)),
            e.forEach((e) =>
              e.classList[t.enabled ? "remove" : "add"](
                t.params.pagination.lockClass
              )
            ));
        }),
        i("lock unlock", () => {
          p();
        }),
        i("click", (e, s) => {
          const i = s.target,
            a = L(t.pagination.el);
          if (
            t.params.pagination.el &&
            t.params.pagination.hideOnClick &&
            a &&
            a.length > 0 &&
            !i.classList.contains(t.params.pagination.bulletClass)
          ) {
            if (
              t.navigation &&
              ((t.navigation.nextEl && i === t.navigation.nextEl) ||
                (t.navigation.prevEl && i === t.navigation.prevEl))
            )
              return;
            const e = a[0].classList.contains(t.params.pagination.hiddenClass);
            r(!0 === e ? "paginationShow" : "paginationHide"),
              a.forEach((e) =>
                e.classList.toggle(t.params.pagination.hiddenClass)
              );
          }
        });
      const h = () => {
        t.el.classList.add(t.params.pagination.paginationDisabledClass);
        let { el: e } = t.pagination;
        e &&
          ((e = L(e)),
          e.forEach((e) =>
            e.classList.add(t.params.pagination.paginationDisabledClass)
          )),
          f();
      };
      Object.assign(t.pagination, {
        enable: () => {
          t.el.classList.remove(t.params.pagination.paginationDisabledClass);
          let { el: e } = t.pagination;
          e &&
            ((e = L(e)),
            e.forEach((e) =>
              e.classList.remove(t.params.pagination.paginationDisabledClass)
            )),
            m(),
            u(),
            p();
        },
        disable: h,
        render: u,
        update: p,
        init: m,
        destroy: f,
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i, emit: r } = e;
      const a = n();
      let o,
        l,
        p,
        u,
        m = !1,
        f = null,
        h = null;
      function v() {
        if (!t.params.scrollbar.el || !t.scrollbar.el) return;
        const { scrollbar: e, rtlTranslate: s } = t,
          { dragEl: i, el: r } = e,
          a = t.params.scrollbar,
          n = t.params.loop ? t.progressLoop : t.progress;
        let o = l,
          d = (p - l) * n;
        s
          ? ((d = -d),
            d > 0 ? ((o = l - d), (d = 0)) : -d + l > p && (o = p + d))
          : d < 0
          ? ((o = l + d), (d = 0))
          : d + l > p && (o = p - d),
          t.isHorizontal()
            ? ((i.style.transform = `translate3d(${d}px, 0, 0)`),
              (i.style.width = `${o}px`))
            : ((i.style.transform = `translate3d(0px, ${d}px, 0)`),
              (i.style.height = `${o}px`)),
          a.hide &&
            (clearTimeout(f),
            (r.style.opacity = 1),
            (f = setTimeout(() => {
              (r.style.opacity = 0), (r.style.transitionDuration = "400ms");
            }, 1e3)));
      }
      function g() {
        if (!t.params.scrollbar.el || !t.scrollbar.el) return;
        const { scrollbar: e } = t,
          { dragEl: s, el: i } = e;
        (s.style.width = ""),
          (s.style.height = ""),
          (p = t.isHorizontal() ? i.offsetWidth : i.offsetHeight),
          (u =
            t.size /
            (t.virtualSize +
              t.params.slidesOffsetBefore -
              (t.params.centeredSlides ? t.snapGrid[0] : 0))),
          (l =
            "auto" === t.params.scrollbar.dragSize
              ? p * u
              : parseInt(t.params.scrollbar.dragSize, 10)),
          t.isHorizontal()
            ? (s.style.width = `${l}px`)
            : (s.style.height = `${l}px`),
          (i.style.display = u >= 1 ? "none" : ""),
          t.params.scrollbar.hide && (i.style.opacity = 0),
          t.params.watchOverflow &&
            t.enabled &&
            e.el.classList[t.isLocked ? "add" : "remove"](
              t.params.scrollbar.lockClass
            );
      }
      function w(e) {
        return t.isHorizontal() ? e.clientX : e.clientY;
      }
      function y(e) {
        const { scrollbar: s, rtlTranslate: i } = t,
          { el: r } = s;
        let a;
        (a =
          (w(e) -
            E(r)[t.isHorizontal() ? "left" : "top"] -
            (null !== o ? o : l / 2)) /
          (p - l)),
          (a = Math.max(Math.min(a, 1), 0)),
          i && (a = 1 - a);
        const n = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * a;
        t.updateProgress(n),
          t.setTranslate(n),
          t.updateActiveIndex(),
          t.updateSlidesClasses();
      }
      function x(e) {
        const s = t.params.scrollbar,
          { scrollbar: i, wrapperEl: a } = t,
          { el: n, dragEl: l } = i;
        (m = !0),
          (o =
            e.target === l
              ? w(e) -
                e.target.getBoundingClientRect()[
                  t.isHorizontal() ? "left" : "top"
                ]
              : null),
          e.preventDefault(),
          e.stopPropagation(),
          (a.style.transitionDuration = "100ms"),
          (l.style.transitionDuration = "100ms"),
          y(e),
          clearTimeout(h),
          (n.style.transitionDuration = "0ms"),
          s.hide && (n.style.opacity = 1),
          t.params.cssMode && (t.wrapperEl.style["scroll-snap-type"] = "none"),
          r("scrollbarDragStart", e);
      }
      function S(e) {
        const { scrollbar: s, wrapperEl: i } = t,
          { el: a, dragEl: n } = s;
        m &&
          (e.preventDefault && e.cancelable
            ? e.preventDefault()
            : (e.returnValue = !1),
          y(e),
          (i.style.transitionDuration = "0ms"),
          (a.style.transitionDuration = "0ms"),
          (n.style.transitionDuration = "0ms"),
          r("scrollbarDragMove", e));
      }
      function T(e) {
        const s = t.params.scrollbar,
          { scrollbar: i, wrapperEl: a } = t,
          { el: n } = i;
        m &&
          ((m = !1),
          t.params.cssMode &&
            ((t.wrapperEl.style["scroll-snap-type"] = ""),
            (a.style.transitionDuration = "")),
          s.hide &&
            (clearTimeout(h),
            (h = c(() => {
              (n.style.opacity = 0), (n.style.transitionDuration = "400ms");
            }, 1e3))),
          r("scrollbarDragEnd", e),
          s.snapOnRelease && t.slideToClosest());
      }
      function M(e) {
        const { scrollbar: s, params: i } = t,
          r = s.el;
        if (!r) return;
        const n = r,
          o = !!i.passiveListeners && { passive: !1, capture: !1 },
          l = !!i.passiveListeners && { passive: !0, capture: !1 };
        if (!n) return;
        const d = "on" === e ? "addEventListener" : "removeEventListener";
        n[d]("pointerdown", x, o),
          a[d]("pointermove", S, o),
          a[d]("pointerup", T, l);
      }
      function C() {
        const { scrollbar: e, el: s } = t;
        t.params.scrollbar = le(
          t,
          t.originalParams.scrollbar,
          t.params.scrollbar,
          { el: "swiper-scrollbar" }
        );
        const i = t.params.scrollbar;
        if (!i.el) return;
        let r, n;
        if (
          ("string" == typeof i.el &&
            t.isElement &&
            (r = t.el.querySelector(i.el)),
          r || "string" != typeof i.el)
        )
          r || (r = i.el);
        else if (((r = a.querySelectorAll(i.el)), !r.length)) return;
        t.params.uniqueNavElements &&
          "string" == typeof i.el &&
          r.length > 1 &&
          1 === s.querySelectorAll(i.el).length &&
          (r = s.querySelector(i.el)),
          r.length > 0 && (r = r[0]),
          r.classList.add(
            t.isHorizontal() ? i.horizontalClass : i.verticalClass
          ),
          r &&
            ((n = r.querySelector(ce(t.params.scrollbar.dragClass))),
            n || ((n = b("div", t.params.scrollbar.dragClass)), r.append(n))),
          Object.assign(e, { el: r, dragEl: n }),
          i.draggable && t.params.scrollbar.el && t.scrollbar.el && M("on"),
          r &&
            r.classList[t.enabled ? "remove" : "add"](
              ...d(t.params.scrollbar.lockClass)
            );
      }
      function P() {
        const e = t.params.scrollbar,
          s = t.scrollbar.el;
        s &&
          s.classList.remove(
            ...d(t.isHorizontal() ? e.horizontalClass : e.verticalClass)
          ),
          t.params.scrollbar.el && t.scrollbar.el && M("off");
      }
      s({
        scrollbar: {
          el: null,
          dragSize: "auto",
          hide: !1,
          draggable: !1,
          snapOnRelease: !0,
          lockClass: "swiper-scrollbar-lock",
          dragClass: "swiper-scrollbar-drag",
          scrollbarDisabledClass: "swiper-scrollbar-disabled",
          horizontalClass: "swiper-scrollbar-horizontal",
          verticalClass: "swiper-scrollbar-vertical",
        },
      }),
        (t.scrollbar = { el: null, dragEl: null }),
        i("changeDirection", () => {
          if (!t.scrollbar || !t.scrollbar.el) return;
          const e = t.params.scrollbar;
          let { el: s } = t.scrollbar;
          (s = L(s)),
            s.forEach((s) => {
              s.classList.remove(e.horizontalClass, e.verticalClass),
                s.classList.add(
                  t.isHorizontal() ? e.horizontalClass : e.verticalClass
                );
            });
        }),
        i("init", () => {
          !1 === t.params.scrollbar.enabled ? k() : (C(), g(), v());
        }),
        i("update resize observerUpdate lock unlock changeDirection", () => {
          g();
        }),
        i("setTranslate", () => {
          v();
        }),
        i("setTransition", (e, s) => {
          !(function (e) {
            t.params.scrollbar.el &&
              t.scrollbar.el &&
              (t.scrollbar.dragEl.style.transitionDuration = `${e}ms`);
          })(s);
        }),
        i("enable disable", () => {
          const { el: e } = t.scrollbar;
          e &&
            e.classList[t.enabled ? "remove" : "add"](
              ...d(t.params.scrollbar.lockClass)
            );
        }),
        i("destroy", () => {
          P();
        });
      const k = () => {
        t.el.classList.add(...d(t.params.scrollbar.scrollbarDisabledClass)),
          t.scrollbar.el &&
            t.scrollbar.el.classList.add(
              ...d(t.params.scrollbar.scrollbarDisabledClass)
            ),
          P();
      };
      Object.assign(t.scrollbar, {
        enable: () => {
          t.el.classList.remove(
            ...d(t.params.scrollbar.scrollbarDisabledClass)
          ),
            t.scrollbar.el &&
              t.scrollbar.el.classList.remove(
                ...d(t.params.scrollbar.scrollbarDisabledClass)
              ),
            C(),
            g(),
            v();
        },
        disable: k,
        updateSize: g,
        setTranslate: v,
        init: C,
        destroy: P,
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({ parallax: { enabled: !1 } });
      const r =
          "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",
        a = (e, s) => {
          const { rtl: i } = t,
            r = i ? -1 : 1,
            a = e.getAttribute("data-swiper-parallax") || "0";
          let n = e.getAttribute("data-swiper-parallax-x"),
            o = e.getAttribute("data-swiper-parallax-y");
          const l = e.getAttribute("data-swiper-parallax-scale"),
            d = e.getAttribute("data-swiper-parallax-opacity"),
            c = e.getAttribute("data-swiper-parallax-rotate");
          if (
            (n || o
              ? ((n = n || "0"), (o = o || "0"))
              : t.isHorizontal()
              ? ((n = a), (o = "0"))
              : ((o = a), (n = "0")),
            (n =
              n.indexOf("%") >= 0
                ? parseInt(n, 10) * s * r + "%"
                : n * s * r + "px"),
            (o =
              o.indexOf("%") >= 0 ? parseInt(o, 10) * s + "%" : o * s + "px"),
            null != d)
          ) {
            const t = d - (d - 1) * (1 - Math.abs(s));
            e.style.opacity = t;
          }
          let p = `translate3d(${n}, ${o}, 0px)`;
          if (null != l) {
            p += ` scale(${l - (l - 1) * (1 - Math.abs(s))})`;
          }
          if (c && null != c) {
            p += ` rotate(${c * s * -1}deg)`;
          }
          e.style.transform = p;
        },
        n = () => {
          const {
              el: e,
              slides: s,
              progress: i,
              snapGrid: n,
              isElement: o,
            } = t,
            l = w(e, r);
          t.isElement && l.push(...w(t.hostEl, r)),
            l.forEach((e) => {
              a(e, i);
            }),
            s.forEach((e, s) => {
              let o = e.progress;
              t.params.slidesPerGroup > 1 &&
                "auto" !== t.params.slidesPerView &&
                (o += Math.ceil(s / 2) - i * (n.length - 1)),
                (o = Math.min(Math.max(o, -1), 1)),
                e
                  .querySelectorAll(`${r}, [data-swiper-parallax-rotate]`)
                  .forEach((e) => {
                    a(e, o);
                  });
            });
        };
      i("beforeInit", () => {
        t.params.parallax.enabled &&
          ((t.params.watchSlidesProgress = !0),
          (t.originalParams.watchSlidesProgress = !0));
      }),
        i("init", () => {
          t.params.parallax.enabled && n();
        }),
        i("setTranslate", () => {
          t.params.parallax.enabled && n();
        }),
        i("setTransition", (e, s) => {
          t.params.parallax.enabled &&
            (function (e) {
              void 0 === e && (e = t.params.speed);
              const { el: s, hostEl: i } = t,
                a = [...s.querySelectorAll(r)];
              t.isElement && a.push(...i.querySelectorAll(r)),
                a.forEach((t) => {
                  let s =
                    parseInt(
                      t.getAttribute("data-swiper-parallax-duration"),
                      10
                    ) || e;
                  0 === e && (s = 0), (t.style.transitionDuration = `${s}ms`);
                });
            })(s);
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i, emit: r } = e;
      const a = l();
      s({
        zoom: {
          enabled: !1,
          limitToOriginalSize: !1,
          maxRatio: 3,
          minRatio: 1,
          toggle: !0,
          containerClass: "swiper-zoom-container",
          zoomedSlideClass: "swiper-slide-zoomed",
        },
      }),
        (t.zoom = { enabled: !1 });
      let n,
        o,
        d = 1,
        c = !1;
      const p = [],
        m = {
          originX: 0,
          originY: 0,
          slideEl: void 0,
          slideWidth: void 0,
          slideHeight: void 0,
          imageEl: void 0,
          imageWrapEl: void 0,
          maxRatio: 3,
        },
        f = {
          isTouched: void 0,
          isMoved: void 0,
          currentX: void 0,
          currentY: void 0,
          minX: void 0,
          minY: void 0,
          maxX: void 0,
          maxY: void 0,
          width: void 0,
          height: void 0,
          startX: void 0,
          startY: void 0,
          touchesStart: {},
          touchesCurrent: {},
        },
        h = {
          x: void 0,
          y: void 0,
          prevPositionX: void 0,
          prevPositionY: void 0,
          prevTime: void 0,
        };
      let v,
        g = 1;
      function y() {
        if (p.length < 2) return 1;
        const e = p[0].pageX,
          t = p[0].pageY,
          s = p[1].pageX,
          i = p[1].pageY;
        return Math.sqrt((s - e) ** 2 + (i - t) ** 2);
      }
      function b() {
        const e = t.params.zoom,
          s = m.imageWrapEl.getAttribute("data-swiper-zoom") || e.maxRatio;
        if (e.limitToOriginalSize && m.imageEl && m.imageEl.naturalWidth) {
          const e = m.imageEl.naturalWidth / m.imageEl.offsetWidth;
          return Math.min(e, s);
        }
        return s;
      }
      function x(e) {
        const s = t.isElement ? "swiper-slide" : `.${t.params.slideClass}`;
        return (
          !!e.target.matches(s) ||
          t.slides.filter((t) => t.contains(e.target)).length > 0
        );
      }
      function S(e) {
        if (("mouse" === e.pointerType && p.splice(0, p.length), !x(e))) return;
        const s = t.params.zoom;
        if (((n = !1), (o = !1), p.push(e), !(p.length < 2))) {
          if (((n = !0), (m.scaleStart = y()), !m.slideEl)) {
            (m.slideEl = e.target.closest(
              `.${t.params.slideClass}, swiper-slide`
            )),
              m.slideEl || (m.slideEl = t.slides[t.activeIndex]);
            let i = m.slideEl.querySelector(`.${s.containerClass}`);
            if (
              (i &&
                (i = i.querySelectorAll(
                  "picture, img, svg, canvas, .swiper-zoom-target"
                )[0]),
              (m.imageEl = i),
              (m.imageWrapEl = i
                ? T(m.imageEl, `.${s.containerClass}`)[0]
                : void 0),
              !m.imageWrapEl)
            )
              return void (m.imageEl = void 0);
            m.maxRatio = b();
          }
          if (m.imageEl) {
            const [e, t] = (function () {
              if (p.length < 2) return { x: null, y: null };
              const e = m.imageEl.getBoundingClientRect();
              return [
                (p[0].pageX + (p[1].pageX - p[0].pageX) / 2 - e.x - a.scrollX) /
                  d,
                (p[0].pageY + (p[1].pageY - p[0].pageY) / 2 - e.y - a.scrollY) /
                  d,
              ];
            })();
            (m.originX = e),
              (m.originY = t),
              (m.imageEl.style.transitionDuration = "0ms");
          }
          c = !0;
        }
      }
      function M(e) {
        if (!x(e)) return;
        const s = t.params.zoom,
          i = t.zoom,
          r = p.findIndex((t) => t.pointerId === e.pointerId);
        r >= 0 && (p[r] = e),
          p.length < 2 ||
            ((o = !0),
            (m.scaleMove = y()),
            m.imageEl &&
              ((i.scale = (m.scaleMove / m.scaleStart) * d),
              i.scale > m.maxRatio &&
                (i.scale = m.maxRatio - 1 + (i.scale - m.maxRatio + 1) ** 0.5),
              i.scale < s.minRatio &&
                (i.scale = s.minRatio + 1 - (s.minRatio - i.scale + 1) ** 0.5),
              (m.imageEl.style.transform = `translate3d(0,0,0) scale(${i.scale})`)));
      }
      function C(e) {
        if (!x(e)) return;
        if ("mouse" === e.pointerType && "pointerout" === e.type) return;
        const s = t.params.zoom,
          i = t.zoom,
          r = p.findIndex((t) => t.pointerId === e.pointerId);
        r >= 0 && p.splice(r, 1),
          n &&
            o &&
            ((n = !1),
            (o = !1),
            m.imageEl &&
              ((i.scale = Math.max(Math.min(i.scale, m.maxRatio), s.minRatio)),
              (m.imageEl.style.transitionDuration = `${t.params.speed}ms`),
              (m.imageEl.style.transform = `translate3d(0,0,0) scale(${i.scale})`),
              (d = i.scale),
              (c = !1),
              i.scale > 1 && m.slideEl
                ? m.slideEl.classList.add(`${s.zoomedSlideClass}`)
                : i.scale <= 1 &&
                  m.slideEl &&
                  m.slideEl.classList.remove(`${s.zoomedSlideClass}`),
              1 === i.scale &&
                ((m.originX = 0), (m.originY = 0), (m.slideEl = void 0))));
      }
      function L() {
        t.touchEventsData.preventTouchMoveFromPointerMove = !1;
      }
      function P(e) {
        if (
          !x(e) ||
          !(function (e) {
            const s = `.${t.params.zoom.containerClass}`;
            return (
              !!e.target.matches(s) ||
              [...t.hostEl.querySelectorAll(s)].filter((t) =>
                t.contains(e.target)
              ).length > 0
            );
          })(e)
        )
          return;
        const s = t.zoom;
        if (!m.imageEl) return;
        if (!f.isTouched || !m.slideEl) return;
        f.isMoved ||
          ((f.width = m.imageEl.offsetWidth || m.imageEl.clientWidth),
          (f.height = m.imageEl.offsetHeight || m.imageEl.clientHeight),
          (f.startX = u(m.imageWrapEl, "x") || 0),
          (f.startY = u(m.imageWrapEl, "y") || 0),
          (m.slideWidth = m.slideEl.offsetWidth),
          (m.slideHeight = m.slideEl.offsetHeight),
          (m.imageWrapEl.style.transitionDuration = "0ms"));
        const i = f.width * s.scale,
          r = f.height * s.scale;
        (f.minX = Math.min(m.slideWidth / 2 - i / 2, 0)),
          (f.maxX = -f.minX),
          (f.minY = Math.min(m.slideHeight / 2 - r / 2, 0)),
          (f.maxY = -f.minY),
          (f.touchesCurrent.x = p.length > 0 ? p[0].pageX : e.pageX),
          (f.touchesCurrent.y = p.length > 0 ? p[0].pageY : e.pageY);
        if (
          (Math.max(
            Math.abs(f.touchesCurrent.x - f.touchesStart.x),
            Math.abs(f.touchesCurrent.y - f.touchesStart.y)
          ) > 5 && (t.allowClick = !1),
          !f.isMoved && !c)
        ) {
          if (
            t.isHorizontal() &&
            ((Math.floor(f.minX) === Math.floor(f.startX) &&
              f.touchesCurrent.x < f.touchesStart.x) ||
              (Math.floor(f.maxX) === Math.floor(f.startX) &&
                f.touchesCurrent.x > f.touchesStart.x))
          )
            return (f.isTouched = !1), void L();
          if (
            !t.isHorizontal() &&
            ((Math.floor(f.minY) === Math.floor(f.startY) &&
              f.touchesCurrent.y < f.touchesStart.y) ||
              (Math.floor(f.maxY) === Math.floor(f.startY) &&
                f.touchesCurrent.y > f.touchesStart.y))
          )
            return (f.isTouched = !1), void L();
        }
        e.cancelable && e.preventDefault(),
          e.stopPropagation(),
          clearTimeout(v),
          (t.touchEventsData.preventTouchMoveFromPointerMove = !0),
          (v = setTimeout(() => {
            t.destroyed || L();
          })),
          (f.isMoved = !0);
        const a = (s.scale - d) / (m.maxRatio - t.params.zoom.minRatio),
          { originX: n, originY: o } = m;
        (f.currentX =
          f.touchesCurrent.x -
          f.touchesStart.x +
          f.startX +
          a * (f.width - 2 * n)),
          (f.currentY =
            f.touchesCurrent.y -
            f.touchesStart.y +
            f.startY +
            a * (f.height - 2 * o)),
          f.currentX < f.minX &&
            (f.currentX = f.minX + 1 - (f.minX - f.currentX + 1) ** 0.8),
          f.currentX > f.maxX &&
            (f.currentX = f.maxX - 1 + (f.currentX - f.maxX + 1) ** 0.8),
          f.currentY < f.minY &&
            (f.currentY = f.minY + 1 - (f.minY - f.currentY + 1) ** 0.8),
          f.currentY > f.maxY &&
            (f.currentY = f.maxY - 1 + (f.currentY - f.maxY + 1) ** 0.8),
          h.prevPositionX || (h.prevPositionX = f.touchesCurrent.x),
          h.prevPositionY || (h.prevPositionY = f.touchesCurrent.y),
          h.prevTime || (h.prevTime = Date.now()),
          (h.x =
            (f.touchesCurrent.x - h.prevPositionX) /
            (Date.now() - h.prevTime) /
            2),
          (h.y =
            (f.touchesCurrent.y - h.prevPositionY) /
            (Date.now() - h.prevTime) /
            2),
          Math.abs(f.touchesCurrent.x - h.prevPositionX) < 2 && (h.x = 0),
          Math.abs(f.touchesCurrent.y - h.prevPositionY) < 2 && (h.y = 0),
          (h.prevPositionX = f.touchesCurrent.x),
          (h.prevPositionY = f.touchesCurrent.y),
          (h.prevTime = Date.now()),
          (m.imageWrapEl.style.transform = `translate3d(${f.currentX}px, ${f.currentY}px,0)`);
      }
      function k() {
        const e = t.zoom;
        m.slideEl &&
          t.activeIndex !== t.slides.indexOf(m.slideEl) &&
          (m.imageEl &&
            (m.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
          m.imageWrapEl &&
            (m.imageWrapEl.style.transform = "translate3d(0,0,0)"),
          m.slideEl.classList.remove(`${t.params.zoom.zoomedSlideClass}`),
          (e.scale = 1),
          (d = 1),
          (m.slideEl = void 0),
          (m.imageEl = void 0),
          (m.imageWrapEl = void 0),
          (m.originX = 0),
          (m.originY = 0));
      }
      function A(e) {
        const s = t.zoom,
          i = t.params.zoom;
        if (!m.slideEl) {
          e &&
            e.target &&
            (m.slideEl = e.target.closest(
              `.${t.params.slideClass}, swiper-slide`
            )),
            m.slideEl ||
              (t.params.virtual && t.params.virtual.enabled && t.virtual
                ? (m.slideEl = w(
                    t.slidesEl,
                    `.${t.params.slideActiveClass}`
                  )[0])
                : (m.slideEl = t.slides[t.activeIndex]));
          let s = m.slideEl.querySelector(`.${i.containerClass}`);
          s &&
            (s = s.querySelectorAll(
              "picture, img, svg, canvas, .swiper-zoom-target"
            )[0]),
            (m.imageEl = s),
            (m.imageWrapEl = s
              ? T(m.imageEl, `.${i.containerClass}`)[0]
              : void 0);
        }
        if (!m.imageEl || !m.imageWrapEl) return;
        let r, n, o, l, c, p, u, h, v, g, y, x, S, M, C, L, P, k;
        t.params.cssMode &&
          ((t.wrapperEl.style.overflow = "hidden"),
          (t.wrapperEl.style.touchAction = "none")),
          m.slideEl.classList.add(`${i.zoomedSlideClass}`),
          void 0 === f.touchesStart.x && e
            ? ((r = e.pageX), (n = e.pageY))
            : ((r = f.touchesStart.x), (n = f.touchesStart.y));
        const A = "number" == typeof e ? e : null;
        1 === d &&
          A &&
          ((r = void 0),
          (n = void 0),
          (f.touchesStart.x = void 0),
          (f.touchesStart.y = void 0));
        const z = b();
        (s.scale = A || z),
          (d = A || z),
          !e || (1 === d && A)
            ? ((u = 0), (h = 0))
            : ((P = m.slideEl.offsetWidth),
              (k = m.slideEl.offsetHeight),
              (o = E(m.slideEl).left + a.scrollX),
              (l = E(m.slideEl).top + a.scrollY),
              (c = o + P / 2 - r),
              (p = l + k / 2 - n),
              (v = m.imageEl.offsetWidth || m.imageEl.clientWidth),
              (g = m.imageEl.offsetHeight || m.imageEl.clientHeight),
              (y = v * s.scale),
              (x = g * s.scale),
              (S = Math.min(P / 2 - y / 2, 0)),
              (M = Math.min(k / 2 - x / 2, 0)),
              (C = -S),
              (L = -M),
              (u = c * s.scale),
              (h = p * s.scale),
              u < S && (u = S),
              u > C && (u = C),
              h < M && (h = M),
              h > L && (h = L)),
          A && 1 === s.scale && ((m.originX = 0), (m.originY = 0)),
          (m.imageWrapEl.style.transitionDuration = "300ms"),
          (m.imageWrapEl.style.transform = `translate3d(${u}px, ${h}px,0)`),
          (m.imageEl.style.transitionDuration = "300ms"),
          (m.imageEl.style.transform = `translate3d(0,0,0) scale(${s.scale})`);
      }
      function z() {
        const e = t.zoom,
          s = t.params.zoom;
        if (!m.slideEl) {
          t.params.virtual && t.params.virtual.enabled && t.virtual
            ? (m.slideEl = w(t.slidesEl, `.${t.params.slideActiveClass}`)[0])
            : (m.slideEl = t.slides[t.activeIndex]);
          let e = m.slideEl.querySelector(`.${s.containerClass}`);
          e &&
            (e = e.querySelectorAll(
              "picture, img, svg, canvas, .swiper-zoom-target"
            )[0]),
            (m.imageEl = e),
            (m.imageWrapEl = e
              ? T(m.imageEl, `.${s.containerClass}`)[0]
              : void 0);
        }
        m.imageEl &&
          m.imageWrapEl &&
          (t.params.cssMode &&
            ((t.wrapperEl.style.overflow = ""),
            (t.wrapperEl.style.touchAction = "")),
          (e.scale = 1),
          (d = 1),
          (f.touchesStart.x = void 0),
          (f.touchesStart.y = void 0),
          (m.imageWrapEl.style.transitionDuration = "300ms"),
          (m.imageWrapEl.style.transform = "translate3d(0,0,0)"),
          (m.imageEl.style.transitionDuration = "300ms"),
          (m.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
          m.slideEl.classList.remove(`${s.zoomedSlideClass}`),
          (m.slideEl = void 0),
          (m.originX = 0),
          (m.originY = 0));
      }
      function I(e) {
        const s = t.zoom;
        s.scale && 1 !== s.scale ? z() : A(e);
      }
      function O() {
        return {
          passiveListener: !!t.params.passiveListeners && {
            passive: !0,
            capture: !1,
          },
          activeListenerWithCapture: !t.params.passiveListeners || {
            passive: !1,
            capture: !0,
          },
        };
      }
      function $() {
        const e = t.zoom;
        if (e.enabled) return;
        e.enabled = !0;
        const { passiveListener: s, activeListenerWithCapture: i } = O();
        t.wrapperEl.addEventListener("pointerdown", S, s),
          t.wrapperEl.addEventListener("pointermove", M, i),
          ["pointerup", "pointercancel", "pointerout"].forEach((e) => {
            t.wrapperEl.addEventListener(e, C, s);
          }),
          t.wrapperEl.addEventListener("pointermove", P, i);
      }
      function D() {
        const e = t.zoom;
        if (!e.enabled) return;
        e.enabled = !1;
        const { passiveListener: s, activeListenerWithCapture: i } = O();
        t.wrapperEl.removeEventListener("pointerdown", S, s),
          t.wrapperEl.removeEventListener("pointermove", M, i),
          ["pointerup", "pointercancel", "pointerout"].forEach((e) => {
            t.wrapperEl.removeEventListener(e, C, s);
          }),
          t.wrapperEl.removeEventListener("pointermove", P, i);
      }
      Object.defineProperty(t.zoom, "scale", {
        get: () => g,
        set(e) {
          if (g !== e) {
            const t = m.imageEl,
              s = m.slideEl;
            r("zoomChange", e, t, s);
          }
          g = e;
        },
      }),
        i("init", () => {
          t.params.zoom.enabled && $();
        }),
        i("destroy", () => {
          D();
        }),
        i("touchStart", (e, s) => {
          t.zoom.enabled &&
            (function (e) {
              const s = t.device;
              if (!m.imageEl) return;
              if (f.isTouched) return;
              s.android && e.cancelable && e.preventDefault(),
                (f.isTouched = !0);
              const i = p.length > 0 ? p[0] : e;
              (f.touchesStart.x = i.pageX), (f.touchesStart.y = i.pageY);
            })(s);
        }),
        i("touchEnd", (e, s) => {
          t.zoom.enabled &&
            (function () {
              const e = t.zoom;
              if (!m.imageEl) return;
              if (!f.isTouched || !f.isMoved)
                return (f.isTouched = !1), void (f.isMoved = !1);
              (f.isTouched = !1), (f.isMoved = !1);
              let s = 300,
                i = 300;
              const r = h.x * s,
                a = f.currentX + r,
                n = h.y * i,
                o = f.currentY + n;
              0 !== h.x && (s = Math.abs((a - f.currentX) / h.x)),
                0 !== h.y && (i = Math.abs((o - f.currentY) / h.y));
              const l = Math.max(s, i);
              (f.currentX = a), (f.currentY = o);
              const d = f.width * e.scale,
                c = f.height * e.scale;
              (f.minX = Math.min(m.slideWidth / 2 - d / 2, 0)),
                (f.maxX = -f.minX),
                (f.minY = Math.min(m.slideHeight / 2 - c / 2, 0)),
                (f.maxY = -f.minY),
                (f.currentX = Math.max(Math.min(f.currentX, f.maxX), f.minX)),
                (f.currentY = Math.max(Math.min(f.currentY, f.maxY), f.minY)),
                (m.imageWrapEl.style.transitionDuration = `${l}ms`),
                (m.imageWrapEl.style.transform = `translate3d(${f.currentX}px, ${f.currentY}px,0)`);
            })();
        }),
        i("doubleTap", (e, s) => {
          !t.animating &&
            t.params.zoom.enabled &&
            t.zoom.enabled &&
            t.params.zoom.toggle &&
            I(s);
        }),
        i("transitionEnd", () => {
          t.zoom.enabled && t.params.zoom.enabled && k();
        }),
        i("slideChange", () => {
          t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && k();
        }),
        Object.assign(t.zoom, {
          enable: $,
          disable: D,
          in: A,
          out: z,
          toggle: I,
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      function r(e, t) {
        const s = (function () {
          let e, t, s;
          return (i, r) => {
            for (t = -1, e = i.length; e - t > 1; )
              (s = (e + t) >> 1), i[s] <= r ? (t = s) : (e = s);
            return e;
          };
        })();
        let i, r;
        return (
          (this.x = e),
          (this.y = t),
          (this.lastIndex = e.length - 1),
          (this.interpolate = function (e) {
            return e
              ? ((r = s(this.x, e)),
                (i = r - 1),
                ((e - this.x[i]) * (this.y[r] - this.y[i])) /
                  (this.x[r] - this.x[i]) +
                  this.y[i])
              : 0;
          }),
          this
        );
      }
      function a() {
        t.controller.control &&
          t.controller.spline &&
          ((t.controller.spline = void 0), delete t.controller.spline);
      }
      s({ controller: { control: void 0, inverse: !1, by: "slide" } }),
        (t.controller = { control: void 0 }),
        i("beforeInit", () => {
          if (
            "undefined" != typeof window &&
            ("string" == typeof t.params.controller.control ||
              t.params.controller.control instanceof HTMLElement)
          ) {
            ("string" == typeof t.params.controller.control
              ? [...document.querySelectorAll(t.params.controller.control)]
              : [t.params.controller.control]
            ).forEach((e) => {
              if (
                (t.controller.control || (t.controller.control = []),
                e && e.swiper)
              )
                t.controller.control.push(e.swiper);
              else if (e) {
                const s = `${t.params.eventsPrefix}init`,
                  i = (r) => {
                    t.controller.control.push(r.detail[0]),
                      t.update(),
                      e.removeEventListener(s, i);
                  };
                e.addEventListener(s, i);
              }
            });
          } else t.controller.control = t.params.controller.control;
        }),
        i("update", () => {
          a();
        }),
        i("resize", () => {
          a();
        }),
        i("observerUpdate", () => {
          a();
        }),
        i("setTranslate", (e, s, i) => {
          t.controller.control &&
            !t.controller.control.destroyed &&
            t.controller.setTranslate(s, i);
        }),
        i("setTransition", (e, s, i) => {
          t.controller.control &&
            !t.controller.control.destroyed &&
            t.controller.setTransition(s, i);
        }),
        Object.assign(t.controller, {
          setTranslate: function (e, s) {
            const i = t.controller.control;
            let a, n;
            const o = t.constructor;
            function l(e) {
              if (e.destroyed) return;
              const s = t.rtlTranslate ? -t.translate : t.translate;
              "slide" === t.params.controller.by &&
                (!(function (e) {
                  t.controller.spline = t.params.loop
                    ? new r(t.slidesGrid, e.slidesGrid)
                    : new r(t.snapGrid, e.snapGrid);
                })(e),
                (n = -t.controller.spline.interpolate(-s))),
                (n && "container" !== t.params.controller.by) ||
                  ((a =
                    (e.maxTranslate() - e.minTranslate()) /
                    (t.maxTranslate() - t.minTranslate())),
                  (!Number.isNaN(a) && Number.isFinite(a)) || (a = 1),
                  (n = (s - t.minTranslate()) * a + e.minTranslate())),
                t.params.controller.inverse && (n = e.maxTranslate() - n),
                e.updateProgress(n),
                e.setTranslate(n, t),
                e.updateActiveIndex(),
                e.updateSlidesClasses();
            }
            if (Array.isArray(i))
              for (let e = 0; e < i.length; e += 1)
                i[e] !== s && i[e] instanceof o && l(i[e]);
            else i instanceof o && s !== i && l(i);
          },
          setTransition: function (e, s) {
            const i = t.constructor,
              r = t.controller.control;
            let a;
            function n(s) {
              s.destroyed ||
                (s.setTransition(e, t),
                0 !== e &&
                  (s.transitionStart(),
                  s.params.autoHeight &&
                    c(() => {
                      s.updateAutoHeight();
                    }),
                  M(s.wrapperEl, () => {
                    r && s.transitionEnd();
                  })));
            }
            if (Array.isArray(r))
              for (a = 0; a < r.length; a += 1)
                r[a] !== s && r[a] instanceof i && n(r[a]);
            else r instanceof i && s !== r && n(r);
          },
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({
        a11y: {
          enabled: !0,
          notificationClass: "swiper-notification",
          prevSlideMessage: "Previous slide",
          nextSlideMessage: "Next slide",
          firstSlideMessage: "This is the first slide",
          lastSlideMessage: "This is the last slide",
          paginationBulletMessage: "Go to slide {{index}}",
          slideLabelMessage: "{{index}} / {{slidesLength}}",
          containerMessage: null,
          containerRoleDescriptionMessage: null,
          containerRole: null,
          itemRoleDescriptionMessage: null,
          slideRole: "group",
          id: null,
          scrollOnFocus: !0,
        },
      }),
        (t.a11y = { clicked: !1 });
      let r,
        a,
        o = null,
        l = new Date().getTime();
      function d(e) {
        const t = o;
        0 !== t.length && ((t.innerHTML = ""), (t.innerHTML = e));
      }
      function c(e) {
        (e = L(e)).forEach((e) => {
          e.setAttribute("tabIndex", "0");
        });
      }
      function p(e) {
        (e = L(e)).forEach((e) => {
          e.setAttribute("tabIndex", "-1");
        });
      }
      function u(e, t) {
        (e = L(e)).forEach((e) => {
          e.setAttribute("role", t);
        });
      }
      function m(e, t) {
        (e = L(e)).forEach((e) => {
          e.setAttribute("aria-roledescription", t);
        });
      }
      function f(e, t) {
        (e = L(e)).forEach((e) => {
          e.setAttribute("aria-label", t);
        });
      }
      function h(e) {
        (e = L(e)).forEach((e) => {
          e.setAttribute("aria-disabled", !0);
        });
      }
      function v(e) {
        (e = L(e)).forEach((e) => {
          e.setAttribute("aria-disabled", !1);
        });
      }
      function g(e) {
        if (13 !== e.keyCode && 32 !== e.keyCode) return;
        const s = t.params.a11y,
          i = e.target;
        if (
          !t.pagination ||
          !t.pagination.el ||
          (i !== t.pagination.el && !t.pagination.el.contains(e.target)) ||
          e.target.matches(ce(t.params.pagination.bulletClass))
        ) {
          if (t.navigation && t.navigation.prevEl && t.navigation.nextEl) {
            const e = L(t.navigation.prevEl);
            L(t.navigation.nextEl).includes(i) &&
              ((t.isEnd && !t.params.loop) || t.slideNext(),
              t.isEnd ? d(s.lastSlideMessage) : d(s.nextSlideMessage)),
              e.includes(i) &&
                ((t.isBeginning && !t.params.loop) || t.slidePrev(),
                t.isBeginning ? d(s.firstSlideMessage) : d(s.prevSlideMessage));
          }
          t.pagination &&
            i.matches(ce(t.params.pagination.bulletClass)) &&
            i.click();
        }
      }
      function w() {
        return (
          t.pagination && t.pagination.bullets && t.pagination.bullets.length
        );
      }
      function y() {
        return w() && t.params.pagination.clickable;
      }
      const E = (e, t, s) => {
          c(e),
            "BUTTON" !== e.tagName &&
              (u(e, "button"), e.addEventListener("keydown", g)),
            f(e, s),
            (function (e, t) {
              (e = L(e)).forEach((e) => {
                e.setAttribute("aria-controls", t);
              });
            })(e, t);
        },
        x = (e) => {
          a && a !== e.target && !a.contains(e.target) && (r = !0),
            (t.a11y.clicked = !0);
        },
        T = () => {
          (r = !1),
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                t.destroyed || (t.a11y.clicked = !1);
              });
            });
        },
        M = (e) => {
          l = new Date().getTime();
        },
        C = (e) => {
          if (t.a11y.clicked || !t.params.a11y.scrollOnFocus) return;
          if (new Date().getTime() - l < 100) return;
          const s = e.target.closest(`.${t.params.slideClass}, swiper-slide`);
          if (!s || !t.slides.includes(s)) return;
          a = s;
          const i = t.slides.indexOf(s) === t.activeIndex,
            n =
              t.params.watchSlidesProgress &&
              t.visibleSlides &&
              t.visibleSlides.includes(s);
          i ||
            n ||
            (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) ||
            (t.isHorizontal() ? (t.el.scrollLeft = 0) : (t.el.scrollTop = 0),
            requestAnimationFrame(() => {
              r ||
                (t.params.loop
                  ? t.slideToLoop(
                      parseInt(s.getAttribute("data-swiper-slide-index")),
                      0
                    )
                  : t.slideTo(t.slides.indexOf(s), 0),
                (r = !1));
            }));
        },
        P = () => {
          const e = t.params.a11y;
          e.itemRoleDescriptionMessage &&
            m(t.slides, e.itemRoleDescriptionMessage),
            e.slideRole && u(t.slides, e.slideRole);
          const s = t.slides.length;
          e.slideLabelMessage &&
            t.slides.forEach((i, r) => {
              const a = t.params.loop
                ? parseInt(i.getAttribute("data-swiper-slide-index"), 10)
                : r;
              f(
                i,
                e.slideLabelMessage
                  .replace(/\{\{index\}\}/, a + 1)
                  .replace(/\{\{slidesLength\}\}/, s)
              );
            });
        },
        k = () => {
          const e = t.params.a11y;
          t.el.append(o);
          const s = t.el;
          e.containerRoleDescriptionMessage &&
            m(s, e.containerRoleDescriptionMessage),
            e.containerMessage && f(s, e.containerMessage),
            e.containerRole && u(s, e.containerRole);
          const i = t.wrapperEl,
            r =
              e.id ||
              i.getAttribute("id") ||
              `swiper-wrapper-${
                ((a = 16),
                void 0 === a && (a = 16),
                "x"
                  .repeat(a)
                  .replace(/x/g, () =>
                    Math.round(16 * Math.random()).toString(16)
                  ))
              }`;
          var a;
          const l =
            t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
          var d;
          (d = r),
            L(i).forEach((e) => {
              e.setAttribute("id", d);
            }),
            (function (e, t) {
              (e = L(e)).forEach((e) => {
                e.setAttribute("aria-live", t);
              });
            })(i, l),
            P();
          let { nextEl: c, prevEl: p } = t.navigation ? t.navigation : {};
          if (
            ((c = L(c)),
            (p = L(p)),
            c && c.forEach((t) => E(t, r, e.nextSlideMessage)),
            p && p.forEach((t) => E(t, r, e.prevSlideMessage)),
            y())
          ) {
            L(t.pagination.el).forEach((e) => {
              e.addEventListener("keydown", g);
            });
          }
          n().addEventListener("visibilitychange", M),
            t.el.addEventListener("focus", C, !0),
            t.el.addEventListener("focus", C, !0),
            t.el.addEventListener("pointerdown", x, !0),
            t.el.addEventListener("pointerup", T, !0);
        };
      i("beforeInit", () => {
        (o = b("span", t.params.a11y.notificationClass)),
          o.setAttribute("aria-live", "assertive"),
          o.setAttribute("aria-atomic", "true");
      }),
        i("afterInit", () => {
          t.params.a11y.enabled && k();
        }),
        i(
          "slidesLengthChange snapGridLengthChange slidesGridLengthChange",
          () => {
            t.params.a11y.enabled && P();
          }
        ),
        i("fromEdge toEdge afterInit lock unlock", () => {
          t.params.a11y.enabled &&
            (function () {
              if (t.params.loop || t.params.rewind || !t.navigation) return;
              const { nextEl: e, prevEl: s } = t.navigation;
              s && (t.isBeginning ? (h(s), p(s)) : (v(s), c(s))),
                e && (t.isEnd ? (h(e), p(e)) : (v(e), c(e)));
            })();
        }),
        i("paginationUpdate", () => {
          t.params.a11y.enabled &&
            (function () {
              const e = t.params.a11y;
              w() &&
                t.pagination.bullets.forEach((s) => {
                  t.params.pagination.clickable &&
                    (c(s),
                    t.params.pagination.renderBullet ||
                      (u(s, "button"),
                      f(
                        s,
                        e.paginationBulletMessage.replace(
                          /\{\{index\}\}/,
                          S(s) + 1
                        )
                      ))),
                    s.matches(ce(t.params.pagination.bulletActiveClass))
                      ? s.setAttribute("aria-current", "true")
                      : s.removeAttribute("aria-current");
                });
            })();
        }),
        i("destroy", () => {
          t.params.a11y.enabled &&
            (function () {
              o && o.remove();
              let { nextEl: e, prevEl: s } = t.navigation ? t.navigation : {};
              (e = L(e)),
                (s = L(s)),
                e && e.forEach((e) => e.removeEventListener("keydown", g)),
                s && s.forEach((e) => e.removeEventListener("keydown", g)),
                y() &&
                  L(t.pagination.el).forEach((e) => {
                    e.removeEventListener("keydown", g);
                  });
              n().removeEventListener("visibilitychange", M),
                t.el &&
                  "string" != typeof t.el &&
                  (t.el.removeEventListener("focus", C, !0),
                  t.el.removeEventListener("pointerdown", x, !0),
                  t.el.removeEventListener("pointerup", T, !0));
            })();
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({
        history: {
          enabled: !1,
          root: "",
          replaceState: !1,
          key: "slides",
          keepQuery: !1,
        },
      });
      let r = !1,
        a = {};
      const n = (e) =>
          e
            .toString()
            .replace(/\s+/g, "-")
            .replace(/[^\w-]+/g, "")
            .replace(/--+/g, "-")
            .replace(/^-+/, "")
            .replace(/-+$/, ""),
        o = (e) => {
          const t = l();
          let s;
          s = e ? new URL(e) : t.location;
          const i = s.pathname
              .slice(1)
              .split("/")
              .filter((e) => "" !== e),
            r = i.length;
          return { key: i[r - 2], value: i[r - 1] };
        },
        d = (e, s) => {
          const i = l();
          if (!r || !t.params.history.enabled) return;
          let a;
          a = t.params.url ? new URL(t.params.url) : i.location;
          const o =
            t.virtual && t.params.virtual.enabled
              ? t.slidesEl.querySelector(`[data-swiper-slide-index="${s}"]`)
              : t.slides[s];
          let d = n(o.getAttribute("data-history"));
          if (t.params.history.root.length > 0) {
            let s = t.params.history.root;
            "/" === s[s.length - 1] && (s = s.slice(0, s.length - 1)),
              (d = `${s}/${e ? `${e}/` : ""}${d}`);
          } else a.pathname.includes(e) || (d = `${e ? `${e}/` : ""}${d}`);
          t.params.history.keepQuery && (d += a.search);
          const c = i.history.state;
          (c && c.value === d) ||
            (t.params.history.replaceState
              ? i.history.replaceState({ value: d }, null, d)
              : i.history.pushState({ value: d }, null, d));
        },
        c = (e, s, i) => {
          if (s)
            for (let r = 0, a = t.slides.length; r < a; r += 1) {
              const a = t.slides[r];
              if (n(a.getAttribute("data-history")) === s) {
                const s = t.getSlideIndex(a);
                t.slideTo(s, e, i);
              }
            }
          else t.slideTo(0, e, i);
        },
        p = () => {
          (a = o(t.params.url)), c(t.params.speed, a.value, !1);
        };
      i("init", () => {
        t.params.history.enabled &&
          (() => {
            const e = l();
            if (t.params.history) {
              if (!e.history || !e.history.pushState)
                return (
                  (t.params.history.enabled = !1),
                  void (t.params.hashNavigation.enabled = !0)
                );
              (r = !0),
                (a = o(t.params.url)),
                a.key || a.value
                  ? (c(0, a.value, t.params.runCallbacksOnInit),
                    t.params.history.replaceState ||
                      e.addEventListener("popstate", p))
                  : t.params.history.replaceState ||
                    e.addEventListener("popstate", p);
            }
          })();
      }),
        i("destroy", () => {
          t.params.history.enabled &&
            (() => {
              const e = l();
              t.params.history.replaceState ||
                e.removeEventListener("popstate", p);
            })();
        }),
        i("transitionEnd _freeModeNoMomentumRelease", () => {
          r && d(t.params.history.key, t.activeIndex);
        }),
        i("slideChange", () => {
          r && t.params.cssMode && d(t.params.history.key, t.activeIndex);
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, emit: i, on: r } = e,
        a = !1;
      const o = n(),
        d = l();
      s({
        hashNavigation: {
          enabled: !1,
          replaceState: !1,
          watchState: !1,
          getSlideIndex(e, s) {
            if (t.virtual && t.params.virtual.enabled) {
              const e = t.slides.filter(
                (e) => e.getAttribute("data-hash") === s
              )[0];
              if (!e) return 0;
              return parseInt(e.getAttribute("data-swiper-slide-index"), 10);
            }
            return t.getSlideIndex(
              w(
                t.slidesEl,
                `.${t.params.slideClass}[data-hash="${s}"], swiper-slide[data-hash="${s}"]`
              )[0]
            );
          },
        },
      });
      const c = () => {
          i("hashChange");
          const e = o.location.hash.replace("#", ""),
            s =
              t.virtual && t.params.virtual.enabled
                ? t.slidesEl.querySelector(
                    `[data-swiper-slide-index="${t.activeIndex}"]`
                  )
                : t.slides[t.activeIndex];
          if (e !== (s ? s.getAttribute("data-hash") : "")) {
            const s = t.params.hashNavigation.getSlideIndex(t, e);
            if (void 0 === s || Number.isNaN(s)) return;
            t.slideTo(s);
          }
        },
        p = () => {
          if (!a || !t.params.hashNavigation.enabled) return;
          const e =
              t.virtual && t.params.virtual.enabled
                ? t.slidesEl.querySelector(
                    `[data-swiper-slide-index="${t.activeIndex}"]`
                  )
                : t.slides[t.activeIndex],
            s = e
              ? e.getAttribute("data-hash") || e.getAttribute("data-history")
              : "";
          t.params.hashNavigation.replaceState &&
          d.history &&
          d.history.replaceState
            ? (d.history.replaceState(null, null, `#${s}` || ""), i("hashSet"))
            : ((o.location.hash = s || ""), i("hashSet"));
        };
      r("init", () => {
        t.params.hashNavigation.enabled &&
          (() => {
            if (
              !t.params.hashNavigation.enabled ||
              (t.params.history && t.params.history.enabled)
            )
              return;
            a = !0;
            const e = o.location.hash.replace("#", "");
            if (e) {
              const s = 0,
                i = t.params.hashNavigation.getSlideIndex(t, e);
              t.slideTo(i || 0, s, t.params.runCallbacksOnInit, !0);
            }
            t.params.hashNavigation.watchState &&
              d.addEventListener("hashchange", c);
          })();
      }),
        r("destroy", () => {
          t.params.hashNavigation.enabled &&
            t.params.hashNavigation.watchState &&
            d.removeEventListener("hashchange", c);
        }),
        r("transitionEnd _freeModeNoMomentumRelease", () => {
          a && p();
        }),
        r("slideChange", () => {
          a && t.params.cssMode && p();
        });
    },
    function (e) {
      let t,
        s,
        { swiper: i, extendParams: r, on: a, emit: o, params: l } = e;
      (i.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
        r({
          autoplay: {
            enabled: !1,
            delay: 3e3,
            waitForTransition: !0,
            disableOnInteraction: !1,
            stopOnLastSlide: !1,
            reverseDirection: !1,
            pauseOnMouseEnter: !1,
          },
        });
      let d,
        c,
        p,
        u,
        m,
        f,
        h,
        v,
        g = l && l.autoplay ? l.autoplay.delay : 3e3,
        w = l && l.autoplay ? l.autoplay.delay : 3e3,
        y = new Date().getTime();
      function b(e) {
        i &&
          !i.destroyed &&
          i.wrapperEl &&
          e.target === i.wrapperEl &&
          (i.wrapperEl.removeEventListener("transitionend", b),
          v || (e.detail && e.detail.bySwiperTouchMove) || C());
      }
      const E = () => {
          if (i.destroyed || !i.autoplay.running) return;
          i.autoplay.paused ? (c = !0) : c && ((w = d), (c = !1));
          const e = i.autoplay.paused ? d : y + w - new Date().getTime();
          (i.autoplay.timeLeft = e),
            o("autoplayTimeLeft", e, e / g),
            (s = requestAnimationFrame(() => {
              E();
            }));
        },
        x = (e) => {
          if (i.destroyed || !i.autoplay.running) return;
          cancelAnimationFrame(s), E();
          let r = void 0 === e ? i.params.autoplay.delay : e;
          (g = i.params.autoplay.delay), (w = i.params.autoplay.delay);
          const a = (() => {
            let e;
            if (
              ((e =
                i.virtual && i.params.virtual.enabled
                  ? i.slides.filter((e) =>
                      e.classList.contains("swiper-slide-active")
                    )[0]
                  : i.slides[i.activeIndex]),
              !e)
            )
              return;
            return parseInt(e.getAttribute("data-swiper-autoplay"), 10);
          })();
          !Number.isNaN(a) &&
            a > 0 &&
            void 0 === e &&
            ((r = a), (g = a), (w = a)),
            (d = r);
          const n = i.params.speed,
            l = () => {
              i &&
                !i.destroyed &&
                (i.params.autoplay.reverseDirection
                  ? !i.isBeginning || i.params.loop || i.params.rewind
                    ? (i.slidePrev(n, !0, !0), o("autoplay"))
                    : i.params.autoplay.stopOnLastSlide ||
                      (i.slideTo(i.slides.length - 1, n, !0, !0), o("autoplay"))
                  : !i.isEnd || i.params.loop || i.params.rewind
                  ? (i.slideNext(n, !0, !0), o("autoplay"))
                  : i.params.autoplay.stopOnLastSlide ||
                    (i.slideTo(0, n, !0, !0), o("autoplay")),
                i.params.cssMode &&
                  ((y = new Date().getTime()),
                  requestAnimationFrame(() => {
                    x();
                  })));
            };
          return (
            r > 0
              ? (clearTimeout(t),
                (t = setTimeout(() => {
                  l();
                }, r)))
              : requestAnimationFrame(() => {
                  l();
                }),
            r
          );
        },
        S = () => {
          (y = new Date().getTime()),
            (i.autoplay.running = !0),
            x(),
            o("autoplayStart");
        },
        T = () => {
          (i.autoplay.running = !1),
            clearTimeout(t),
            cancelAnimationFrame(s),
            o("autoplayStop");
        },
        M = (e, s) => {
          if (i.destroyed || !i.autoplay.running) return;
          clearTimeout(t), e || (h = !0);
          const r = () => {
            o("autoplayPause"),
              i.params.autoplay.waitForTransition
                ? i.wrapperEl.addEventListener("transitionend", b)
                : C();
          };
          if (((i.autoplay.paused = !0), s))
            return f && (d = i.params.autoplay.delay), (f = !1), void r();
          const a = d || i.params.autoplay.delay;
          (d = a - (new Date().getTime() - y)),
            (i.isEnd && d < 0 && !i.params.loop) || (d < 0 && (d = 0), r());
        },
        C = () => {
          (i.isEnd && d < 0 && !i.params.loop) ||
            i.destroyed ||
            !i.autoplay.running ||
            ((y = new Date().getTime()),
            h ? ((h = !1), x(d)) : x(),
            (i.autoplay.paused = !1),
            o("autoplayResume"));
        },
        L = () => {
          if (i.destroyed || !i.autoplay.running) return;
          const e = n();
          "hidden" === e.visibilityState && ((h = !0), M(!0)),
            "visible" === e.visibilityState && C();
        },
        P = (e) => {
          "mouse" === e.pointerType &&
            ((h = !0), (v = !0), i.animating || i.autoplay.paused || M(!0));
        },
        k = (e) => {
          "mouse" === e.pointerType && ((v = !1), i.autoplay.paused && C());
        };
      a("init", () => {
        i.params.autoplay.enabled &&
          (i.params.autoplay.pauseOnMouseEnter &&
            (i.el.addEventListener("pointerenter", P),
            i.el.addEventListener("pointerleave", k)),
          n().addEventListener("visibilitychange", L),
          S());
      }),
        a("destroy", () => {
          i.el &&
            "string" != typeof i.el &&
            (i.el.removeEventListener("pointerenter", P),
            i.el.removeEventListener("pointerleave", k)),
            n().removeEventListener("visibilitychange", L),
            i.autoplay.running && T();
        }),
        a("_freeModeStaticRelease", () => {
          (u || h) && C();
        }),
        a("_freeModeNoMomentumRelease", () => {
          i.params.autoplay.disableOnInteraction ? T() : M(!0, !0);
        }),
        a("beforeTransitionStart", (e, t, s) => {
          !i.destroyed &&
            i.autoplay.running &&
            (s || !i.params.autoplay.disableOnInteraction ? M(!0, !0) : T());
        }),
        a("sliderFirstMove", () => {
          !i.destroyed &&
            i.autoplay.running &&
            (i.params.autoplay.disableOnInteraction
              ? T()
              : ((p = !0),
                (u = !1),
                (h = !1),
                (m = setTimeout(() => {
                  (h = !0), (u = !0), M(!0);
                }, 200))));
        }),
        a("touchEnd", () => {
          if (!i.destroyed && i.autoplay.running && p) {
            if (
              (clearTimeout(m),
              clearTimeout(t),
              i.params.autoplay.disableOnInteraction)
            )
              return (u = !1), void (p = !1);
            u && i.params.cssMode && C(), (u = !1), (p = !1);
          }
        }),
        a("slideChange", () => {
          !i.destroyed && i.autoplay.running && (f = !0);
        }),
        Object.assign(i.autoplay, { start: S, stop: T, pause: M, resume: C });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({
        thumbs: {
          swiper: null,
          multipleActiveThumbs: !0,
          autoScrollOffset: 0,
          slideThumbActiveClass: "swiper-slide-thumb-active",
          thumbsContainerClass: "swiper-thumbs",
        },
      });
      let r = !1,
        a = !1;
      function o() {
        const e = t.thumbs.swiper;
        if (!e || e.destroyed) return;
        const s = e.clickedIndex,
          i = e.clickedSlide;
        if (i && i.classList.contains(t.params.thumbs.slideThumbActiveClass))
          return;
        if (null == s) return;
        let r;
        (r = e.params.loop
          ? parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10)
          : s),
          t.params.loop ? t.slideToLoop(r) : t.slideTo(r);
      }
      function l() {
        const { thumbs: e } = t.params;
        if (r) return !1;
        r = !0;
        const s = t.constructor;
        if (e.swiper instanceof s)
          (t.thumbs.swiper = e.swiper),
            Object.assign(t.thumbs.swiper.originalParams, {
              watchSlidesProgress: !0,
              slideToClickedSlide: !1,
            }),
            Object.assign(t.thumbs.swiper.params, {
              watchSlidesProgress: !0,
              slideToClickedSlide: !1,
            }),
            t.thumbs.swiper.update();
        else if (m(e.swiper)) {
          const i = Object.assign({}, e.swiper);
          Object.assign(i, {
            watchSlidesProgress: !0,
            slideToClickedSlide: !1,
          }),
            (t.thumbs.swiper = new s(i)),
            (a = !0);
        }
        return (
          t.thumbs.swiper.el.classList.add(
            t.params.thumbs.thumbsContainerClass
          ),
          t.thumbs.swiper.on("tap", o),
          !0
        );
      }
      function d(e) {
        const s = t.thumbs.swiper;
        if (!s || s.destroyed) return;
        const i =
          "auto" === s.params.slidesPerView
            ? s.slidesPerViewDynamic()
            : s.params.slidesPerView;
        let r = 1;
        const a = t.params.thumbs.slideThumbActiveClass;
        if (
          (t.params.slidesPerView > 1 &&
            !t.params.centeredSlides &&
            (r = t.params.slidesPerView),
          t.params.thumbs.multipleActiveThumbs || (r = 1),
          (r = Math.floor(r)),
          s.slides.forEach((e) => e.classList.remove(a)),
          s.params.loop || (s.params.virtual && s.params.virtual.enabled))
        )
          for (let e = 0; e < r; e += 1)
            w(
              s.slidesEl,
              `[data-swiper-slide-index="${t.realIndex + e}"]`
            ).forEach((e) => {
              e.classList.add(a);
            });
        else
          for (let e = 0; e < r; e += 1)
            s.slides[t.realIndex + e] &&
              s.slides[t.realIndex + e].classList.add(a);
        const n = t.params.thumbs.autoScrollOffset,
          o = n && !s.params.loop;
        if (t.realIndex !== s.realIndex || o) {
          const r = s.activeIndex;
          let a, l;
          if (s.params.loop) {
            const e = s.slides.filter(
              (e) =>
                e.getAttribute("data-swiper-slide-index") === `${t.realIndex}`
            )[0];
            (a = s.slides.indexOf(e)),
              (l = t.activeIndex > t.previousIndex ? "next" : "prev");
          } else (a = t.realIndex), (l = a > t.previousIndex ? "next" : "prev");
          o && (a += "next" === l ? n : -1 * n),
            s.visibleSlidesIndexes &&
              s.visibleSlidesIndexes.indexOf(a) < 0 &&
              (s.params.centeredSlides
                ? (a =
                    a > r
                      ? a - Math.floor(i / 2) + 1
                      : a + Math.floor(i / 2) - 1)
                : a > r && s.params.slidesPerGroup,
              s.slideTo(a, e ? 0 : void 0));
        }
      }
      (t.thumbs = { swiper: null }),
        i("beforeInit", () => {
          const { thumbs: e } = t.params;
          if (e && e.swiper)
            if (
              "string" == typeof e.swiper ||
              e.swiper instanceof HTMLElement
            ) {
              const s = n(),
                i = () => {
                  const i =
                    "string" == typeof e.swiper
                      ? s.querySelector(e.swiper)
                      : e.swiper;
                  if (i && i.swiper) (e.swiper = i.swiper), l(), d(!0);
                  else if (i) {
                    const s = `${t.params.eventsPrefix}init`,
                      r = (a) => {
                        (e.swiper = a.detail[0]),
                          i.removeEventListener(s, r),
                          l(),
                          d(!0),
                          e.swiper.update(),
                          t.update();
                      };
                    i.addEventListener(s, r);
                  }
                  return i;
                },
                r = () => {
                  if (t.destroyed) return;
                  i() || requestAnimationFrame(r);
                };
              requestAnimationFrame(r);
            } else l(), d(!0);
        }),
        i("slideChange update resize observerUpdate", () => {
          d();
        }),
        i("setTransition", (e, s) => {
          const i = t.thumbs.swiper;
          i && !i.destroyed && i.setTransition(s);
        }),
        i("beforeDestroy", () => {
          const e = t.thumbs.swiper;
          e && !e.destroyed && a && e.destroy();
        }),
        Object.assign(t.thumbs, { init: l, update: d });
    },
    function (e) {
      let { swiper: t, extendParams: s, emit: i, once: r } = e;
      s({
        freeMode: {
          enabled: !1,
          momentum: !0,
          momentumRatio: 1,
          momentumBounce: !0,
          momentumBounceRatio: 1,
          momentumVelocityRatio: 1,
          sticky: !1,
          minimumVelocity: 0.02,
        },
      }),
        Object.assign(t, {
          freeMode: {
            onTouchStart: function () {
              if (t.params.cssMode) return;
              const e = t.getTranslate();
              t.setTranslate(e),
                t.setTransition(0),
                (t.touchEventsData.velocities.length = 0),
                t.freeMode.onTouchEnd({
                  currentPos: t.rtl ? t.translate : -t.translate,
                });
            },
            onTouchMove: function () {
              if (t.params.cssMode) return;
              const { touchEventsData: e, touches: s } = t;
              0 === e.velocities.length &&
                e.velocities.push({
                  position: s[t.isHorizontal() ? "startX" : "startY"],
                  time: e.touchStartTime,
                }),
                e.velocities.push({
                  position: s[t.isHorizontal() ? "currentX" : "currentY"],
                  time: p(),
                });
            },
            onTouchEnd: function (e) {
              let { currentPos: s } = e;
              if (t.params.cssMode) return;
              const {
                  params: a,
                  wrapperEl: n,
                  rtlTranslate: o,
                  snapGrid: l,
                  touchEventsData: d,
                } = t,
                c = p() - d.touchStartTime;
              if (s < -t.minTranslate()) t.slideTo(t.activeIndex);
              else if (s > -t.maxTranslate())
                t.slides.length < l.length
                  ? t.slideTo(l.length - 1)
                  : t.slideTo(t.slides.length - 1);
              else {
                if (a.freeMode.momentum) {
                  if (d.velocities.length > 1) {
                    const e = d.velocities.pop(),
                      s = d.velocities.pop(),
                      i = e.position - s.position,
                      r = e.time - s.time;
                    (t.velocity = i / r),
                      (t.velocity /= 2),
                      Math.abs(t.velocity) < a.freeMode.minimumVelocity &&
                        (t.velocity = 0),
                      (r > 150 || p() - e.time > 300) && (t.velocity = 0);
                  } else t.velocity = 0;
                  (t.velocity *= a.freeMode.momentumVelocityRatio),
                    (d.velocities.length = 0);
                  let e = 1e3 * a.freeMode.momentumRatio;
                  const s = t.velocity * e;
                  let c = t.translate + s;
                  o && (c = -c);
                  let u,
                    m = !1;
                  const f =
                    20 * Math.abs(t.velocity) * a.freeMode.momentumBounceRatio;
                  let h;
                  if (c < t.maxTranslate())
                    a.freeMode.momentumBounce
                      ? (c + t.maxTranslate() < -f &&
                          (c = t.maxTranslate() - f),
                        (u = t.maxTranslate()),
                        (m = !0),
                        (d.allowMomentumBounce = !0))
                      : (c = t.maxTranslate()),
                      a.loop && a.centeredSlides && (h = !0);
                  else if (c > t.minTranslate())
                    a.freeMode.momentumBounce
                      ? (c - t.minTranslate() > f && (c = t.minTranslate() + f),
                        (u = t.minTranslate()),
                        (m = !0),
                        (d.allowMomentumBounce = !0))
                      : (c = t.minTranslate()),
                      a.loop && a.centeredSlides && (h = !0);
                  else if (a.freeMode.sticky) {
                    let e;
                    for (let t = 0; t < l.length; t += 1)
                      if (l[t] > -c) {
                        e = t;
                        break;
                      }
                    (c =
                      Math.abs(l[e] - c) < Math.abs(l[e - 1] - c) ||
                      "next" === t.swipeDirection
                        ? l[e]
                        : l[e - 1]),
                      (c = -c);
                  }
                  if (
                    (h &&
                      r("transitionEnd", () => {
                        t.loopFix();
                      }),
                    0 !== t.velocity)
                  ) {
                    if (
                      ((e = o
                        ? Math.abs((-c - t.translate) / t.velocity)
                        : Math.abs((c - t.translate) / t.velocity)),
                      a.freeMode.sticky)
                    ) {
                      const s = Math.abs((o ? -c : c) - t.translate),
                        i = t.slidesSizesGrid[t.activeIndex];
                      e =
                        s < i
                          ? a.speed
                          : s < 2 * i
                          ? 1.5 * a.speed
                          : 2.5 * a.speed;
                    }
                  } else if (a.freeMode.sticky) return void t.slideToClosest();
                  a.freeMode.momentumBounce && m
                    ? (t.updateProgress(u),
                      t.setTransition(e),
                      t.setTranslate(c),
                      t.transitionStart(!0, t.swipeDirection),
                      (t.animating = !0),
                      M(n, () => {
                        t &&
                          !t.destroyed &&
                          d.allowMomentumBounce &&
                          (i("momentumBounce"),
                          t.setTransition(a.speed),
                          setTimeout(() => {
                            t.setTranslate(u),
                              M(n, () => {
                                t && !t.destroyed && t.transitionEnd();
                              });
                          }, 0));
                      }))
                    : t.velocity
                    ? (i("_freeModeNoMomentumRelease"),
                      t.updateProgress(c),
                      t.setTransition(e),
                      t.setTranslate(c),
                      t.transitionStart(!0, t.swipeDirection),
                      t.animating ||
                        ((t.animating = !0),
                        M(n, () => {
                          t && !t.destroyed && t.transitionEnd();
                        })))
                    : t.updateProgress(c),
                    t.updateActiveIndex(),
                    t.updateSlidesClasses();
                } else {
                  if (a.freeMode.sticky) return void t.slideToClosest();
                  a.freeMode && i("_freeModeNoMomentumRelease");
                }
                (!a.freeMode.momentum || c >= a.longSwipesMs) &&
                  (i("_freeModeStaticRelease"),
                  t.updateProgress(),
                  t.updateActiveIndex(),
                  t.updateSlidesClasses());
              }
            },
          },
        });
    },
    function (e) {
      let t,
        s,
        i,
        r,
        { swiper: a, extendParams: n, on: o } = e;
      n({ grid: { rows: 1, fill: "column" } });
      const l = () => {
        let e = a.params.spaceBetween;
        return (
          "string" == typeof e && e.indexOf("%") >= 0
            ? (e = (parseFloat(e.replace("%", "")) / 100) * a.size)
            : "string" == typeof e && (e = parseFloat(e)),
          e
        );
      };
      o("init", () => {
        r = a.params.grid && a.params.grid.rows > 1;
      }),
        o("update", () => {
          const { params: e, el: t } = a,
            s = e.grid && e.grid.rows > 1;
          r && !s
            ? (t.classList.remove(
                `${e.containerModifierClass}grid`,
                `${e.containerModifierClass}grid-column`
              ),
              (i = 1),
              a.emitContainerClasses())
            : !r &&
              s &&
              (t.classList.add(`${e.containerModifierClass}grid`),
              "column" === e.grid.fill &&
                t.classList.add(`${e.containerModifierClass}grid-column`),
              a.emitContainerClasses()),
            (r = s);
        }),
        (a.grid = {
          initSlides: (e) => {
            const { slidesPerView: r } = a.params,
              { rows: n, fill: o } = a.params.grid,
              l =
                a.virtual && a.params.virtual.enabled
                  ? a.virtual.slides.length
                  : e.length;
            (i = Math.floor(l / n)),
              (t = Math.floor(l / n) === l / n ? l : Math.ceil(l / n) * n),
              "auto" !== r && "row" === o && (t = Math.max(t, r * n)),
              (s = t / n);
          },
          unsetSlides: () => {
            a.slides &&
              a.slides.forEach((e) => {
                e.swiperSlideGridSet &&
                  ((e.style.height = ""),
                  (e.style[a.getDirectionLabel("margin-top")] = ""));
              });
          },
          updateSlide: (e, r, n) => {
            const { slidesPerGroup: o } = a.params,
              d = l(),
              { rows: c, fill: p } = a.params.grid,
              u =
                a.virtual && a.params.virtual.enabled
                  ? a.virtual.slides.length
                  : n.length;
            let m, f, h;
            if ("row" === p && o > 1) {
              const s = Math.floor(e / (o * c)),
                i = e - c * o * s,
                a = 0 === s ? o : Math.min(Math.ceil((u - s * c * o) / c), o);
              (h = Math.floor(i / a)),
                (f = i - h * a + s * o),
                (m = f + (h * t) / c),
                (r.style.order = m);
            } else
              "column" === p
                ? ((f = Math.floor(e / c)),
                  (h = e - f * c),
                  (f > i || (f === i && h === c - 1)) &&
                    ((h += 1), h >= c && ((h = 0), (f += 1))))
                : ((h = Math.floor(e / s)), (f = e - h * s));
            (r.row = h),
              (r.column = f),
              (r.style.height = `calc((100% - ${(c - 1) * d}px) / ${c})`),
              (r.style[a.getDirectionLabel("margin-top")] =
                0 !== h ? d && `${d}px` : ""),
              (r.swiperSlideGridSet = !0);
          },
          updateWrapperSize: (e, s) => {
            const { centeredSlides: i, roundLengths: r } = a.params,
              n = l(),
              { rows: o } = a.params.grid;
            if (
              ((a.virtualSize = (e + n) * t),
              (a.virtualSize = Math.ceil(a.virtualSize / o) - n),
              a.params.cssMode ||
                (a.wrapperEl.style[a.getDirectionLabel("width")] = `${
                  a.virtualSize + n
                }px`),
              i)
            ) {
              const e = [];
              for (let t = 0; t < s.length; t += 1) {
                let i = s[t];
                r && (i = Math.floor(i)),
                  s[t] < a.virtualSize + s[0] && e.push(i);
              }
              s.splice(0, s.length), s.push(...e);
            }
          },
        });
    },
    function (e) {
      let { swiper: t } = e;
      Object.assign(t, {
        appendSlide: pe.bind(t),
        prependSlide: ue.bind(t),
        addSlide: me.bind(t),
        removeSlide: fe.bind(t),
        removeAllSlides: he.bind(t),
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({ fadeEffect: { crossFade: !1 } }),
        ve({
          effect: "fade",
          swiper: t,
          on: i,
          setTranslate: () => {
            const { slides: e } = t;
            t.params.fadeEffect;
            for (let s = 0; s < e.length; s += 1) {
              const e = t.slides[s];
              let i = -e.swiperSlideOffset;
              t.params.virtualTranslate || (i -= t.translate);
              let r = 0;
              t.isHorizontal() || ((r = i), (i = 0));
              const a = t.params.fadeEffect.crossFade
                  ? Math.max(1 - Math.abs(e.progress), 0)
                  : 1 + Math.min(Math.max(e.progress, -1), 0),
                n = ge(0, e);
              (n.style.opacity = a),
                (n.style.transform = `translate3d(${i}px, ${r}px, 0px)`);
            }
          },
          setTransition: (e) => {
            const s = t.slides.map((e) => g(e));
            s.forEach((t) => {
              t.style.transitionDuration = `${e}ms`;
            }),
              we({
                swiper: t,
                duration: e,
                transformElements: s,
                allSlides: !0,
              });
          },
          overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            spaceBetween: 0,
            virtualTranslate: !t.params.cssMode,
          }),
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({
        cubeEffect: {
          slideShadows: !0,
          shadow: !0,
          shadowOffset: 20,
          shadowScale: 0.94,
        },
      });
      const r = (e, t, s) => {
        let i = s
            ? e.querySelector(".swiper-slide-shadow-left")
            : e.querySelector(".swiper-slide-shadow-top"),
          r = s
            ? e.querySelector(".swiper-slide-shadow-right")
            : e.querySelector(".swiper-slide-shadow-bottom");
        i ||
          ((i = b(
            "div",
            (
              "swiper-slide-shadow-cube swiper-slide-shadow-" +
              (s ? "left" : "top")
            ).split(" ")
          )),
          e.append(i)),
          r ||
            ((r = b(
              "div",
              (
                "swiper-slide-shadow-cube swiper-slide-shadow-" +
                (s ? "right" : "bottom")
              ).split(" ")
            )),
            e.append(r)),
          i && (i.style.opacity = Math.max(-t, 0)),
          r && (r.style.opacity = Math.max(t, 0));
      };
      ve({
        effect: "cube",
        swiper: t,
        on: i,
        setTranslate: () => {
          const {
              el: e,
              wrapperEl: s,
              slides: i,
              width: a,
              height: n,
              rtlTranslate: o,
              size: l,
              browser: d,
            } = t,
            c = P(t),
            p = t.params.cubeEffect,
            u = t.isHorizontal(),
            m = t.virtual && t.params.virtual.enabled;
          let f,
            h = 0;
          p.shadow &&
            (u
              ? ((f = t.wrapperEl.querySelector(".swiper-cube-shadow")),
                f ||
                  ((f = b("div", "swiper-cube-shadow")), t.wrapperEl.append(f)),
                (f.style.height = `${a}px`))
              : ((f = e.querySelector(".swiper-cube-shadow")),
                f || ((f = b("div", "swiper-cube-shadow")), e.append(f))));
          for (let e = 0; e < i.length; e += 1) {
            const t = i[e];
            let s = e;
            m && (s = parseInt(t.getAttribute("data-swiper-slide-index"), 10));
            let a = 90 * s,
              n = Math.floor(a / 360);
            o && ((a = -a), (n = Math.floor(-a / 360)));
            const d = Math.max(Math.min(t.progress, 1), -1);
            let f = 0,
              v = 0,
              g = 0;
            s % 4 == 0
              ? ((f = 4 * -n * l), (g = 0))
              : (s - 1) % 4 == 0
              ? ((f = 0), (g = 4 * -n * l))
              : (s - 2) % 4 == 0
              ? ((f = l + 4 * n * l), (g = l))
              : (s - 3) % 4 == 0 && ((f = -l), (g = 3 * l + 4 * l * n)),
              o && (f = -f),
              u || ((v = f), (f = 0));
            const w = `rotateX(${c(u ? 0 : -a)}deg) rotateY(${c(
              u ? a : 0
            )}deg) translate3d(${f}px, ${v}px, ${g}px)`;
            d <= 1 &&
              d > -1 &&
              ((h = 90 * s + 90 * d), o && (h = 90 * -s - 90 * d)),
              (t.style.transform = w),
              p.slideShadows && r(t, d, u);
          }
          if (
            ((s.style.transformOrigin = `50% 50% -${l / 2}px`),
            (s.style["-webkit-transform-origin"] = `50% 50% -${l / 2}px`),
            p.shadow)
          )
            if (u)
              f.style.transform = `translate3d(0px, ${
                a / 2 + p.shadowOffset
              }px, ${-a / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${
                p.shadowScale
              })`;
            else {
              const e = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
                t =
                  1.5 -
                  (Math.sin((2 * e * Math.PI) / 360) / 2 +
                    Math.cos((2 * e * Math.PI) / 360) / 2),
                s = p.shadowScale,
                i = p.shadowScale / t,
                r = p.shadowOffset;
              f.style.transform = `scale3d(${s}, 1, ${i}) translate3d(0px, ${
                n / 2 + r
              }px, ${-n / 2 / i}px) rotateX(-89.99deg)`;
            }
          const v =
            (d.isSafari || d.isWebView) && d.needPerspectiveFix ? -l / 2 : 0;
          (s.style.transform = `translate3d(0px,0,${v}px) rotateX(${c(
            t.isHorizontal() ? 0 : h
          )}deg) rotateY(${c(t.isHorizontal() ? -h : 0)}deg)`),
            s.style.setProperty("--swiper-cube-translate-z", `${v}px`);
        },
        setTransition: (e) => {
          const { el: s, slides: i } = t;
          if (
            (i.forEach((t) => {
              (t.style.transitionDuration = `${e}ms`),
                t
                  .querySelectorAll(
                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                  )
                  .forEach((t) => {
                    t.style.transitionDuration = `${e}ms`;
                  });
            }),
            t.params.cubeEffect.shadow && !t.isHorizontal())
          ) {
            const t = s.querySelector(".swiper-cube-shadow");
            t && (t.style.transitionDuration = `${e}ms`);
          }
        },
        recreateShadows: () => {
          const e = t.isHorizontal();
          t.slides.forEach((t) => {
            const s = Math.max(Math.min(t.progress, 1), -1);
            r(t, s, e);
          });
        },
        getEffectParams: () => t.params.cubeEffect,
        perspective: () => !0,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: !1,
          virtualTranslate: !0,
        }),
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({ flipEffect: { slideShadows: !0, limitRotation: !0 } });
      const r = (e, s) => {
        let i = t.isHorizontal()
            ? e.querySelector(".swiper-slide-shadow-left")
            : e.querySelector(".swiper-slide-shadow-top"),
          r = t.isHorizontal()
            ? e.querySelector(".swiper-slide-shadow-right")
            : e.querySelector(".swiper-slide-shadow-bottom");
        i || (i = ye("flip", e, t.isHorizontal() ? "left" : "top")),
          r || (r = ye("flip", e, t.isHorizontal() ? "right" : "bottom")),
          i && (i.style.opacity = Math.max(-s, 0)),
          r && (r.style.opacity = Math.max(s, 0));
      };
      ve({
        effect: "flip",
        swiper: t,
        on: i,
        setTranslate: () => {
          const { slides: e, rtlTranslate: s } = t,
            i = t.params.flipEffect,
            a = P(t);
          for (let n = 0; n < e.length; n += 1) {
            const o = e[n];
            let l = o.progress;
            t.params.flipEffect.limitRotation &&
              (l = Math.max(Math.min(o.progress, 1), -1));
            const d = o.swiperSlideOffset;
            let c = -180 * l,
              p = 0,
              u = t.params.cssMode ? -d - t.translate : -d,
              m = 0;
            t.isHorizontal()
              ? s && (c = -c)
              : ((m = u), (u = 0), (p = -c), (c = 0)),
              (o.style.zIndex = -Math.abs(Math.round(l)) + e.length),
              i.slideShadows && r(o, l);
            const f = `translate3d(${u}px, ${m}px, 0px) rotateX(${a(
              p
            )}deg) rotateY(${a(c)}deg)`;
            ge(0, o).style.transform = f;
          }
        },
        setTransition: (e) => {
          const s = t.slides.map((e) => g(e));
          s.forEach((t) => {
            (t.style.transitionDuration = `${e}ms`),
              t
                .querySelectorAll(
                  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                )
                .forEach((t) => {
                  t.style.transitionDuration = `${e}ms`;
                });
          }),
            we({ swiper: t, duration: e, transformElements: s });
        },
        recreateShadows: () => {
          t.params.flipEffect,
            t.slides.forEach((e) => {
              let s = e.progress;
              t.params.flipEffect.limitRotation &&
                (s = Math.max(Math.min(e.progress, 1), -1)),
                r(e, s);
            });
        },
        getEffectParams: () => t.params.flipEffect,
        perspective: () => !0,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: !0,
          spaceBetween: 0,
          virtualTranslate: !t.params.cssMode,
        }),
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          scale: 1,
          modifier: 1,
          slideShadows: !0,
        },
      }),
        ve({
          effect: "coverflow",
          swiper: t,
          on: i,
          setTranslate: () => {
            const { width: e, height: s, slides: i, slidesSizesGrid: r } = t,
              a = t.params.coverflowEffect,
              n = t.isHorizontal(),
              o = t.translate,
              l = n ? e / 2 - o : s / 2 - o,
              d = n ? a.rotate : -a.rotate,
              c = a.depth,
              p = P(t);
            for (let e = 0, t = i.length; e < t; e += 1) {
              const t = i[e],
                s = r[e],
                o = (l - t.swiperSlideOffset - s / 2) / s,
                u =
                  "function" == typeof a.modifier
                    ? a.modifier(o)
                    : o * a.modifier;
              let m = n ? d * u : 0,
                f = n ? 0 : d * u,
                h = -c * Math.abs(u),
                v = a.stretch;
              "string" == typeof v &&
                -1 !== v.indexOf("%") &&
                (v = (parseFloat(a.stretch) / 100) * s);
              let g = n ? 0 : v * u,
                w = n ? v * u : 0,
                y = 1 - (1 - a.scale) * Math.abs(u);
              Math.abs(w) < 0.001 && (w = 0),
                Math.abs(g) < 0.001 && (g = 0),
                Math.abs(h) < 0.001 && (h = 0),
                Math.abs(m) < 0.001 && (m = 0),
                Math.abs(f) < 0.001 && (f = 0),
                Math.abs(y) < 0.001 && (y = 0);
              const b = `translate3d(${w}px,${g}px,${h}px)  rotateX(${p(
                f
              )}deg) rotateY(${p(m)}deg) scale(${y})`;
              if (
                ((ge(0, t).style.transform = b),
                (t.style.zIndex = 1 - Math.abs(Math.round(u))),
                a.slideShadows)
              ) {
                let e = n
                    ? t.querySelector(".swiper-slide-shadow-left")
                    : t.querySelector(".swiper-slide-shadow-top"),
                  s = n
                    ? t.querySelector(".swiper-slide-shadow-right")
                    : t.querySelector(".swiper-slide-shadow-bottom");
                e || (e = ye("coverflow", t, n ? "left" : "top")),
                  s || (s = ye("coverflow", t, n ? "right" : "bottom")),
                  e && (e.style.opacity = u > 0 ? u : 0),
                  s && (s.style.opacity = -u > 0 ? -u : 0);
              }
            }
          },
          setTransition: (e) => {
            t.slides
              .map((e) => g(e))
              .forEach((t) => {
                (t.style.transitionDuration = `${e}ms`),
                  t
                    .querySelectorAll(
                      ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                    )
                    .forEach((t) => {
                      t.style.transitionDuration = `${e}ms`;
                    });
              });
          },
          perspective: () => !0,
          overwriteParams: () => ({ watchSlidesProgress: !0 }),
        });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({
        creativeEffect: {
          limitProgress: 1,
          shadowPerProgress: !1,
          progressMultiplier: 1,
          perspective: !0,
          prev: {
            translate: [0, 0, 0],
            rotate: [0, 0, 0],
            opacity: 1,
            scale: 1,
          },
          next: {
            translate: [0, 0, 0],
            rotate: [0, 0, 0],
            opacity: 1,
            scale: 1,
          },
        },
      });
      const r = (e) => ("string" == typeof e ? e : `${e}px`);
      ve({
        effect: "creative",
        swiper: t,
        on: i,
        setTranslate: () => {
          const { slides: e, wrapperEl: s, slidesSizesGrid: i } = t,
            a = t.params.creativeEffect,
            { progressMultiplier: n } = a,
            o = t.params.centeredSlides,
            l = P(t);
          if (o) {
            const e = i[0] / 2 - t.params.slidesOffsetBefore || 0;
            s.style.transform = `translateX(calc(50% - ${e}px))`;
          }
          for (let s = 0; s < e.length; s += 1) {
            const i = e[s],
              d = i.progress,
              c = Math.min(
                Math.max(i.progress, -a.limitProgress),
                a.limitProgress
              );
            let p = c;
            o ||
              (p = Math.min(
                Math.max(i.originalProgress, -a.limitProgress),
                a.limitProgress
              ));
            const u = i.swiperSlideOffset,
              m = [t.params.cssMode ? -u - t.translate : -u, 0, 0],
              f = [0, 0, 0];
            let h = !1;
            t.isHorizontal() || ((m[1] = m[0]), (m[0] = 0));
            let v = {
              translate: [0, 0, 0],
              rotate: [0, 0, 0],
              scale: 1,
              opacity: 1,
            };
            c < 0
              ? ((v = a.next), (h = !0))
              : c > 0 && ((v = a.prev), (h = !0)),
              m.forEach((e, t) => {
                m[t] = `calc(${e}px + (${r(v.translate[t])} * ${Math.abs(
                  c * n
                )}))`;
              }),
              f.forEach((e, t) => {
                let s = v.rotate[t] * Math.abs(c * n);
                f[t] = s;
              }),
              (i.style.zIndex = -Math.abs(Math.round(d)) + e.length);
            const g = m.join(", "),
              w = `rotateX(${l(f[0])}deg) rotateY(${l(f[1])}deg) rotateZ(${l(
                f[2]
              )}deg)`,
              y =
                p < 0
                  ? `scale(${1 + (1 - v.scale) * p * n})`
                  : `scale(${1 - (1 - v.scale) * p * n})`,
              b =
                p < 0
                  ? 1 + (1 - v.opacity) * p * n
                  : 1 - (1 - v.opacity) * p * n,
              E = `translate3d(${g}) ${w} ${y}`;
            if ((h && v.shadow) || !h) {
              let e = i.querySelector(".swiper-slide-shadow");
              if ((!e && v.shadow && (e = ye("creative", i)), e)) {
                const t = a.shadowPerProgress ? c * (1 / a.limitProgress) : c;
                e.style.opacity = Math.min(Math.max(Math.abs(t), 0), 1);
              }
            }
            const x = ge(0, i);
            (x.style.transform = E),
              (x.style.opacity = b),
              v.origin && (x.style.transformOrigin = v.origin);
          }
        },
        setTransition: (e) => {
          const s = t.slides.map((e) => g(e));
          s.forEach((t) => {
            (t.style.transitionDuration = `${e}ms`),
              t.querySelectorAll(".swiper-slide-shadow").forEach((t) => {
                t.style.transitionDuration = `${e}ms`;
              });
          }),
            we({ swiper: t, duration: e, transformElements: s, allSlides: !0 });
        },
        perspective: () => t.params.creativeEffect.perspective,
        overwriteParams: () => ({
          watchSlidesProgress: !0,
          virtualTranslate: !t.params.cssMode,
        }),
      });
    },
    function (e) {
      let { swiper: t, extendParams: s, on: i } = e;
      s({
        cardsEffect: {
          slideShadows: !0,
          rotate: !0,
          perSlideRotate: 2,
          perSlideOffset: 8,
        },
      }),
        ve({
          effect: "cards",
          swiper: t,
          on: i,
          setTranslate: () => {
            const { slides: e, activeIndex: s, rtlTranslate: i } = t,
              r = t.params.cardsEffect,
              { startTranslate: a, isTouched: n } = t.touchEventsData,
              o = i ? -t.translate : t.translate;
            for (let l = 0; l < e.length; l += 1) {
              const d = e[l],
                c = d.progress,
                p = Math.min(Math.max(c, -4), 4);
              let u = d.swiperSlideOffset;
              t.params.centeredSlides &&
                !t.params.cssMode &&
                (t.wrapperEl.style.transform = `translateX(${t.minTranslate()}px)`),
                t.params.centeredSlides &&
                  t.params.cssMode &&
                  (u -= e[0].swiperSlideOffset);
              let m = t.params.cssMode ? -u - t.translate : -u,
                f = 0;
              const h = -100 * Math.abs(p);
              let v = 1,
                g = -r.perSlideRotate * p,
                w = r.perSlideOffset - 0.75 * Math.abs(p);
              const y =
                  t.virtual && t.params.virtual.enabled
                    ? t.virtual.from + l
                    : l,
                b =
                  (y === s || y === s - 1) &&
                  p > 0 &&
                  p < 1 &&
                  (n || t.params.cssMode) &&
                  o < a,
                E =
                  (y === s || y === s + 1) &&
                  p < 0 &&
                  p > -1 &&
                  (n || t.params.cssMode) &&
                  o > a;
              if (b || E) {
                const e = (1 - Math.abs((Math.abs(p) - 0.5) / 0.5)) ** 0.5;
                (g += -28 * p * e),
                  (v += -0.5 * e),
                  (w += 96 * e),
                  (f = -25 * e * Math.abs(p) + "%");
              }
              if (
                ((m =
                  p < 0
                    ? `calc(${m}px ${i ? "-" : "+"} (${w * Math.abs(p)}%))`
                    : p > 0
                    ? `calc(${m}px ${i ? "-" : "+"} (-${w * Math.abs(p)}%))`
                    : `${m}px`),
                !t.isHorizontal())
              ) {
                const e = f;
                (f = m), (m = e);
              }
              const x = p < 0 ? "" + (1 + (1 - v) * p) : "" + (1 - (1 - v) * p),
                S = `\n        translate3d(${m}, ${f}, ${h}px)\n        rotateZ(${
                  r.rotate ? (i ? -g : g) : 0
                }deg)\n        scale(${x})\n      `;
              if (r.slideShadows) {
                let e = d.querySelector(".swiper-slide-shadow");
                e || (e = ye("cards", d)),
                  e &&
                    (e.style.opacity = Math.min(
                      Math.max((Math.abs(p) - 0.5) / 0.5, 0),
                      1
                    ));
              }
              d.style.zIndex = -Math.abs(Math.round(c)) + e.length;
              ge(0, d).style.transform = S;
            }
          },
          setTransition: (e) => {
            const s = t.slides.map((e) => g(e));
            s.forEach((t) => {
              (t.style.transitionDuration = `${e}ms`),
                t.querySelectorAll(".swiper-slide-shadow").forEach((t) => {
                  t.style.transitionDuration = `${e}ms`;
                });
            }),
              we({ swiper: t, duration: e, transformElements: s });
          },
          perspective: () => !0,
          overwriteParams: () => ({
            watchSlidesProgress: !0,
            virtualTranslate: !t.params.cssMode,
          }),
        });
    },
  ];
  oe.use(be);
  var Ee = s(209),
    xe = s(37);
  function Se(e) {
    document
      .querySelectorAll(".swiper-slide-home .card-container-banner-home")
      .forEach(function (t) {
        var s = t.style.getPropertyValue("--background-image-mobile"),
          i = t.style.getPropertyValue("--background-image-desktop");
        t.style.backgroundImage = e ? i : s;
      });
  }
  function Te(e) {
    var t = [
      {
        name: "fontSize",
        desktop: "data-desktop-font-size",
        mobile: "data-mobile-font-size",
      },
      {
        name: "lineHeight",
        desktop: "data-desktop-line-height",
        mobile: "data-mobile-line-height",
      },
      {
        name: "paddingLeft",
        desktop: "data-desktop-padding-left",
        mobile: null,
      },
    ];
    document
      .querySelectorAll(
        ".card-information, .card-information-text--title, .card-information-text--subtitle"
      )
      .forEach(function (s) {
        t.forEach(function (t) {
          var i = e ? s.getAttribute(t.desktop) : s.getAttribute(t.mobile);
          i && (s.style[t.name] = i);
        });
      });
  }
  function Me() {
    if (document.querySelector(".swiper-product-homepage")) {
      var e,
        t = window.matchMedia("(min-width: 768px)").matches;
      (e = t),
        new oe(".".concat("swiper-product-homepage"), {
          effect: "fade",
          slidesPerView: 1,
          loop: !0,
          autoplay: { delay: 5e3 },
          fadeEffect: { crossFade: !0 },
          on: {
            slideChange: function () {
              Se(e), Te(e);
            },
          },
          pagination: { el: ".swiper-home-product-pagination" },
          navigation: {
            nextEl: ".swiper-home-product-button-next",
            prevEl: ".swiper-home-product-button-prev",
          },
        }),
        Se(t),
        Te(t),
        window.addEventListener("resize", function () {
          Se(t), Te(t);
        });
    }
  }
  function Ce(e) {
    return (
      (Ce =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            }),
      Ce(e)
    );
  }
  function Le(e, t, s) {
    return (
      (t = (function (e) {
        var t = (function (e, t) {
          if ("object" != Ce(e) || !e) return e;
          var s = e[Symbol.toPrimitive];
          if (void 0 !== s) {
            var i = s.call(e, t || "default");
            if ("object" != Ce(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        })(e, "string");
        return "symbol" == Ce(t) ? t : t + "";
      })(t)) in e
        ? Object.defineProperty(e, t, {
            value: s,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = s),
      e
    );
  }
  document.addEventListener("DOMContentLoaded", function () {
    new MutationObserver(function (e, t) {
      var s = document.querySelector(
        '.shopify-cleanslate ul li > div[data-testid="ShopifyPay-button"]'
      );
      s && ((s.parentElement.id = "shop-pay-button"), t.disconnect());
    }).observe(document.body, { childList: !0, subtree: !0 });
  });
  var Pe = document.querySelectorAll(".tabs-collections__collection");
  Pe.length &&
    Pe.forEach(function (e) {
      var t = e.querySelector(".tabs-collections_slider");
      new oe(t, {
        slidesPerView: 6,
        spaceBetween: 25,
        loop: !1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          320: {
            slidesPerView: "auto",
            spaceBetween: 10,
            mousewheel: { forceToAxis: !0, invert: !0 },
          },
          768: { slidesPerView: 3, spaceBetween: 25 },
          992: { slidesPerView: 4, spaceBetween: 25 },
          1200: { slidesPerView: 6 },
        },
      });
    }),
    document.addEventListener("DOMContentLoaded", function () {
      var e;
      !(function () {
        var e = window.innerWidth <= 768,
          t = document.querySelector(
            ".carousel-category-mobile-container--swiper"
          );
        if (t) {
          var s = t.querySelector(".carousel-container"),
            i = (s ? s.dataset : null).elementsCount;
          e &&
            i > 4 &&
            (new oe(t, {
              modules: [de],
              slidesPerView: "auto",
              spaceBetween: 12,
              mousewheel: { forceToAxis: !0 },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            }),
            t.querySelector(".carousel-container").classList.remove("gap"));
        }
      })(),
        (0, Ee.Z)(),
        (0, Ee.g)(),
        (0, xe.K5)(),
        window.innerWidth <= 768 &&
          window.addEventListener("scroll", function () {
            var e =
                window.scrollY ||
                document.documentElement.scrollTop ||
                document.body.scrollTop,
              t = document.querySelector(".section-header page-header");
            t &&
              (e > 0
                ? t.classList.add("navigation-scroll")
                : t.classList.remove("navigation-scroll"));
          }),
        (e = document.querySelector(".reviews-carousel__list")),
        new oe(e, {
          slidesPerView: 3,
          spaceBetween: 40,
          mousewheel: !0,
          loop: !0,
          pagination: { el: ".swiper-pagination", clickable: !0 },
          autoplay: { delay: 6e3 },
          breakpoints: {
            320: {
              slidesPerView: "auto",
              spaceBetween: 8,
              centeredSlides: !0,
              mousewheel: { forceToAxis: !0, invert: !0 },
            },
            768: { slidesPerView: 2, spaceBetween: 25, centeredSlides: !1 },
            992: { slidesPerView: 3, spaceBetween: 40, centeredSlides: !1 },
          },
        }),
        Me();
    }),
    document.addEventListener("DOMContentLoaded", function () {
      var e = document.querySelectorAll(".swiper-container-lp");
      document
        .querySelectorAll(".lp-athletes-items.swiper-container")
        .forEach(function (e) {
          new oe(e, {
            loop: !0,
            slidesPerView: 4,
            spaceBetween: 40,
            navigation: { nextEl: ".next", prevEl: ".prev" },
            breakpoints: {
              0: { slidesPerView: 1 },
              425: { slidesPerView: 2 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 4 },
            },
          });
        }),
        e.forEach(function (e) {
          var t = e.querySelectorAll(".swiper-slide").length;
          console.log("Los Productos son " + t),
            t > 3
              ? new oe(e, {
                  spaceBetween: 30,
                  loop: !0,
                  navigation: { nextEl: ".nextt", prevEl: ".prevv" },
                  breakpoints: {
                    767: {
                      slidesPerView: 1,
                      slidesPerGroup: 1,
                      spaceBetween: 0,
                    },
                    768: {
                      slidesPerView: 3,
                      slidesPerGroup: 1,
                      spaceBetween: 30,
                    },
                  },
                })
              : (e.classList.add("limited-items"),
                console.log(window.matchMedia("(max-width: 767px)").matches),
                window.matchMedia("(max-width: 767px)").matches &&
                  new oe(
                    e,
                    Le(
                      {
                        spaceBetween: 30,
                        loop: !0,
                        navigation: { nextEl: ".nextt", prevEl: ".prevv" },
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                      },
                      "spaceBetween",
                      0
                    )
                  ));
        });
    });
})();
//# sourceMappingURL=endrock.scripts.js.map
